(function() {
  'use strict';

  angular
    .module('portalProveedores', [
        'ngAnimate',
        'ngCookies',
        'ngTouch',
        'ngSanitize',
        'ngMessages',
        'ngAria',        
        'ui.router', //nested views        
        'toastr', //toastr messages
        'vAccordion', //accordion for FAQ
        'LocalStorageModule', //LS for Angular with fallback
        'angular-loading-bar', //every $http requests shows bar                
        'ngTable', //angular tables
        'smoothScroll', //Scroller -> https://github.com/d-oliveros/ngSmoothScroll
        'ui.bootstrap',
        'angular-intro',
        'ui.router.title',
        'angulartics',
        'angulartics.google.analytics',
        'chart.js',
        'ngJustGage',
        'ui.select',        
        'daterangepicker', //https://github.com/fragaria/angular-daterangepicker
        'angucomplete-alt', //autocomplete para vista admin
        'angular-linq', //LINQ expressions para JS
        'ui.grid',
        'ui.grid.resizeColumns'
    ]);
})();

(function () {
    'use strict';

    angular
      .module('portalProveedores')
      .component('ticketsRespuestaComponent', {
          templateUrl: 'app/reportes/tickets/ticketsrespuesta/tickets-respuesta.html',
          controller: TicketsRespuestaComponentController
      });


    /** @ngInject */
    function TicketsRespuestaComponentController(moment, portalSmartFactory, $linq, $filter) {
        var vm = this;

        vm.barData = {};
        vm.datosSet = [];
        vm.getTicketsPerformance = getTicketsPerformance;
        vm.graficoOpciones = {};
        vm.listadoAbiertos = [];
        vm.muestraStandby = true;
        vm.periodos = {};
        vm.query = {};
        vm.resumenConsulta = {};
       


        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        activate();

        function activate() {
            generaPeriodosDDL();
            getDatosSet();
            getGraficoOpciones();
            activaDDLPeriodos(); //Debe ir al final ya que inicia DDL con periodos
        }


        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////  

        function activaDDLPeriodos() {
            vm.query = vm.periodos[0];
        }

        //Genera array con KPIs
        function generaArrayKPI(cantidadPeriodos, numeroKPI) {

            var array = [];

            for (var i = 0; i < cantidadPeriodos; i++) {
                array.push(numeroKPI);
            }

            return array;
        }

        //Genera periodos para DDL
        function generaPeriodosDDL() {
            var periodos = [
                { nombrePeriodo: 'TODOS LOS PERÍODOS', inicioPeriodo: null, finPeriodo: null, todosPeriodos: true },
                { nombrePeriodo: 'AÑO ACTUAL', inicioPeriodo: moment().utc().startOf('year'), finPeriodo: moment().utc().endOf('year'), todosPeriodos: false },
                { nombrePeriodo: 'ÚLTIMOS 12 MESES', inicioPeriodo: moment().utc().subtract(12, 'month'), finPeriodo: moment().utc(), todosPeriodos: false },
                { nombrePeriodo: 'AÑO ANTERIOR', inicioPeriodo: moment().utc().subtract(1, 'year').startOf('year'), finPeriodo: moment().utc().subtract(1, 'year').endOf('year'), todosPeriodos: false },
                { nombrePeriodo: 'MES ACTUAL', inicioPeriodo: moment().startOf('month'), finPeriodo: moment().utc().endOf('month'), todosPeriodos: false }
            ]

            vm.periodos = periodos;
        }


        //Configuraciones independientes para las SERIES del grafico
        function getDatosSet() {
            var datosSet = [
                {
                    label: "KPI",
                    type: 'line',
                    fill: false,
                    lineTension: 0,
                    hoverBackgroundColor: "#721104",
                    hoverBorderColor: "#721104",
                    hoverColor: '#721104',
                    borderColor: '#721104', //burdeo
                    pointBorderColor: '#721104',
                    pointBackgroundColor: '#721104',
                    pointRadius: 3,
                    pointHoverRadius: 5,
                    borderWidth: 2,
                    yAxisID: 'A'
                },
                {
                    label: "Respuesta",
                    type: 'line',
                    fill: false,
                    lineTension: 0,
                    hoverBackgroundColor: "#3b7cc6",
                    hoverBorderColor: "#3b7cc6",
                    borderColor: '#004aa0', //azul
                    pointBorderColor: '#0c2e56', //azul oscuro
                    pointBackgroundColor: '#3b7cc6', //azul claro
                    pointRadius: 6,
                    pointHoverRadius: 5,
                    borderWidth: 2,
                    yAxisID: 'A'
                },
                {
                    label: 'Abiertos',
                    type: 'bar',
                    backgroundColor: 'rgba(252,144,0, .8)',
                    borderColor: 'rgba(252,144,0, 1)',
                    borderWidth: 0,
                    yAxisID: 'B'
                },
                {
                    label: 'Cerrados',
                    type: 'bar',
                    backgroundColor: 'rgba(0,94,87, .8)',
                    borderColor: 'rgba(0,94,87,1)',
                    borderWidth: 0,
                    yAxisID: 'B'
                }
            ];

            vm.datosSet = datosSet;
        }

        //Configuraciones para el grafico
        function getGraficoOpciones() {

            var opciones = {
                title: {
                    display: true,
                    text: 'Tickets por Analista vs Performance (Días)',
                    fontSize: 35,
                    fontFamily: "'Dosis','Open Sans', 'Helvetica', 'Arial', sans-serif",
                    fontStyle: 'lighter',
                    padding: 20
                },
                tooltips: {
                    titleFontSize: 19,
                    titleSpacing: 4,
                    bodyFontFamily: "'Dosis','Open Sans', 'Helvetica', 'Arial', sans-serif",
                    bodyFontSize: 16,
                    bodySpacing: 10,
                    xPadding: 10,
                    yPadding: 10,
                    callbacks: {
                        label: function (tooltipItems, data) {
                            var unidad = '';

                            if (tooltipItems.datasetIndex === 0 || tooltipItems.datasetIndex === 1) {
                                unidad = 'días';
                            }
                            else {
                                unidad = 'tickets'
                            }

                            return data.datasets[tooltipItems.datasetIndex].label + ': ' + tooltipItems.yLabel + ' ' + unidad;
                        }
                    }
                },
                legend: {
                    display: true,
                    position: 'top',
                    labels: {
                        fontFamily: "'Dosis','Open Sans', 'Helvetica', 'Arial', sans-serif",
                        fontSize: 19
                    }
                },
                scales: {
                    yAxes: [
                        {
                            id: 'A',
                            type: 'linear',
                            position: 'left'
                        },
                        {
                            id: 'B',
                            type: 'linear',
                            position: 'right'
                        }
                    ]
                }
            };



            vm.graficoOpciones = opciones;
        }

        //Retorna objeto de configuracion para chart.js de performance de tickets
        function getTicketsPerformance() {
                                   
            var valorKPI = 3;            

            portalSmartFactory.ticketsPerformance(vm.query).then(function (response) {                

                vm.muestraStandby = false; //bandera para eliminar fila de espera

                vm.listadoAbiertos = response.ticketsAbiertos;

                var etiquetas = $linq.Enumerable().From(response.ticketPerformance)
                    .Select(function (x) {
                        return x.analista;
                    }).ToArray();                
                
                var kpi = generaArrayKPI(etiquetas.length, valorKPI);

                var performance = $linq.Enumerable().From(response.ticketPerformance)
                    .Select(function (x) {
                        return x.performance;
                    }).ToArray();

                var ticketsCerrados = $linq.Enumerable().From(response.ticketPerformance)
                    .Select(function (x) {
                        return x.ticketsCerrados;
                    }).ToArray();

                var ticketsAbiertos = $linq.Enumerable().From(response.ticketPerformance)
                    .Select(function (x) {
                        return x.ticketsAbiertos;
                    }).ToArray();

                vm.barData.data = [];

                vm.barData.etiquetas = etiquetas;

                //Convierte a DIAS y trunca en 2 PERFORMANCE
                var performanceDias = performance.map(function (item) {
                    var dias = item / 24;
                    return $filter('number')(dias, 2);
                });

                //Debe corresponder al orden DatosSet()
                vm.barData.data.push(kpi);
                vm.barData.data.push(performanceDias);
                vm.barData.data.push(ticketsAbiertos);
                vm.barData.data.push(ticketsCerrados);                

                vm.resumenConsulta = {
                    totalTickets: response.ticketsCantidadTotalPeriodo,
                    totalTicketsAbiertos: response.totalTicketsAbiertos,
                    totalTicketsCerrados: response.totalTicketsCerrados,
                    totalCantidadAnalistas: response.cantidadAnalistasTicket
                };                                               

            });
        }

    }

})();
(function () {
    'use strict';

    angular
      .module('portalProveedores')
      .component('ticketsRespuestaGridComponent', {
          bindings: {
              tableData: '<'
          }, 
          templateUrl: 'app/reportes/tickets/ticketsrespuesta/tickets-respuesta-grid.html',
          controller: TicketsRespuestaGridController
      });


    /** @ngInject */
    function TicketsRespuestaGridController($uibModal) {
        var vm = this;        

        vm.openDetalleTicketModal = openDetalleTicketModal; //abre modal con detalle de documento        

        
        //activate();        

        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        //function activate() {        
        //}

        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


        function openDetalleTicketModal(ticketFila) {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/reportes/tickets/ticketsrespuesta/detalle-ticket.modal.html',
                controller: DetalleTicketModalController,
                controllerAs: 'vm',
                size: 'lg',
                windowTopClass: 'modal-fix',
                resolve: {
                    ticketFila: function () {
                        return ticketFila;
                    }                    
                }
            });
        }



        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        /** @ngInject */
        function DetalleTicketModalController($uibModalInstance, ticketFila) {
            var vm = this;

            vm.ticket = ticketFila;
            

            vm.closeModal = function () {
                $uibModalInstance.close();
            }
        }

    }

})();
(function () {
    'use strict';

    angular
      .module('portalProveedores')
      .component('detalleTicketModalComponent', {
          bindings: {
              ticketData: '<'              
          },
          templateUrl: 'app/reportes/tickets/detalleticketmodal/detalle-ticket-main.html',
          controller: DetalleTicketModalComponentController
      });


    /** @ngInject */
    function DetalleTicketModalComponentController() {
           
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        //activate();

        //function activate() {
        //    getDetalleDocumento();
        //}

        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        
        //function getDetalleDocumento() {
        //    portalSmartFactory.detalleDocumento(vm.documentoid).then(function (response) {
        //        vm.documento = response;
        //    });
        //}


    }

})();
(function () {
    'use strict';

    angular
      .module('portalProveedores')
      .component('mockComponent', {
          templateUrl: 'app/reportes/mock/mock.html',
          controller: MockComponentController
      });


    /** @ngInject */
    function MockComponentController() {


        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        activate();

        function activate() {
        }


        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


    }

})();

(function () {
    'use strict';

    angular
      .module('portalProveedores')
      .component('fixedNavigatorComponent', {
          templateUrl: 'app/reportes/fixednavigator/fixednavigator.html',
          controller: FixedNavigatorComponentController
      });


    /** @ngInject */
    function FixedNavigatorComponentController() {

        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////        

        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    }

})();
(function () {
    'use strict';

    angular
      .module('portalProveedores')
      .component('detalleDocumentoModalComponent', {
          bindings: {
              documentoid: '<',
              promedioDias: '<'
          },
          templateUrl: 'app/reportes/detalledocumentomodal/detalle-documento-main.html',
          controller: DetalleDocumentoModalComponentController
      });


    /** @ngInject */
    function DetalleDocumentoModalComponentController(portalSmartFactory) {
        var vm = this;

        vm.documento = {};


        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        activate();

        function activate() {
            getDetalleDocumento();
        }

        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        
        function getDetalleDocumento() {
            portalSmartFactory.detalleDocumento(vm.documentoid).then(function (response) {
                vm.documento = response;
            });
        }




    }

})();
(function () {
    'use strict';

    angular
      .module('portalProveedores')
      .component('cicloVidaMainComponent', {
          templateUrl: 'app/reportes/ciclovida/ciclo-vida-main.html',
          controller: CicloVidaMainComponentController
      });


    /** @ngInject */
    function CicloVidaMainComponentController($log, moment, portalSmartFactory, $linq, $filter) {
        var vm = this;

        vm.analistasDocumentos = [];
        vm.calcularPorcentaje = calcularPorcentaje;
        vm.getCicloVida = getCicloVida;
        vm.listadoMeses = generaListadoMeses();
        vm.momento = momento;
        vm.muestraStandby = true;
        vm.query = {};
        vm.respuestaCiclo = {};
        vm.resumenTodosCiclos = {};
        vm.tiposPeriodoConsulta = ['Anual', 'Mensual'];
        vm.variacionesPeriodosAnteriores = {};
        vm.yearsDocumentos = [];
        



        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        activate();

        function activate() {
            activaDDLS();
            getAnalistasDocumentos();
            getYears();
        }


        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////        
        function activaDDLS() {
            vm.query.analista = '';
            vm.query.cargarListados = true;
            vm.query.year = moment().year();
            vm.query.tipoPeriodo = 'Mensual';
            vm.query.mes = $linq.Enumerable().From(vm.listadoMeses).FirstOrDefault(-1, "$.numeromes==moment().month()");
            vm.query.cantidadPeriodos = 3;
        }

        //Calcula Promedio Simple (Regla de Tres)
        function calcularPorcentaje(subtotal, total) {

            if (total == 0) {
                return '-';
            }

            var calculo = (100 * subtotal) / total;
                
            var resultado = $filter('number')(calculo, 2)

            return resultado + '%';
        }

        //Calcula variacion entre periodos
        function calcularVariacion(actual, anterior) {

            if (anterior == -1) {
                return 'ERROR';
            }

            if (anterior == 0) {
                return 0;
            }

            var calc = ((actual * 100) / anterior) - 100;

            return calc;
        }

        //Genera listado meses para DDL
        function generaListadoMeses() {

            var resultado = [
                { numeromes: 0, nombremes: 'Enero' },
                { numeromes: 1, nombremes: 'Febrero' },
                { numeromes: 2, nombremes: 'Marzo' },
                { numeromes: 3, nombremes: 'Abril' },
                { numeromes: 4, nombremes: 'Mayo' },
                { numeromes: 5, nombremes: 'Junio' },
                { numeromes: 6, nombremes: 'Julio' },
                { numeromes: 7, nombremes: 'Agosto' },
                { numeromes: 8, nombremes: 'Septiembre' },
                { numeromes: 9, nombremes: 'Octubre' },
                { numeromes: 10, nombremes: 'Noviembre' },
                { numeromes: 11, nombremes: 'Diciembre' }
            ];

            return resultado;
        }

        // cantidad: numero de periodos, periodo: month, day, etc.
        function generaListaPeriodos(tipoPeriodo, periodoInicial, cantidadPeriodos) {

            var operadorMoment = ''; //month || year

            switch (tipoPeriodo) {
                case 'Anual':
                    operadorMoment = 'year';
                    break;
                case 'Mensual':
                default:
                    operadorMoment = 'month';
                    break;
            }

            var listadoPeriodos = [];

            for (var i = 0; i < cantidadPeriodos; i++) {

                var obj = {};

                if (i == 0) {                    
                    obj = { inicio: moment().utc().year(periodoInicial.year).month(periodoInicial.mes).startOf(operadorMoment), final: moment().utc().year(periodoInicial.year).month(periodoInicial.mes).endOf(operadorMoment), esPeriodoActual: true }
                    listadoPeriodos.push(obj);
                }
                else {                    
                    obj = { inicio: moment().utc().year(periodoInicial.year).month(periodoInicial.mes).subtract(i, operadorMoment).startOf(operadorMoment), final: moment().utc().year(periodoInicial.year).month(periodoInicial.mes).subtract(i, operadorMoment).endOf(operadorMoment), esPeriodoActual: false }
                    listadoPeriodos.push(obj);
                }
            }

            return listadoPeriodos;
        }

        //Genera variaciones porcentuales respecto a PERIODO ACTUAL con todos los periodos ANTERIORES
        function generaVariacionesPeriodos(dataCicloVida) {

            var periodoActual = $linq.Enumerable().From(dataCicloVida)
                .FirstOrDefault(-1, "$.esPeriodoActual==true");

            var actualPromedioDiasCont = periodoActual.resumenContabilizados.promedioDias;
            var actualPromedioDiasNoCont = periodoActual.resumenNoContabilizados.promedioDias;

            var periodosNoActuales = $linq.Enumerable().From(dataCicloVida)
                .Where("$.esPeriodoActual==false").ToArray();



            var noContabilizados = $linq.Enumerable().From(periodosNoActuales)
                .Select(function (x) {
                    return calcularVariacion(actualPromedioDiasNoCont, x.resumenNoContabilizados.promedioDias);
                }).ToArray();

            var contabilizados = $linq.Enumerable().From(periodosNoActuales)
                .Select(function (x) {
                    return calcularVariacion(actualPromedioDiasCont, x.resumenContabilizados.promedioDias);
                }).ToArray();

            vm.variacionesPeriodosAnteriores.contabilizados = contabilizados;
            vm.variacionesPeriodosAnteriores.noContabilizados = noContabilizados;
        }


        //Obtiene los analistas para select box
        function getAnalistasDocumentos() {
            portalSmartFactory.analistasDocumentos().then(function (response) {
                vm.analistasDocumentos = response;
            })
        }



        //Obtiene informacion para reporte ciclo de vida
        function getCicloVida() {

            var incluirTops = vm.query.cargarListados;

            if (incluirTops == 'undefined' || incluirTops.length == 0 || angular.isUndefined(incluirTops)) {
                incluirTops = false;

            }

            var periodoInicial = {
                year: vm.query.year,
                mes: vm.query.mes.numeromes
            }

            var queryAPI = {
                listaPeriodos: generaListaPeriodos(vm.query.tipoPeriodo, periodoInicial, vm.query.cantidadPeriodos),
                analista: vm.query.analista,
                incluirTops: vm.query.cargarListados
            };

            portalSmartFactory.cicloVida(queryAPI).then(function (response) {
                vm.muestraStandby = false;
                vm.respuestaCiclo = response;
                setResumenTodosPeriodos(response);
                generaVariacionesPeriodos(response);
            });
        }


        //Obtiene anhos en los documentos (distinct)
        function getYears() {
            portalSmartFactory.yearsDocumentos().then(function (response) {
                vm.yearsDocumentos = response;
                vm.cicloVidaYear = response[0];
            });
        }

        //Retorna instancia de momentjs
        function momento(fecha) {
            return moment(fecha);
        }

        //Calcula resumenes para TODOS los periodos
        function setResumenTodosPeriodos(data) {

            var totalDocsPeriodos = $linq.Enumerable().From(data)
                .Sum("$.cantidadDocumentosTotal");

            var sumaContabilizados = $linq.Enumerable().From(data)
                .Sum("$.resumenContabilizados.cantidadDocumentos");

            var sumaNoContabilizados = $linq.Enumerable().From(data)
                .Sum("$.resumenNoContabilizados.cantidadDocumentos");

            var promedioDiasContablizadosPeriodos = $linq.Enumerable().From(data)
                .Average("$.resumenContabilizados.promedioDias"); //resumenContabilizados.promedioDias

            var promedioDiasNoContablizadosPeriodos = $linq.Enumerable().From(data)
                .Average("$.resumenNoContabilizados.promedioDias"); //resumenContabilizados.promedioDias

            vm.resumenTodosCiclos.totalDocsPeriodo = totalDocsPeriodos;

            vm.resumenTodosCiclos.sumaContabilizados = sumaContabilizados;
            vm.resumenTodosCiclos.promedioDiasContablizadosPeriodos = promedioDiasContablizadosPeriodos;
            vm.resumenTodosCiclos.porcentajeContabilizados = calcularPorcentaje(sumaContabilizados, totalDocsPeriodos);

            vm.resumenTodosCiclos.sumaNoContabilizados = sumaNoContabilizados;
            vm.resumenTodosCiclos.promedioDiasNoContablizadosPeriodos = promedioDiasNoContablizadosPeriodos;
            vm.resumenTodosCiclos.porcentajeNoContabilizados = calcularPorcentaje(sumaNoContabilizados, totalDocsPeriodos);
        }


    }

})();
(function () {
    'use strict';

    angular
      .module('portalProveedores')
      .component('cicloVidaGridComponent', {
          bindings: {
              tableData: '=',
              campoPromedio: '@'              
          },
          template: '<div ui-grid="$ctrl.gridOptions" class="grid" ui-grid-resize-columns></div>',
          controller: CicloVidaGridComponentController
      });


    /** @ngInject */
    function CicloVidaGridComponentController($uibModal) {
        var vm = this;        

        vm.openDetalleModal = openDetalleModal; //abre modal con detalle de documento        


        vm.gridOptions = {            
            flatEntityAccess: true,             
            enableSorting: false,
            columnDefs: [
              { field: 'analista', cellTemplate: '<div class="ui-grid-cell-contents"><span>{{COL_FIELD}}</span></div>' },
              { field: 'proveedor', cellTemplate: '<div class="ui-grid-cell-contents"><span>{{COL_FIELD}}</span></div>' },
              { name: 'promedioDias', field: vm.campoPromedio, cellTemplate: '<div class="ui-grid-cell-contents"><span>{{COL_FIELD}}</span></div>' },
              {
                  //campoPromedio: diferenciaDiasContabilizacion, diferenciaDiasRecepcion & diferenciaDiasPago
                  name: 'folio',
                  cellTemplate: '<a ng-click="grid.appScope.$ctrl.openDetalleModal(row.entity.facturaID, row.entity.' + vm.campoPromedio + ')" href="">{{row.entity.folio}}</a>'
              }
            ],
            data: vm.tableData
        };
        
        //activate();        

        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        //function activate() {
        //    gridParams();
        //}

        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



        //function gridParams() {
        //    vm.gridOptions.data = vm.tableData;
        //}

        function openDetalleModal(documentoID, promedio) {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/reportes/ciclovida/detalle-documento.modal.html',
                controller: DetalleModalController,
                controllerAs: 'vm',
                size: 'lg',
                windowTopClass: 'modal-fix',
                resolve: {
                    documentoID: function () {
                        return documentoID;
                    },
                    promedio: function () {
                        return promedio;
                    }
                }
            });
        }



        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        /** @ngInject */
        function DetalleModalController($uibModalInstance, documentoID, promedio) {
            var vm = this;

            vm.documentoID = documentoID;
            vm.promedio = promedio;

            vm.closeModal = function () {
                $uibModalInstance.close();
            }
        }

    }

})();

(function () {
    'use strict';

    angular
      .module('portalProveedores')
      .component('barraEstadoReportesComponent', {
          templateUrl: 'app/reportes/barraestado/barra-estado-main.html',
          controller: BarraEstadoComponentController
      });


    /** @ngInject */
    function BarraEstadoComponentController(portalSmartFactory, SERVICE_BASE, $interval, $log) {
        var vm = this;

        vm.barraEstadoInfo = {};
        vm.baseUrl = SERVICE_BASE;

        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        activate();        

        $interval(activate, 150000);

        function activate() {
            getBarraEstadoInfo();
            $log.log('BARRAESTADO: Actualizado/Activate');
        }

        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        //Informacion Barra de Estado General
        function getBarraEstadoInfo() {
            portalSmartFactory.infoBarraEstado().then(function (response) {
                vm.barraEstadoInfo = response;
            })
        }




    }

})();
(function () {
    'use strict';

    angular
      .module('portalProveedores')
      .component('analistasPerformanceComponent', {
          templateUrl: 'app/reportes/analistasperformance/analistas-performance.html',
          controller: AnalistasPerformanceComponentController
      });


    /** @ngInject */
    function AnalistasPerformanceComponentController(portalSmartFactory, moment, $linq, $filter) {
        var vm = this;


        vm.analistasDocumentos = [];
        vm.getCicloVida = getCicloVida;
        vm.grafico = {};
        vm.muestraStandby = true;
        vm.query = {};


        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        activate();

        function activate() {
            getAnalistasDocumentos();
            getDatosSet();
            getGraficoOpciones();
        }

        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        function formateaFecha(fecha) {
            var resultado = moment(fecha).utc().format('MMMM YYYY');
            return resultado;
        }

        //Genera array con KPIs
        function generaArrayKPI(cantidadPeriodos, numeroKPI) {

            var array = [];

            for (var i = 0; i < cantidadPeriodos; i++) {
                array.push(numeroKPI);
            }

            return array;
        }

        //Obtiene listadoPeriodos para una cantidad de periodos definida, por lo general 12 meses (12,'month')
        function generaPeriodos(cantidadPeriodos, tipoPeriodo) {

            var listadoPeriodos = [];

            var obj = {};

            for (var i = 0; i < cantidadPeriodos; i++) {
                if (i == 0) {
                    obj = { inicio: moment().utc().startOf(tipoPeriodo), final: moment().utc().endOf(tipoPeriodo), esPeriodoActual: true }
                    listadoPeriodos.push(obj);
                }
                else {
                    obj = { inicio: moment().utc().subtract(i, tipoPeriodo).startOf(tipoPeriodo), final: moment().utc().subtract(i, tipoPeriodo).endOf(tipoPeriodo), esPeriodoActual: false }
                    listadoPeriodos.push(obj);
                }
            }

            return listadoPeriodos;
        }

        //Obtiene los analistas para select box
        function getAnalistasDocumentos() {
            portalSmartFactory.analistasDocumentos().then(function (response) {
                vm.analistasDocumentos = response;
            })
        }

        //Obtiene informacion para reporte ciclo de vida
        function getCicloVida() {

            var cantidadPeriodos = 12;
            var valorKPI = 8;

            var queryAPI = {
                listaPeriodos: generaPeriodos(cantidadPeriodos, 'month'),
                analista: vm.query.analista,
                incluirTops: false //no obtiene listados de documentos, acelera el proceso de carga y de $watch
            };

            portalSmartFactory.cicloVida(queryAPI).then(function (response) {

                vm.muestraStandby = false;

                var kpi = generaArrayKPI(cantidadPeriodos, valorKPI);

                var etiquetas = $linq.Enumerable().From(response) //etiquetas corresponden a los periodos, en este caso MESES
                    .Select(function (x) {
                        return formateaFecha(x.inicioPeriodo);
                    }).ToArray();

                var contabilizadosDias = $linq.Enumerable().From(response)
                    .Select(function (x) {
                        return $filter('number')(x.resumenContabilizados.promedioDias, 2);
                    }).ToArray();

                var noContabilizadosDias = $linq.Enumerable().From(response)
                    .Select(function (x) {
                        return $filter('number')(x.resumenNoContabilizados.promedioDias, 2);
                    }).ToArray();

                var cantidadDocumentos = $linq.Enumerable().From(response)
                    .Select(function (x) {
                        return x.cantidadDocumentosTotal;
                    }).ToArray();


                vm.grafico.etiquetas = etiquetas;


                vm.grafico.data = [];

                vm.grafico.data.push(kpi);
                vm.grafico.data.push(cantidadDocumentos);
                vm.grafico.data.push(noContabilizadosDias);
                vm.grafico.data.push(contabilizadosDias);

            });
        }



        //Configuraciones independientes para las SERIES del grafico
        function getDatosSet() {

            var datosSet = [
                {
                    label: "KPI",
                    type: 'line',
                    fill: false,
                    lineTension: 0,
                    borderColor: '#721104', //burdeo
                    pointBorderColor: '#721104',
                    pointBackgroundColor: '#721104',
                    pointRadius: 3,
                    pointHoverRadius: 5,
                    borderWidth: 2,
                    yAxisID: 'A'
                },
                {
                    label: "Cantidad Documentos",
                    type: 'line',
                    fill: false,
                    lineTension: 0,
                    borderColor: '#004aa0', //azul
                    pointBorderColor: '#0c2e56', //azul oscuro
                    pointBackgroundColor: '#3b7cc6', //azul claro
                    pointRadius: 6,
                    pointHoverRadius: 5,
                    borderWidth: 2,
                    yAxisID: 'B'
                },
                {
                    label: 'No Contabilizados',
                    type: 'bar',
                    backgroundColor: 'rgba(252,144,0, .8)',
                    borderColor: 'rgba(252,144,0, 1)',
                    borderWidth: 0,
                    yAxisID: 'A'
                },
                {
                    label: 'Contabilizados',
                    type: 'bar',
                    backgroundColor: 'rgba(0,94,87, .8)',
                    borderColor: 'rgba(0,94,87,1)',
                    borderWidth: 0,
                    yAxisID: 'A'
                }

            ];

            vm.grafico.set = datosSet;
        }

        //Configuraciones para el grafico
        function getGraficoOpciones() {
            var opciones = {
                title: {
                    display: true,
                    text: 'Performance Promedio Días Analistas - 12 Meses',
                    fontSize: 35,
                    fontFamily: "'Dosis','Open Sans', 'Helvetica', 'Arial', sans-serif",
                    fontStyle: 'lighter',
                    padding: 20
                },
                tooltips: {
                    titleFontSize: 19,
                    titleSpacing: 4,
                    bodyFontFamily: "'Dosis','Open Sans', 'Helvetica', 'Arial', sans-serif",
                    bodyFontSize: 16,
                    bodySpacing: 10,
                    xPadding: 10,
                    yPadding: 10,
                    callbacks: {
                        label: function (tooltipItems, data) {
                            var unidad = '';

                            if (tooltipItems.datasetIndex === 0 || tooltipItems.datasetIndex === 2 || tooltipItems.datasetIndex === 3) {
                                unidad = 'días';
                            }
                            
                            return data.datasets[tooltipItems.datasetIndex].label + ': ' + tooltipItems.yLabel + ' ' + unidad;
                        }
                    }
                },
                legend: {
                    display: true,
                    position: 'top',
                    labels: {
                        fontFamily: "'Dosis','Open Sans', 'Helvetica', 'Arial', sans-serif",
                        fontSize: 19
                    }
                },
                scales: {
                    yAxes: [
                        {
                            id: 'A',
                            type: 'linear',
                            position: 'left'
                        },
                        {
                            id: 'B',
                            type: 'linear',
                            position: 'right'
                        }
                    ]
                }
            };

            vm.grafico.opciones = opciones;
        }




    }

})();

(function () {
    'use strict';

    angular
      .module('portalProveedores')
      .directive('navbarMetso', navbarMetso);

    /** @ngInject */
    function navbarMetso() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/navbar/navbar.html',
            scope: {
                creationDate: '='
            },
            controller: NavbarController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function NavbarController(moment, authService, localStorageService, $location, $state, $scope, $rootScope) {
            var vm = this;

            vm.authentication = authService.authentication;


            vm.isAuthenticated = function () {
                var authData = localStorageService.get('authorizationData');
                if (authData) {
                    return true;
                }
                else {
                    return false;
                }
            }

            vm.logOut = function () {
                authService.logOut();
                emitLogOut();
                $state.go('home');
            }

            function emitLogOut(){
              $rootScope.$emit('eventEmitedLogOut', false);
            }

        }
    }

})();

(function () {
  'use strict';

  angular
  .module('portalProveedores')
  .component('metsoJumbotronComponent', component());

  /* @ngInject */
  function component() {
    var component = {
      templateUrl: 'app/components/jumbotron-v2/metsojumbo.html',
      controller: MetsoJumbotronComponentController
    };

    return component;
  }


  /** @ngInject */
  function MetsoJumbotronComponentController($scope, $rootScope, $log, localStorageService) {

    var vm = this;

    vm.isAuthenticated = false;

    //$rootScope.$on('eventEmitedLogOut', function(event, data) {
    //  $log.log(event.name + ' => received by Jumbotron with data  => ' + data);
    //  vm.isAuthenticated = false;
    //});

    var emitedLogOut = $rootScope.$on('eventEmitedLogOut', function (event, data) {
      $log.log(event.name + ' => received by Jumbotron with data  => ' + data);
      vm.isAuthenticated = false;
    });

    $rootScope.$on('$destroy', emitedLogOut);

    //--------------------------------------------------------------------------- //
    activate();
    //--------------------------------------------------------------------------- //

    function activate(){
        vm.isAuthenticated = checkIsAuth();        
    }

    //--------------------------------------------------------------------------- //

    function checkIsAuth(){
      var authData = localStorageService.get('authorizationData');
      if (authData) {
        return true;
      }
      else {
        return false;
      }
    }

    // -------------------------------------------------------------------------- //


  }

})();

(function () {

	'use strict';

	angular
      .module('portalProveedores')
      .directive('jumbotronPortal', jumbotronPortal);

	/** @ngInject */
	/** @ngInject */
	function jumbotronPortal() {
		var directive = {
			restrict: 'E',
			templateUrl: 'app/components/jumbotron/jumbotron.html',
			scope: {
				encabezado: '=',
				texto: '=',
				conDocumentos: '='
			},
			controller: JumbotronPortalController,
			controllerAs: 'vm',
			bindToController: true
		};

		return directive;
	}

	/** @ngInject */
	function JumbotronPortalController() {		
	}

})();
(function () {
    'use strict';

    angular
      .module('portalProveedores')
      .directive('footerMetso', footerMetso);

    /** @ngInject */
    function footerMetso() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/footer/footer.html',
            scope: {
                creationDate: '='
            },
            controller: FooterController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    /** @ngInject */
    function FooterController(moment, $rootScope, $uibModal, portalIntroFactory, portalDataFactory, toastr, $scope, $log) {

        var vm = this;


        vm.openFaqModal = function () {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/faq/faq-modal.html',
                controller: FaqModalController,
                controllerAs: 'vm',
                size: 'lg'
            });
        }

        vm.nombreEstado = '';
        vm.introOptions = [];



        vm.formularioContacto = {};        

        vm.sendFormularioContacto = function () {

            function formSuccess(response) {
                var data = response.data;
                toastr.success('Pronto nos comunicaremos con ud.', 'MENSAJE ENVIADO');
                $log.log('FOOTER: Mensaje enviado');
                $log.log(data);

                vm.formularioContacto = {};
                $scope.footercontacto.$setUntouched();
            }

            vm.formularioContacto.responsableID = vm.responsableSeleccionado.responsableID;
            vm.formularioContacto.razonMensaje = vm.responsableSeleccionado.descripcion;

            portalDataFactory.postFormularioContacto(vm.formularioContacto).then(formSuccess);

        }

        vm.responsables = [];

        vm.getAsuntoDropdown = function () {

            portalDataFactory.getResponsablesFormularioContacto()
                .then(function (response) {
                    vm.responsables = response;
                });
        }


        //Recibe informaci�n del nombre del estado para parametrizar 
        vm.on = $rootScope.$on('intro', function (event, val) {
            vm.nombreEstado = val;
            vm.introOptions = portalIntroFactory.getIntroJSOptions(vm.nombreEstado);
        });

        /** @ngInject */
        function FaqModalController($uibModalInstance) {
            var vm = this;

            vm.closeModal = function () {
                $uibModalInstance.close();
            }
        }

        vm.getAsuntoDropdown();

    }

})();

(function () {

	'use strict';

	angular
      .module('portalProveedores')
      .directive('documentosPortal', documentosPortal);

	/** @ngInject */	
	function documentosPortal() {
		var directive = {
			restrict: 'E',
			templateUrl: 'app/components/documentos/documentos.html',
			scope: {
				tipo: '=',
				conBullet: '='
			},
			controller: DocumentosPortalController,
			controllerAs: 'vm',
			bindToController: true
		};

		return directive;
	}

	/** @ngInject */
	function DocumentosPortalController(portalDataFactory, $log) {

		var vm = this;

		vm.documentos = [];

		vm.getDocumentos = (function () {
			portalDataFactory.getDocumentos()
                .then(function (response) {
                    vm.documentos = response;
                }, function (error) {
                    $log.warn('DOCS Directiva. No se cargaron documentos. ERROR.');
                    $log.warn(error);
                });
		})();

	}

})();
(function () {
    'use strict';

    angular
      .module('portalProveedores')
      .controller('WelcomeController', WelcomeController);

    /** @ngInject */
    function WelcomeController(portalDataFactory, $log, localStorageService, $window, $rootScope, portalIntroFactory, $state, moment) {
        var vm = this;

        //Datos para intro TUTORIALES
        vm.introWelcomeOptions = {};

        vm.cargaIntroOptions = (function () {
            vm.introWelcomeOptions = portalIntroFactory.getIntroJSOptions('home');
        })();
        
        vm.docs = [];

        vm.userData = {
            razonSocial: '',
            rutProveedor: '',
            email: '',
            nombreEncargado: '',
            cargoEncargado: ''
        };

        vm.hoy = moment();        

        vm.mostrarFormModificacion = false;

        vm.getDocumentos = function () {
            portalDataFactory.getDocumentos()
                .then(function (response) {
                    vm.docs = response;
                }, function (error) {
                    $log.warn('WELCOME. No se cargaron documentos. ERROR.');
                    $log.warn(error);
                });
        }

        vm.isAuthenticated = function () {
            var authData = localStorageService.get('authorizationData');
            if (authData) {
                return true;
            }
            else {
                return false;
            }
        }

        vm.getUserData = function () {

            if (vm.isAuthenticated()) {
                portalDataFactory.getUserTokenInfo()
                .then(function (response) {
                    vm.userData = response;
                }, function (error) {
                    $log.warn('No se pudo obtener info de usuario.');
                    $log.warn(error);
                });
            }
        }

        vm.sendUserData = function () {
            portalDataFactory.postUserTokenInfo(vm.userData)
            .then(function (response) {
                vm.userData = response.data;
                vm.getUserData();
                vm.mostrarFormModificacion = false;
            }, function (error) {
                $log.warn('No se pudo postear nueva info de usuario');
                $log.warn(error);
            });
        }

        // notifica estado a FOOTER para parametrizar Tutorial
        vm.notificaEstado = (function () {
            $rootScope.$emit('intro', $state.current.name);
        })();


        //RUN...
        vm.getDocumentos();
        vm.getUserData();
        //vm.notificaEstado();

    }

})();
(function () {

    'use strict';

    angular
      .module('portalProveedores')
      .controller('UserDataController', UserDataController);

    /** @ngInject */
    function UserDataController($log, localStorageService, portalDataFactory) {
        var vm = this;

        vm.userData = {
            razonSocial: '',
            rutProveedor: '',
            email: '',
            nombreEncargado: '',
            cargoEncargado: ''
        };

        vm.getUserData = function () {
            portalDataFactory.getUserTokenInfo()
                .then(function (response) {
                    vm.userData = response;
                }, function (error) {
                    $log.warn('No se pudo obtener info de usuario.');
                    $log.warn(error);
                });
        }

        vm.sendUserData = function () {
            portalDataFactory.postUserTokenInfo(vm.userData)
                .then(function (response) {
                    vm.userData = response.data;
                    vm.getUserData();
                }, function (error) {
                    $log.warn('No se pudo postear nueva info de usuario');
                    $log.warn(error);
                });
        }

        vm.getUserData();


    }

})();
(function () {

    'use strict';

    angular
      .module('portalProveedores')
      .controller('TestController', TestController);

    /** @ngInject */
    function TestController() {
        //var vm = this;

        //vm.infoUsuario = {};
        //vm.token = {};
        //vm.parametro = $stateParams.razon;

        //vm.getUserInfo = function () {
        //    portalDataFactory.testCheckUsuario()
        //        .then(function (response) {
        //            vm.infoUsuario = response;
        //        }, function (error) {
        //            $log.warn('TEST. No se cargo info usuario por token. ERROR.');
        //            $log.warn(error);
        //        });
        //}

        //vm.getVista = function () {
        //    var param = vm.variableTest;
        //    $state.go('ingresar', { razon: param })
        //}

        //vm.getTokenLocal = function () {
        //    var authData = localStorageService.get('authorizationData');
        //    if (authData) {
        //        vm.token = authData;
        //    }
        //    else {
        //        vm.token = { nohay: 'sin datos'};
        //    }
        //}

        //vm.introOptions = portalIntroFactory.getIntroJSOptions('test');
        //vm.introCompleted = function () {
        //    $state.go('home');
        //}

        //// notifica estado a FOOTER para parametrizar Tutorial
        //vm.notificaEstado = (function () {
        //    $rootScope.$emit('intro', $state.current.name);
        //})();

        //vm.getTokenLocal();
        
    }


})();

(function () {

    'use strict';

    angular
      .module('portalProveedores')
      .controller('SignupController', SignupController);

    /** @ngInject */
    function SignupController($location, $timeout, authService, portalDataFactory, $log, $state, $rootScope) {
        var vm = this;

        vm.savedSuccessfully = false;
        vm.mensajesRegistro = [];

        vm.mensajeUsuario = {
            esProveedor: false,
            mensaje: ""            
        };

        vm.registration = {
            userName: "",
            password: "",
            confirmPassword: "",
            email: "",
            razonSocial: "",
            nombreEncargado: "",
            cargoEncargado: ""
        };

        vm.signUp = function () {
            authService.saveRegistration(vm.registration).then(function (response) {
                $log.log('Usuario registrado exitosamente');
                $log.log(response);
                vm.savedSuccessfully = true;
                var mensaje = "Usuario registrado correctamente. Redirigiendo en 2 segundos.";
                vm.mensajesRegistro.push(mensaje);
                startTimer();

            },
             function (response) {
                 var errors = [];
                 for (var key in response.data.modelState) {
                     for (var i = 0; i < response.data.modelState[key].length; i++) {
                         errors.push(response.data.modelState[key][i]);
                     }
                 }
                 $log.log(response);
                 vm.mensajesRegistro = errors;
                 //vm.message = "ERROR. " + errors.join(' ');
             });
        };


        vm.checkUser = function () {
            portalDataFactory.checkUser(vm.registration.userName)
                .then(function (response) {
                    vm.mensajeUsuario.esProveedor = response;
                    if (response === false) {
                        vm.mensajeUsuario.mensaje = 'Usted no tiene registros como proveedor';
                    }                                                          
                }, function (error) {
                    $log.log('Usuario no pudo ser verificado como proveedor (CheckUser)');
                    $log.log(error);
                    vm.mensajeUsuario.mensaje = 'Usted no tiene registros como proveedor';                    
                });
        }

        var startTimer = function () {
            var timer = $timeout(function () {
                $timeout.cancel(timer);
                $location.path('/ingresar');
            }, 2000);
        }

        vm.getDocumentos = function () {
            portalDataFactory.getDocumentos()
                .then(function (response) {
                    vm.docs = response;
                }, function (error) {
                    $log.warn('WELCOME. No se cargaron documentos. ERROR.');
                    $log.warn(error);
                });
        }

        // notifica estado a FOOTER para parametrizar Tutorial
        vm.notificaEstado = (function () {
            $rootScope.$emit('intro', $state.current.name);
        })();

        vm.getDocumentos();
        authService.logOut();



    }


})();
(function () {

    'use strict';

    angular
      .module('portalProveedores')
      .directive('pwCheck', pwCheck);


    /** @ngInject */
    function pwCheck() {
        return {
            require: 'ngModel',
            link: function (scope, elem, attrs, ctrl) {
                var firstPassword = '#' + attrs.pwCheck;
                elem.add(firstPassword).on('keyup', function () {
                    scope.$apply(function () {                        
                        var v = elem.val() === angular.element(firstPassword).val();
                        ctrl.$setValidity('pwmatch', v);
                    });
                });
            }
        }
    }
})();
(function () {
    'use strict';

    angular
      .module('portalProveedores')
      .controller('ShowcaseController', ShowcaseController);

    /** @ngInject */
    function ShowcaseController() {
    }
})();
(function () {
    'use strict';

    angular
      .module('portalProveedores')
      .controller('ResetpasswordController', ResetpasswordController);

    /** @ngInject */
    function ResetpasswordController($location, $timeout, authService, portalDataFactory, $log, $state, toastr, $stateParams) {

        var vm = this;


        vm.confirmPassword = "";
        vm.mensajesRegistro = [];
        vm.resetPassword = resetPassword;
        vm.resetPasswordViewModel = {
            userId: $stateParams.userId,
            password: "",
            token: $stateParams.token
        };
        vm.savedSuccessfully = false;
       

        /* ------------------------------------------------------------------------------------------------------------------------------------------------------- */


        function resetPassword () {

            portalDataFactory.resetPassword(vm.resetPasswordViewModel).then(successReset, failReset);

            function successReset (response) {
                toastr.success('Su contraseña ha sido reestablecida con éxito. Inicie sesión con su nueva contraseña', 'MUY BIEN', { timeOut: 5000 })
                vm.savedSuccessfully = true;
                var mensaje = "Usuario reestablecido correctamente. Redirigiendo en 2 segundos.";
                vm.mensajesRegistro = [];
                vm.mensajesRegistro.push(mensaje);
                //startTimer();                
                $log.log('Exito reestableciendo password. ' + response);
                $state.go('ingresar');
            }

            function failReset (response) {
                var errors = [];
                for (var key in response.data.modelState) {
                    for (var i = 0; i < response.data.modelState[key].length; i++) {
                        errors.push(response.data.modelState[key][i]);
                    }
                }
                $log.log(response);
                vm.mensajesRegistro = errors;
            }

        }

    }

})();
(function () {

    'use strict';


    angular
      .module('portalProveedores')
      .controller('RecuperarpasswordController', RecuperarpasswordController);

    /** @ngInject */
    function RecuperarpasswordController($location, $timeout, authService, portalDataFactory, $log, $state, toastr, $rootScope) {
        var vm = this;

        vm.savedSuccessfully = false;
        vm.mensajesRegistro = [];

        vm.mensajeUsuario = {
            esProveedor: false,
            mensaje: ""
        };

        vm.registration = {
            userName: ""            
        };

        vm.infoUsuario = {
            rutProveedor: "",
            baseUrlAPI: ""
        };

        vm.datosUsuario = {
            nombreUsuario: "",
            emailUsuario: "",
            razonSocial: "",
            baseUrlAPI: $state.href('resetPassword', { userId: '{0}', token: '{1}' }, { absolute: true })
        };
       

        vm.forgotPassword = function () {            
            portalDataFactory.forgotPassword(vm.datosUsuario).then(function (response) {
                $log.log('Correo enviado exitosamente');

                if (response) {
                    toastr.success('Por favor revise su correo electrónico y siga los pasos descritos para continuar', 'CORREO ENVIADO');
                    startTimer();
                }
            })
        };


        vm.checkUser = function () {
            portalDataFactory.checkRegisteredUser(vm.registration.userName)
                .then(function (response) {                    
                    if (response == null) {
                        vm.mensajeUsuario.esProveedor = false;
                        vm.mensajeUsuario.mensaje = 'Usted no est&aacute; registrado como proveedor';
                    }
                    else {
                        vm.mensajeUsuario.esProveedor = true;
                        vm.mensajeUsuario.mensaje = 'Usted est&aacute; registrado como proveedor';
                        vm.datosUsuario.nombreUsuario = response.nombreUsuario;
                        vm.datosUsuario.emailUsuario = response.emailUsuario;
                        vm.datosUsuario.razonSocial = response.razonSocial;
                    }

                }, function (error) {
                    $log.log('Usuario no pudo ser verificado como proveedor registrado (CheckRegisteredUser)');
                    $log.log(error);
                    vm.mensajeUsuario.mensaje = 'No fue posible vreificar si es proveedor, intene de nuevo';
                });
        }

        var startTimer = function () {
            var timer = $timeout(function () {
                $timeout.cancel(timer);                
                $state.go('home');
            }, 2000);
        }

        vm.getDocumentos = function () {
            portalDataFactory.getDocumentos()
                .then(function (response) {
                    vm.docs = response;
                }, function (error) {
                    $log.warn('RECUPERAR PASSWORD. No se cargaron documentos. ERROR.');
                    $log.warn(error);
                });
        }

        vm.getDocumentos();
        authService.logOut();

        // notifica estado a FOOTER para parametrizar Tutorial
        vm.notificaEstado = (function () {
            $rootScope.$emit('intro', $state.current.name);
        })();
    }


})();
(function () {
    'use strict';

    //TODO: OJO con las inyecciones de esta función. Salieron todas de sendTicket()

    angular
      .module('portalProveedores')
      .directive('sendTicket', sendTicket);

    /** @ngInject */
    function sendTicket() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/sendticket/sendticket.html',
            scope: {
                rutProveedor: '=',
                nombreProveedor: '=',
                numeroFactura: '=',
                facturaEstado: '='
            },
            controller: SendTicketController,
            controllerAs: 'send',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function SendTicketController(portalDataFactory, toastr, $log, $scope) {
            var vm = this;            
            
            //Mail contacto            
            vm.infoTicket = {};
            
            vm.postTicket = function () {                
                //Desde $scope directiva (isolated)
                vm.infoTicket.RutProveedor = vm.rutProveedor;
                vm.infoTicket.NombreProveedor = vm.nombreProveedor;
                vm.infoTicket.NumeroFactura = vm.numeroFactura;
                vm.infoTicket.FacturaEstado = vm.facturaEstado;                

                //Log en consola el objeto para debuggear
                $log.log('SendTicket: Enviando objeto ->' + vm.infoTicket);

                portalDataFactory.postMailContacto(vm.infoTicket)
                .then(function (response) {
                    toastr.success('Su mensaje ha sido enviado exitosamente');
                    $log.log('Envio de ticket a POST de API exitoso');
                    $log.log(response.data);
                    vm.infoTicket = {};                                       
                    $scope.ticketForm.$setUntouched();

                }, function (error) {
                    $log.log('Envio de ticket a POST de API exitoso');
                    $log.log(error);
                });
            }

            vm.showToastr = showToastr;

            function showToastr() {
                toastr.success('Su mensaje ha sido enviado exitosamente');
                vm.classAnimation = '';
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('portalProveedores')
           .factory('reportesConfigFactory', reportesConfigFactory);

    /** @ngInject */
    function reportesConfigFactory(moment) {

        var vm = this;
        
        vm.dataFactory = {
            getDateRangePickerDefaults: getDateRangePickerDefaults,
            getChartJSOptions: getChartJSOptions
        }

        return vm.dataFactory;

        ///////////////////////////////////////////////////
        function getDateRangePickerDefaults(apply) {                        

            var autoAplica = apply;

            var config = {
                locale: {
                    format: 'DD/MM/YYYY',
                    applyLabel: 'Aplicar',
                    cancelLabel: 'Cancelar',
                    customRangeLabel: 'Especificar Rango'
                },
                autoApply: autoAplica,
                ranges: {
                    'Mes Actual': [moment().startOf('month'), moment().endOf('month')],
                    '&Uacute;ltimos 30 D&iacute;as': [moment().subtract(29, 'days'), moment()],
                    'Mes Anterior': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                    'A&ntilde;o Actual': [moment().startOf('year'), moment().endOf('year')],
                    '&Uacute;ltimos 12 Meses': [moment().subtract(12, 'month'), moment()],
                    'A&ntilde;o Anterior': [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')]
                }
            }

            return config;
        }        

        ////////////////////////////////////////////////
        function getChartJSOptions(chartTitle) {

            var options = {
                title: {
                    display: false,
                    text: chartTitle,
                    fontSize: 35,
                    fontFamily: "'Open Sans', 'Helvetica', 'Arial', sans-serif",
                    fontStyle: 'lighter',
                    padding: 20
                },
                tooltips: {
                    custom: function (tooltip) {
                        if (!tooltip) {
                            return;
                        }
                    }
                },
                legend: {
                    display: true,
                    position: 'top',
                    labels: {
                        fontFamily: "'Open Sans', 'Helvetica', 'Arial', sans-serif",
                        fontSize: 14
                    }
                }
            }

            return options;
        }

    }

})();
(function () {

    'use strict';

    angular.module('portalProveedores')
           .factory('portalSmartFactory', portalSmartFactory);

    /** @ngInject */
    function portalSmartFactory($http, $q, $log, API_URL_SMART, SERVICE_BASE) {

        var urlBase = SERVICE_BASE + API_URL_SMART;
        var dataFactory = {};


        //GET: "api/v1/smart/analistasdocumentos"
        dataFactory.analistasDocumentos = function () {

            var deferred = $q.defer();

            $http.get(urlBase + 'analistasdocumentos').then(function (response) {
                deferred.resolve(response.data);
            });

            return deferred.promise;
        }

        //POST: "ciclovida/{query}"
        //     ej. objeto: DateTime[] listaPeriodos, string analista
        dataFactory.cicloVida = function (query) {

            var deferred = $q.defer();

            $http.post(urlBase + 'ciclovida', query).then(success, error);

            function success(response) {                
                deferred.resolve(response.data);
                $log.log('REPORTE CICLO VIDA: Datos obtenidos con exito.');
            }
            
            function error(error) {
                deferred.reject(error);
                $log.warn('REPORTE CICLO VIDA: Datos no pudieron ser obtenidos con exito.');
            }

            return deferred.promise;
        }

        //GET: "api/v1/smart/detalledocumento/{facturaID:int}"
        dataFactory.detalleDocumento = function (facturaid) {
            var deferred = $q.defer();

            $http.get(urlBase + 'detalledocumento/' + facturaid).then(function (response) {
                deferred.resolve(response.data);
            });

            return deferred.promise;
        }

        //GET: "api/v1/smart/getyears" Obtiene anhos de los documentos (distinct)
        dataFactory.yearsDocumentos = function () {
            var deferred = $q.defer();

            $http.get(urlBase + 'getyears').then(function (response) {
                deferred.resolve(response.data);
            });

            return deferred.promise;

        }


        //GET: "api/v1/smart/barraestado"
        dataFactory.infoBarraEstado = function () {
            var deferred = $q.defer();

            $http.get(urlBase + 'barraestado').then(function (response) {
                deferred.resolve(response.data);
            });

            return deferred.promise;
        }

        //GET: "api/v1/smart/ticketsperformance/{inicio:datetime?}/{fin:datetime?}/{todosPeriodos:bool?}"
        //     ej.: /api/v1/smart/ticketsperformance/2016-01-01/2016-01-02/false
        dataFactory.ticketsPerformance = function (query) {

            var deferred = $q.defer();            

            $http.post(urlBase + 'ticketsperformance', query).then(function (response) {
            //$http.get(urlBase + 'ticketsperformance/' + inicio + '/' + fin + '/' + todosPeriodos + '/').then(function (response) {
                deferred.resolve(response.data);
                $log.log('Performance');
                $log.log(response.data)
            });

            return deferred.promise;

        }
        
        return dataFactory;
    }
})();
(function () {

    'use strict';

    angular.module('portalProveedores')
           .factory('portalDataFactory', portalDataFactory);

    /** @ngInject */
    function portalDataFactory($http, $q, $log, API_URL_BASE, SERVICE_BASE) {

        var urlBase = SERVICE_BASE + API_URL_BASE;
        var dataFactory = {};


        // GET: api/v1/facturas/{numero:int}/desde/{desde:datetime}/hasta/{hasta:datetime}
        dataFactory.getFechas = function (numero, desde, hasta) {
            return $http.get(urlBase + numero + '/desde/' + desde + '/hasta/' + hasta);
        };


        // Obtiene FACTURAS para un PROVEEDOR en particular        
        // GET: api/v1/facturas/{proveedorid}/emision/desde/{desde:datetime}/hasta/{hasta:datetime}/{estado}
        dataFactory.getFacturasProveedor = function (proveedorid, desde, hasta, estado) {
            return $http.get(urlBase + proveedorid + '/emision' + '/desde/' + desde + '/hasta/' + hasta + '/' + estado);
        };

        // GET: api/v1/facturas/{proveedorid}/pagadas/{fechaPago:datetime}
        dataFactory.getFacturasProveedorPagadas = function (proveedorid, fechaPago) {
            return $http.get(urlBase + proveedorid + '/pagadas/' + fechaPago);
        };

        //api/v1/facturas/{customerId}/folio/{folio}
        dataFactory.getFacturaDetalle = function (customerId, facturaID) {
            return $http.get(urlBase + customerId + '/detalle/' + facturaID);
        }

        //api/v1/facturas/proveedorid}/{numeroFactura:int}
        dataFactory.getFacturaPorNumero = function (customerId, numeroFactura) {
            return $http.get(urlBase + customerId + '/' + numeroFactura);
        }

        // POST: api/v1/facturas/mailcontacto
        dataFactory.postMailContacto = function (ticket) {
            return $http.post(urlBase + 'mailcontacto/', ticket);
        }

        // GET: api/v1/facturas/formulariocontacto/responsables
        dataFactory.getResponsablesFormularioContacto = function () {
            var deferred = $q.defer();

            $http.get(urlBase + 'formulariocontacto/responsables')
            .then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                $log.warn('FORMULARIO CONTACTO. Fallo enviando mensaje');
                deferred.reject(error);
            });

            return deferred.promise;

        }

        // POST: api/v1/facturas/formulariocontacto/enviar
        dataFactory.postFormularioContacto = function (formulario) {
            return $http.post(urlBase + 'formulariocontacto/enviar', formulario);
        }


        // Obtiene sólo las fechas de los pagos del proveedor
        // GET: api/v1/{proveedorid}/fechaspagos
        dataFactory.getFechasPagos = function (proveedorid) {
            var deferred = $q.defer();

            $http.get(urlBase + proveedorid + '/fechaspagos')
                .then(function (response) {
                    $log.log('EXITO en FECHAS PAGOS Svc (deferred)');
                    $log.log(response);
                    deferred.resolve(response.data);
                }, function (error) {
                    $log.warn('Fallo en FECHAS PAGOS Svc (deferred)');
                    deferred.reject(error);
                });

            return deferred.promise;
        };


        // Obtiene FAQ desde API
        // GET: api/v1/faq
        dataFactory.getPreguntasFaq = function () {
            var deferred = $q.defer();

            $http.get(urlBase + 'faq')
            .then(function (response) {
                $log.log('EXITO obteniendo FAQs (deferred)');
                $log.log(response);
                deferred.resolve(response.data);
            }, function (error) {
                $log.warn('FALLO obteniendo FAQs (deferred)');
                deferred.reject(error);
            });

            return deferred.promise;
        };

        // Chequea si usuario que intenta registrar tiene registros ACTUALES
        // GET: api/v1/facturas/account/checkuser/{rutProveedor}
        dataFactory.checkUser = function (rutProveedor) {
            var deferred = $q.defer();

            $http.get(urlBase + 'account/checkuser/' + rutProveedor)
            .then(function (response) {
                $log.log('EXITO obteniendo CheckUser : ' + response.data);
                deferred.resolve(response.data);
            }, function (error) {
                $log.warn('FALLO obteniendo CheckUser');
                deferred.reject(error);
            });

            return deferred.promise;
        };

        // Chequea si usuario que intenta registrar tiene registros ACTUALES
        // POST: api/v1/facturas/account/forgotpassword"
        dataFactory.forgotPassword = function (datosUsuario) {
            var deferred = $q.defer();

            var sender = {
                rutProveedor: datosUsuario.nombreUsuario,
                baseUrlAPI: datosUsuario.baseUrlAPI
            };

            $http.post(urlBase + 'account/forgotpassword', sender)
            .then(function (response) {
                $log.log('EXITO obteniendo CheckRegisteredUser');
                $log.log(response.data);
                deferred.resolve(response.data);
            }, function (error) {
                $log.warn('FALLO obteniendo CheckRegisteredUser');
                deferred.reject(error);
            });

            return deferred.promise;
        };

        dataFactory.resetPassword = function (datosUsuario) {

            var deferred = $q.defer();

            $http.post(urlBase + 'account/resetpassword', datosUsuario)
                .then(function (response) {
                    $log.log('CAMBIO de password exitoso.');
                    deferred.resolve(response.data);
                }, function (error) {
                    $log.warn('CAMBIO de password fallo');
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        // Envía información de usuario a la API para enviar correo de reestablecer contraseña
        // POST: api/v1/facturas/account/checkuser/{rutProveedor}
        dataFactory.checkRegisteredUser = function (rutProveedor) {
            var deferred = $q.defer();

            $http.get(urlBase + 'account/checkregistereduser/' + rutProveedor)
            .then(function (response) {
                $log.log('EXITO obteniendo CheckRegisteredUser : ' + response.data);
                $log.log(response.data);
                deferred.resolve(response.data);
            }, function (error) {
                $log.warn('FALLO obteniendo CheckRegisteredUser');
                deferred.reject(error);
            });

            return deferred.promise;
        };

        // Obtiene documentos de la plataforma para Proveedores como manuales e instructivos
        // GET: api/v1/facturas/documentos
        dataFactory.getDocumentos = function () {
            var deferred = $q.defer();

            $http.get(urlBase + 'documentos')
            .then(function (response) {
                $log.log('EXITO obteniendo documentos : ' + response.data);
                deferred.resolve(response.data);
            }, function (error) {
                $log.warn('FALLO obteniendo documentos');
                deferred.reject(error);
            });

            return deferred.promise;
        };

        // OBTIENE información del usuario en función del token.
        // GET: api/v1/facturas/account/modify
        dataFactory.getUserTokenInfo = function () {

            var deferred = $q.defer();

            $http.get(urlBase + 'account/modify').
                then(function (response) {
                    $log.log('getUserInfoToke(). EXITO obteniendo info usuario : ' + response.data);
                    deferred.resolve(response.data);
                }, function (error) {
                    $log.warn('getUserInfoToke(). FALLO obteniendo info usuario');
                    deferred.reject(error);
                });

            return deferred.promise;
        };

        // POSTEA información del usuario en función del token.
        // POST: api/v1/facturas/account/modify -> recibe UsuarioDatosDTO
        dataFactory.postUserTokenInfo = function (userData) {
            return $http.post(urlBase + 'account/modify', userData);
        };


        // Test para ver si la API retorna la información del usuario basado en su token (bearer)
        // GET: api/v1/facturas/test/usernames
        dataFactory.testCheckUsuario = function () {

            var deferred = $q.defer();

            $http.get(urlBase + 'test/usernames')
            .then(successCallback, errorCallback);

            function successCallback(response) {
                $log.debug('Exito retornando informacion usuario. UserSvC');
                $log.debug(response);
                deferred.resolve(response.data);
            }

            function errorCallback(error) {
                $log.debug('Exito retornando informacion usuario. UserSvC');
                $log.debug(error);
                deferred.reject(error);
            }

            return deferred.promise;
        };



        dataFactory.getCustomersByProveedor = function (id) {
            return $http.get(urlBase + '/proveedor/' + id + '/facturas');
        };

        // api/v1/facturas/{customerid}/proveedorinfo
        dataFactory.getCustomerInfo = function (id) {
            return $http.get(urlBase + id + '/proveedorinfo');
        };

        dataFactory.insertCustomer = function (cust) {
            return $http.post(urlBase, cust);
        };

        dataFactory.updateCustomer = function (cust) {
            return $http.put(urlBase + '/' + cust.ID, cust)
        };

        dataFactory.deleteCustomer = function (id) {
            return $http.delete(urlBase + '/' + id);
        };

        dataFactory.getOrders = function (id) {
            return $http.get(urlBase + '/' + id + '/orders');
        };

        return dataFactory;
    }
})();
(function () {
    'use strict';

    angular.module('portalProveedores')
           .factory('portalIntroFactory', portalIntroFactory);

    /** @ngInject */
    function portalIntroFactory() {

        var vm = this;
        var dataFactory = {};

        //Defaults Intro.js
        vm.showStepNumbers = true,
        vm.showBullets = true,
        vm.exitOnOverlayClick = true,
        vm.exitOnEsc = true,
        vm.nextLabel = '<strong>SIGUIENTE <i class="fa fa-arrow-right" aria-hidden="true"></i></strong>',
        vm.prevLabel = '<span><i class="fa fa-arrow-left" aria-hidden="true"></i> Anterior</span>',
        vm.skipLabel = 'Salir <i class="fa fa-times" aria-hidden="true"></i>',
        vm.doneLabel = 'Gracias! <i class="fa fa-check" aria-hidden="true"></i>'
      

        
        //TODO: Terminar los pasos para el tutorial
        //Pasos para estado WELCOME...
        vm.welcomeSteps = [
            {
                intro: '<h1>Bienvenido</h1><p>En este peque&ntilde;o tutorial revisaremos las caracter&iacute;sticas y funcionaliades de la p&aacute;gina de inicio del Portal Proveedores Metso. Podr&aacute; acceder a este tutorial todas las veces que desee, le explicaremos c&oacute;mo a continuaci&oacute;n</p>',
                tooltipClass: 'intro-tooltip-big'
            },
            {
                element: '#intro-tutorial-link',
                intro: "<h3>Ver Tutorial</h3><p>Siempre podr&aacute; ver los tutoriales para todas nuestras secciones haciendo click en este link</p>",
                position: 'left',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: '#intro-jumbotron-seccion',
                intro: "<h3>Encabezado & Documentos</h3><p>Este encabezado se encuentra en todas nuestras secciones, contendr&aacute; informaci&oacute;n relevante respecto a la secci&oacute;n actual y los documentos de consulta</p>",
                position: 'left',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                intro: "<h1>Informaci&oacute;n & Recursos</h1><p>Metso proporciona a nuestros proveedores un conjunto de recursos para consulta con el fin de resolver dudas y ayudar a comprender el funcionamiento de nuestros procesos internos con nuestros Proveedores</p>",
                tooltipClass: 'intro-tooltip-big'
            },
            {
                element: "#intro-faq-welcome",
                intro: "<h3>Preguntas Frecuentes</h3><p>Resuelven preguntas com&uacute;nmente realizadas por nuestros Proveedores respecto a los horarios de funcionamiento, consultas, etc.</p>",
                position: 'right',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: "#intro-faq-welcome",
                intro: "<h3>Siempre disponibles</h3><p>Las Preguntas Frecuentes pueden ser consultadas en todo momento sin perder el trabajo que est&eacute; realizando haciendo click en el link en el pie de p&aacute;gina</p>",
                position: 'right',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: "#intro-docs-welcome",
                intro: "<h3>Documentos</h3><p>Los documentos disponibles aqu&iacute; son los mismos que est&aacute;n disponibles en el encabezado de cada secci&oacute;n</p>",
                position: 'left',
                tooltipClass: 'intro-tooltip-normal'
            },            
            {
                element: '#intro-login-welcome',
                intro: "<h3>Iniciar Sesi&oacute;n</h3><p>Para poder operar en nuestro Portal de Proveedores primero debe iniciar sesi&oacute;n con su RUT DE PROVEEDOR y la contrase&ntilde;a que defini&oacute; al momento de registrarse en nuestro sistema</p>",
                position: 'left',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: '#intro-login-welcome',
                intro: "<h3>Datos de Registro</h3><p>Una vez iniciada su sesi&oacuten;, en este mismo recuadro podr&aacute; ver su informaci&oacute;n de registro y editarla</p>",
                position: 'left',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                intro: '<h1>Registro de Usuario</h1><p>Si es primera vez que ingresa a nuestro sistema primero debe registrarse, puede acceder al m&oacute;dulo de registro mediante el men&uacute; superior. <strong>No existen Proveedores registrados por parte de Metso, todos los proveedores deben registrarse.</strong></p>',
                tooltipClass: 'intro-tooltip-big'                
            },
            {
                intro: '<h1>Tutoriales <i class="fa fa-graduation-cap" aria-hidden="true"></i></h1><p>Cada vez que vea un link con el &iacute;cono <i class="fa fa-graduation-cap"></i> corresponder&aacute; a un tutorial que al hacer click, desplegar&aacute; un tutorial en espec&iacute;fico. Los tutoriales no afectan el trabajo que est&eacute; realizando</p>',
                tooltipClass: 'intro-tooltip-big'                
            },
            {
                intro: '<h1>¡Muchas Gracias!</h1><p>Recuerde que <strong>cada secci&oacute;n</strong> de nuestro Portal cuenta con un tutorial similar a este en caso de dudas, puede activarlo en cualquier momento con el link <i class="fa fa-graduation-cap"></i> respectivo en el pie de p&aacute;gina</p>',
                tooltipClass: 'intro-tooltip-big'
            }
        ];

        vm.mainFiltrosSteps = [
            {
                element: '#caja-filtro-periodo',
                intro: "<h3>Buscar Documentos</h3><p>A continuaci&oacute;n revisaremos los filtros disponibles para consultar sus documentos</p>",
                position: 'right',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: '#caja-filtro-periodo',
                intro: "<h3>Buscar por Per&iacute;odo</h3><p>Este formulario le permite revisar todos sus documentos por un rango de fechas en espec&iacute;fico y/o por ESTADO de los mismos</p>",
                position: 'right',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: '#resumen-periodo',
                intro: '<h3>Definir el Per&iacute;odo</h3><p>Al hacer click en este campo puede seleccionar un per&iacute;odo espec&iacute;fico para su consulta, el per&iacute;odo por defecto seleccionado es el <strong>MES ACTUAL<strong></p>',
                position: 'right',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: '#resumen-periodo',
                intro: '<h3>Per&iacute;odos Disponibles</h3><p>Puede seleccionar consultar sus documentos por:</p><ul><li>Mes Actual</li><li>&Uacute;ltimos 30 D&iacute;as</li><li>Mes Anterior</li><li>A&ntilde;o Actual (YTD)</li><li>&Uacute;ltimos 12 Meses</li><li>A&ntilde;o Anterior</li></ul>',
                position: 'right',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: '#filtro-estado-documento',
                intro: '<h3>Seleccionar Estado</h3><p>Junto con el per&iacute;odo adem&aacute;s puede consultar por documentos con alg&uacute;n estado en particular. Por defecto, se consultar&aacute;n todos los documentos con CUALQUIER estado</p>',
                position: 'right',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: '#btn-buscar-periodo',
                intro: '<h3>Buscar Documentos</h3><p>Una vez seleccionados sus filtros de b&uacute;squeda puede hacer click en el bot&oacute;n de b&uacute;squeda. Los resultados se mostrar&aacute;n en una tabla que se desplegar&aacute; m&aacute;s abajo</p>',
                position: 'right',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: '#caja-filtro-nrofactura',
                intro: '<h3>Buscar por Nro. Factura</h3><p>En caso de que necesite buscar una factura en particular por su <strong>n&uacute;mero de documento</strong> puede hacerlo a trav&eacute;s de este formulario. Posteriormente debe presionar el bot&oacute;n de b&uacute;squeda <strong>BUSCAR FACTURA</strong>. El n&uacute;mero de documento es el correlativo correspondiente a sus facturas</p>',
                position: 'left',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: '#caja-filtro-fechapago',
                intro: '<h3>Buscar por Fechas de Pago</h3><p>Este formulario toma todas las <strong>fechas de pago</strong> que tienen sus documentos, por lo tanto retornar&aacute; documentos que est&eacute;n con estado <strong>PAGADO</strong>. La finalidad de esta opci&oacute;n es poder verificar a qu&eacute; documentos corresponde alg&uacute;n pago realizado por Metso a usted</p>',
                position: 'left',
                tooltipClass: 'intro-tooltip-normal'
            },
            {                
                intro: '<h3>Filtros Independientes</h3><p>Todos los formularios de b&uacute;squeda son totalmente independientes entre s&iacute;. Los criterios de b&uacute;squeda que se encuentren en uno no afectan a los dem&aacute;s</p>',
                tooltipClass: 'intro-tooltip-big'
            }
        ];
                
        vm.mainResultadosSteps = [
            {
                element: '#tabla-resultados',
                intro: "<h3>Tabla Resultados</h3><p>Esta tabla muestra los resultados generados por su consulta. Cada columna representa un atributo de los documentos obtenidos desde nuestro Portal Proveedores. Todas las columnas cuentan con la opci&oacute;n de ordenar de manera ascendente/descendente y algunas permiten filtrar los resultados</p>",
                position: 'top',
                tooltipClass: 'intro-tooltip-normal'
            },
            {                
                element: '.ng-table-filters',
                intro: "<h3>Filtrar Resultados</h3><p>Algunas columnas permiten filtrar los resultados, en el caso de los valores correspondientes a dinero no es necesario agregar puntuaciones o s&iacute;mbolos especiales. Los filtros no discriminan entre may&uacute;sculas y/o min&uacute;sculas</p>",
                position: 'top',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: '#res-nrodoc-0',
                intro: "<h3>N&uacute;mero de Documento</h3><p>Corresponde al n&uacute;mero correlativo de sus facturas</p>",
                position: 'right',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: '#res-fechadoc-0',
                intro: "<h3>Fecha Emisi&oacute;n Documento</h3><p>Es la fecha que tiene el documento como fecha de emisi&oacute;n. Para permitir un correcto filtrado y ordenamiento de los valores, es necesario usar el formato <strong>aaaa-mm-dd</strong> (año-mes-d&iacute;a) para las fechas</p>",
                position: 'right',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: '#res-fecharecepciondoc-0',
                intro: "<h3>Fecha Recepci&oacute;n Documento</h3><p>Corresponde a la fecha en que el documento fue recibido por nuestro departamento de Contabilidad</p>",
                position: 'right',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: '#res-montodoc-0',
                intro: "<h3>Monto del Documento</h3><p>Monto total especificado en el documento</p>",
                position: 'right',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: '#res-pagadodoc-0',
                intro: "<h3>Monto Pagado</h3><p>En caso de que el estado del documento sea <strong>PAGADO</strong> mostrar&aacute; la cantidad pagada. En ciertos casos, algunos documentos son pagados en parcialidades</p>",
                position: 'left',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: '#res-estadodoc-0',
                intro: "<h3>Estado del Documento</h3><p>Existen 5 estados para los documentos: Recibido, Contabilizado, Devuelto, Rechazado y Pagado. La fila y el identificador del docuento cambiar&aacute; de color en funci&oacute;n de su estado</p>",
                position: 'left',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: '#res-ticketsdoc-0',
                intro: "<h3>Tickets Generados</h3><p>Muestra la cantidad de tickets de consulta generados para el documento por usted. En la vista de <strong>DETALLE</strong> se pueden generar estos tickets de soporte, por supuesto en la vista de DETALLE existe un tutorial id&eacute;ntico a este explicando su funcionamiento</p>",
                position: 'left',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: '#res-detalledoc-0',
                intro: "<h3>Abrir Detalle del Documento</h3><p>Este bot&oacute;n abre la vista de <strong>DETALLE</strong> para el documento. En esa vista podr&aacute; ver informaci&oacute;n detallada del documento y generar tickets de soporte</p>",
                position: 'left',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: '#res-totales',
                intro: "<h3>Totales</h3><p>En esta fila se muestran los totales correspondientes a las columnas de MONTO DOCUMENTO y CANTIDAD PAGADA. Suma todos los valores de cada una de esas columnas</p>",
                position: 'top',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: '.ng-table-counts ',
                intro: "<h3>Cantidad de Registros por Tabla</h3><p>Por defecto, el Portal de Proveedores desplegar&aacute; los primeros 25 registros, ac&aacute; puede definir una cantidad mayor o menor. Todos los registros fueron cargados en funci&oacute;n de los criterios de b&uacute;squeda que seleccion&oacute;, la idea de esto es facilitar la visualizaci&oacute;n</p>",
                position: 'left',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                intro: '<h1>Hemos finalizado</h1><p>Esas son las caracter&iacute;sticas de la tabla de resultados de sus documentos consultados en el Portal de Proveedores Metso. Recuerde que en la vista de <strong>DETALLE</strong> de cada documento podr&aacute; consultar un tutorial similar a este explicando su funcionamiento. Muchas gracias.</p>',
                tooltipClass: 'intro-tooltip-big'
            }
        ];

        vm.detalleSteps = [
            {
                element: '#detalle-resumen-doc',
                intro: '<h3>Encabezado Documento</h3><p>Muestra el n&uacute;mero de documento, el monto asociado y el <strong>estado</strong> del documento</p>',
                position: 'right',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: '#detalle-fechas-doc',
                intro: '<h3>Fechas del Documento</h3><p>Se detallan las fechas asociadas al documento. En caso de los documentos <strong>CONTABILIZADOS</strong> se muestra la <strong>fecha probable de pago</strong>; para los documentos <strong>PAGADOS</strong> se muestra la <strong>fecha de pago</strong></p>',
                position: 'left',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: '#detalle-barra-doc',
                intro: '<h3>Barra de Estado</h3><p>La barra detalla el estado en que se encuentra el documento y su correspondiente descripci&oacute;n. Los documentos <strong>RECHAZADOS</strong> contienen un <strong>glosa de rechazo</strong> detallando el por qu&eacute; fue rechazado el documento</p>',
                position: 'top',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: '#detalle-info-doc',
                intro: '<h3>Informaci&oacute;n Detallada</h3><p>Muestra el nombre del proveedor, RUT, n&uacute;mero de documento y el tipo de documento especificando si es electr&oacute;nico o f&iacute;sico</p>',
                position: 'right',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: '#detalle-infoestado-doc',
                intro: '<h3>Detalles sobre el Estado</h3><p>Describe el <strong>ESTADO</strong> del documento y var&iacute;a seg&uacute;n el mismo. Cuando el documento fue <strong>RECHAZADO</strong> mostrar&aacute; la raz&oacute;n del rechazo y la fecha correspondiente, en caso de que el documento se encuentre pagado mostrar&aacute; la informaci&oacute; del pago y la fecha de pago</p>',
                position: 'left',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: '#detalle-ticket-doc',
                intro: '<h3>Genere Tickets de Soporte</h3><p>En caso de que tenga <strong>consultas espec&iacute;ficas para un documento</strong> en este formulario puede elaborar un ticket de soporte el cual ser&aacute; gestionado por nuestro personal y la respuesta ser&aacute; enviada al correo que defina aqu&iacute;</p>',
                position: 'left',
                tooltipClass: 'intro-tooltip-normal'
            },
            {
                element: '#detalle-ticket-doc',
                intro: '<h3>Respuestas a Tickets</h3><p>La respuesta a su ticket ser&aacute; enviada al correo electr&oacute;nico que especifique, adem&aacute;s, pordr&aacute; ser visualizado en esta misma secci&oacute;n en un listado desplegado en la parte superior de este formulario</p>',
                position: 'left',
                tooltipClass: 'intro-tooltip-normal'
            }
        ];

        vm.ingresarSteps = [

        ];

        

        dataFactory.getIntroJSOptions = function (estado) {

            var pasos = [];

            switch (estado) {
                case 'home':
                    pasos = vm.welcomeSteps;
                    break;
                case 'mainFiltros':
                    pasos = vm.mainFiltrosSteps;
                    break;
                case 'mainResultados':
                    pasos = vm.mainResultadosSteps;
                    break;
                case 'detalle':
                    pasos = vm.detalleSteps;
                    break;
                default:
                    pasos = [];
                    break;
            }

            var options = {
                steps: pasos,
                showStepNumbers: vm.showStepNumbers,
                showBullets: vm.showBullets,
                exitOnOverlayClick: vm.exitOnOverlayClick,
                exitOnEsc: vm.exitOnEsc,
                nextLabel: vm.nextLabel,
                prevLabel: vm.prevLabel,
                skipLabel: vm.skipLabel,
                doneLabel: vm.doneLabel
            }

            return options;
        };

        return dataFactory;


    }

})();
(function(){
    'use strict';

    angular
        .module('portalProveedores')
        .factory('portalAuthverifierFactory', portalAuthverifierFactory);

    /** @ngInject */
    function portalAuthverifierFactory(localStorageService, $location, $log) {

        var portalAuthverifierFactory = {};

        var _verifier = function () {
            var authData = localStorageService.get('authorizationData');

            if (authData != null) {
                $log.info('Existe un usuario y token. Usuario : ' + authData.userName);
                return true;
            }
            else {
                $log.warn('NO EXISTE un nombre de usuario');
                _redirect();
                return false;
            }
        }

        var _redirect = function () {
            $log.log('Usuario sin loguear, redirigiendo a LOGIN.');
            $location.path('/');
        }

        portalAuthverifierFactory.verifier = _verifier;
        portalAuthverifierFactory.redirect = _redirect;

        return portalAuthverifierFactory;
    }

    

})();
(function () {

    'use strict';

    angular
      .module('portalProveedores')
      .controller('ReportesController', ReportesController);

    /** @ngInject */
    function ReportesController() {

              
                     
                   

        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        //activate(); //run Forrest, RUN!        


        // FUNCIONES Y ASIGNACIONES
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        
        //function activate() {                        
        //}
        
        ////////////////////////////////////////////////////////        

        

        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


    }

})();
(function () {
    'use strict';

    angular
      .module('portalProveedores')
      .controller('MainController', MainController);

    /** @ngInject */
    function MainController($timeout, $log, toastr, authService, localStorageService, portalDataFactory, moment, NgTableParams, portalAuthverifierFactory, $state, $rootScope, portalIntroFactory, API_URL_BASE, SERVICE_BASE) {

        var vm = this; //scope

        portalAuthverifierFactory.verifier();

        vm.urlBase = SERVICE_BASE + API_URL_BASE + 'autocomplete/proveedores/';

        //Datos para intro TUTORIALES
        vm.introFiltrosOptions = []
        vm.introResultadosOptions = [];

        vm.cargaIntroOptions = (function () {
            vm.introFiltrosOptions = portalIntroFactory.getIntroJSOptions('mainFiltros');
            vm.introResultadosOptions = portalIntroFactory.getIntroJSOptions('mainResultados');
        })();

        //Tabla
        vm.tableParams = new NgTableParams({
            page: 1, // show first page
            count: 25 // count per page
        }, {
            filterDelay: 0,
            data: null
        });

        vm.nombreColumnaFecha = 'Fecha Factura';
        vm.columnaSuccess = false;
        vm.esDocumentosPagados = false;


        vm.totalDocumentosEmitidos = 0;
        vm.totalDocumentosPagados = 0;

        //Fechas
        vm.hoy = moment();

        vm.datePicker = {};

        vm.datePicker.date = {
            startDate: moment().startOf('month'),
            endDate: moment().endOf('month')
        }

        //Usuario
        vm.proveedorInfo;
        vm.authentication = authService.authentication;
        vm.authData = localStorageService.get('authorizationData'); //TOKEN DE ACCESO
        vm.usuario = vm.authData.userName;

        vm.getUserInfo = function (proveedor) {
            portalDataFactory.getCustomerInfo(proveedor)
            .then(function (response) {
                vm.proveedorInfo = response.data;
            }, function (error) {
                $log.log('Fall� la API obteniendo Info Usuario (MIGRAR A IDENTITYUSER)');
                $log.log(error);
            });
        };

        //Objeto consulta
        vm.consultaDocumento = {};
        vm.consultaDocumento.estado = 'todos'; //Inicia DDL en estado TODOS para consulta

        vm.documentosProveedor;

        vm.getDocumentos = function () { //Obtiene documentos EMITIDOS en el rango de fechas
            var proveedorid = vm.usuario;
            var desde = vm.datePicker.date.startDate.format('YYYY-MM-DD');
            var hasta = vm.datePicker.date.endDate.format('YYYY-MM-DD');
            var estado = vm.consultaDocumento.estado;

            portalDataFactory.getFacturasProveedor(proveedorid, desde, hasta, estado)
            .then(function (response) {

                vm.nombreColumnaFecha = 'Fecha Doc.'; //da nombre a columna
                vm.columnaSuccess = false; //agrega clase a <td> para se�alar fecha de pago
                vm.esDocumentosPagados = false;

                vm.documentosProveedor = response.data;
                vm.tableParams.settings({
                    dataset: vm.documentosProveedor
                });

                vm.calculaTotalesDocumentos(response.data);

                $log.log(response.data)
            }, function (error) {
                $log.log('GET LISTADO DOCUMENTOS (API: GetFacturasProveedor(proveedorid, desde, hasta, estado) fallo en la consulta.');
                $log.log(error);
            });
        }

        vm.getDocumentosPagados = function () {

            vm.nombreColumnaFecha = 'Fecha Pago'; //da nombre a columna
            vm.columnaSuccess = true; //agrega clase a <td> para se�alar fecha de pago
            vm.esDocumentosPagados = true;

            var proveedorId = vm.usuario;
            var fechaPago = vm.fechaPagoSeleccionada;

            function successCallback(response) {
                vm.documentosProveedor = response.data;
                vm.tableParams.settings({
                    dataset: vm.documentosProveedor
                });
                vm.calculaTotalesDocumentos(response.data);
            }
            function errorCallback(error) {
                $log.log('Falla en carga de Documentos Pagados =( : ' + error);
            }

            portalDataFactory.getFacturasProveedorPagadas(proveedorId, fechaPago).then(successCallback, errorCallback);
        }

        // TODO: Terminar m�todo de carga de Facturas por folio. Ver como crear 2-way-binding desde UI y no desde controlador para sobrecargar el Numero de Factura
        vm.getDocumentosPorNumero = function (numeroFactura) {

            var proveedorId = vm.usuario;

            function successCallback(response) {
                vm.documentosProveedor = response.data;
                vm.tableParams.settings({
                    dataset: vm.documentosProveedor
                });
            }

            function errorCallback(error) {
                $log.warn('Falla en carga de Documento por Numero Factura =( :');
                $log.warn(error);
            }

            portalDataFactory.getFacturaPorNumero(proveedorId, numeroFactura).then(successCallback, errorCallback);
        }

        // FECHAS PAGOS
        vm.fechasPagos = [];
        vm.fechaPagoSeleccionada;

        vm.getFechasPagos = function () {
            portalDataFactory.getFechasPagos(vm.usuario)
                .then(function (response) {
                    $log.log('Fechas Pagos : ');
                    $log.log(response);
                    vm.fechasPagos = response;
                }, function (response) {
                    $log.log('No fue posible obtener fechas de pagos para el provedor');
                    $log.log(response);
                });
        }



        vm.calculaTotalesDocumentos = function (documentos) {
            var totalE = 0;
            var totalP = 0;

            for (var i = 0; i < documentos.length; i++) {

                var docE = documentos[i].montoTotal;
                var docP = documentos[i].montoPagado;

                if (docE == null) {
                    docE = 0;
                }

                if (docP == null) {
                    docP = 0;
                }

                totalE += docE;
                totalP += docP;
            }

            vm.totalDocumentosEmitidos = totalE;
            vm.totalDocumentosPagados = totalP;
        }


        vm.showToastr = showToastr;

        function showToastr() {
            toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" target="_blank"><b>generator-gulp-angular</b></a>');
            vm.classAnimation = '';
        }


        // notifica estado a FOOTER para parametrizar Tutorial
        vm.notificaEstado = (function () {
            $rootScope.$emit('intro', $state.current.name);
        })();

        // autocomplete seleccion proveedor para admin
        vm.adminProveedor = {};

        vm.adminProveedorCallback = function (item) {
            if (item != 'undefined' && item != null) {
                vm.usuario = item.description;
                vm.adminProveedor = item;
                toastr.info(vm.usuario, 'Consultando como:');
                vm.getFechasPagos();

                portalDataFactory.checkRegisteredUser(item.description).then(function (response) {

                    //nombreUsuario = user.UserName,
                    //emailUsuario = user.Email,
                    //razonSocial = user.RazonSocial,
                    //nombreEncargado = user.NombreEncargado

                    if (response == null) {
                        vm.adminProveedor.emailUsuario = 'SIN REGISTRAR';
                        vm.adminProveedor.nombreEncargado = 'SIN REGISTRAR';
                    } else {
                        vm.adminProveedor.emailUsuario = response.emailUsuario;
                        vm.adminProveedor.nombreEncargado = response.nombreEncargado;
                    }
                });

                $log.debug('AdminProveedor (CheckRegisteredUser):');
                $log.debug(vm.adminProveedor);
                

            }
        }

        //RUN FORREST RUN!
        vm.getUserInfo(vm.authentication.userName);
        vm.getFechasPagos();

    }
})();

(function () {

    'use strict';

    angular
      .module('portalProveedores')
      .controller('LoginController', LoginController);
    
    /** @ngInject */
    function LoginController($location, authService, $log) {

        var vm = this;

        //Patrón RUT
        vm.patronRut = /\b\d{1,8}\-[K|k|0-9]/;
        vm.formatRut = function () {            
            var newUserName = vm.loginData.userName.split('.').join('');
            vm.loginData.userName = newUserName;
0        }

        vm.loginData = {
            userName: "",
            password: ""
        };



        vm.message = "";

        vm.test = "Controller OK";

        vm.login = function () {
            authService.login(vm.loginData).then(function (response) {
                $location.path('/main');
                $log.log('Exito logueando... (LoginCtrl)');
                $log.log(response);
            },
             function (err) {
                 $log.warn('Pasword/Usuario incorrectos. Mensaje : ' + err.error_description);
                 $log.warn('Objeto Error LOGIN : ');
                 $log.warn(err);
                 vm.message = 'El usuario o contraseña son incorrectos';
             });
        };
    }

})();
(function () {

    'use strict';

    angular
      .module('portalProveedores')
      .controller('IngresarController', IngresarController);

    /** @ngInject */
    function IngresarController(portalDataFactory, $log, $stateParams, authService, $rootScope, $state) {

        var vm = this;

        vm.razonLogin = $stateParams.razon;

        vm.getDocumentos = function () {
            portalDataFactory.getDocumentos()
                .then(function (response) {
                    vm.docs = response;
                }, function (error) {
                    $log.warn('WELCOME. No se cargaron documentos. ERROR.');
                    $log.warn(error);
                });            
        }        
        

        vm.correspondeLogOut = function () {
            if(vm.razonLogin == 401 || vm.razonLogin == '401')
            authService.logOut();
        }

        // notifica estado a FOOTER para parametrizar Tutorial
        vm.notificaEstado = (function () {
            $rootScope.$emit('intro', $state.current.name);
        })();

        vm.correspondeLogOut();
        vm.getDocumentos();
        authService.logOut();

    }

})();
(function () {
    'use strict';

    angular
      .module('portalProveedores')
      .directive('faqPortal', faqPortal);

    /** @ngInject */
    function faqPortal() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/faq/faq.html',
            scope: {
                creationDate: '='
            },
            controller: FaqController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;        
    }

    /** @ngInject */
    function FaqController($location, portalDataFactory, $log) {
        var vm = this;
        vm.url = $location.path();

        vm.faqs = []; //array con preguntas

        vm.getFaq = function () {
            portalDataFactory.getPreguntasFaq()
            .then(function (response) {
                vm.faqs = response;
            }, function (error) {
                $log.warn('FAQ. No se cargaron datos. ERROR.');
                $log.warn(error);
            });
        };

        vm.getFaq(); //RUUUUUUUN!
    }

})();

(function() {
    'use strict';

    angular
        .module('portalProveedores')
        .controller('DetalleController', DetalleController);

    /** @ngInject */
    function DetalleController($log, $stateParams, moment, portalDataFactory, localStorageService, portalIntroFactory) {
        var vm = this;

        vm.docID = $stateParams.docID; //ID Factura... se va a servicio

        vm.authData = localStorageService.get('authorizationData'); //TOKEN DE ACCESO
        vm.usuario = vm.authData.userName;

        //Datos para intro TUTORIALES
        vm.introDetalleOptions = {};

        vm.cargaIntroOptions = (function() {
            vm.introDetalleOptions = portalIntroFactory.getIntroJSOptions('detalle');
        })();

        //Desde API...
        vm.documento = {};

        vm.getFacturaDetalle = function(customerId, folio) {
            portalDataFactory.getFacturaDetalle(customerId, folio)
                .then(function(response) {
                    vm.documento = response.data;
                    $log.debug('DETALLE :');
                    $log.debug(response.data);
                }, function(error) {
                    $log.warn('Fall� llamado a DETALLE de documento a la API. Revisar XHR.')
                    $log.log(error);
                });
        };


        //Fecha probable pago...
        vm.fechaPago = function(fecha, dias) {
            var fechaPago = moment(fecha).add(dias, 'd');
            return fechaPago;
        };

        //GENERA FECHA PROBABLE DE PAGO
        vm.generaFechaProbablePago = function(fechaRecepcion, dias) {
            var fechaR;
            var fechaP;
            var dayP = 0;

            if (fechaRecepcion == null) {
                fechaRecepcion = vm.documento.fechaRecepcion;
                fechaR = moment(fechaRecepcion);
                fechaP = fechaR.clone().add(60, 'd'); //Fecha Recepci�n nullo se se asigna la fecha de recepcion mas 60 dias
            } else {
                fechaR = moment(fechaRecepcion); //Fecha Recepci�n
                fechaP = fechaR.clone().add(dias, 'd');
            }
            dayP = fechaP.day()
                //El caso que la fecha no sea dia lunes esta se actualiza hasta que sea el lunes siguiente.
            do {
                if (dayP != 1) {
                    fechaP.add(1, 'd');
                    dayP = fechaP.day();
                }
            } while (dayP != 1);

            return fechaP;
        }

        //RUN
        vm.getFacturaDetalle(vm.usuario, vm.docID);
    }




})();
(function() {
  'use strict';

    // Portal Proveedores
    // prosmart.xyz
    
  angular
    .module('portalProveedores')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, authService) {
      authService.fillAuthData();            
      $log.debug('Corriendo... Desarrollado por prosmart.xyz - Todos los derechos reservados - Chile');
  }
})();



(function () {
    'use strict';

    angular
      .module('portalProveedores')
      .config(routerConfig);

    routerConfig.$inject = ['$stateProvider', '$urlRouterProvider'];

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
          .state('main', {
              url: '/main',
              templateUrl: 'app/main/main.html',
              controller: 'MainController',
              controllerAs: 'vm',
              resolve: {
                  //Usa ui.router.title
                  $title: function () { return 'Documentos' }
              }
          });

        $stateProvider
          .state('main.detalle', {
              url: '/detalledoc/{docID:int}',
              templateUrl: 'app/detalle/detalle.html',
              controller: 'DetalleController',
              controllerAs: 'vm'
          });

        $stateProvider
          .state('home', {
              url: '/',
              views: {
                  '': {
                      templateUrl: 'app/welcome/welcome.html',
                      controller: 'WelcomeController',
                      controllerAs: 'vm'
                  },
                  'login@home': {
                      templateUrl: 'app/login/login.html',
                      controller: 'LoginController',
                      controllerAs: 'vm'
                  }
              },
              resolve: {
                  //Usa ui.router.title
                  $title: function() { return 'Bienvenido' }
              }
          });

        $stateProvider
          .state('signup', {
              url: '/signup',
              templateUrl: 'app/signup/signup.html',
              controller: 'SignupController',
              controllerAs: 'vm',
              resolve: {
                  //Usa ui.router.title
                  $title: function () { return 'Registro' }
              }
          });

        $stateProvider
          .state('ingresar', {
              url: '/ingresar',
              params : {
                razon: null
              },
              views: {
                  '': {
                      templateUrl: 'app/ingresar/ingresar.html',
                      controller: 'IngresarController',
                      controllerAs: 'vm'
                  },
                  'login@ingresar': {
                      templateUrl: 'app/login/login.html',
                      controller: 'LoginController',
                      controllerAs: 'vm'
                  }
              },
              resolve: {
                  //Usa ui.router.title
                  $title: function () { return 'Iniciar Sesion' }
              }
          });

        $stateProvider
          .state('recuperar', {
              url: '/recuperar',
              templateUrl: 'app/recuperarpassword/recuperarpassword.html',
              controller: 'RecuperarpasswordController',
              controllerAs: 'vm',
              resolve: {
                  //Usa ui.router.title
                  $title: function () { return 'Recuperar Password' }
              }
          });

        $stateProvider
          .state('resetPassword', {
              url: '/resetPassword?userId&token', // Matches /resetPassword?userid=Prosmart&token=T0k3n
              templateUrl: 'app/recuperarpassword/resetpassword.html',
              controller: 'ResetpasswordController',
              controllerAs: 'vm',
              params: {
                  docID: 0
              },
              resolve: {
                  //Usa ui.router.title
                  $title: function () { return 'Nuevo Password' }
              }
          });

        $stateProvider
          .state('detalle', {
              url: '/detalle/{docID:int}',
              templateUrl: 'app/detalle/detalle.html',
              controller: 'DetalleController',
              controllerAs: 'vm',
              params: {
                  docID : 0
              }
          });

        $stateProvider
        .state('test', {
            url: '/test',
            templateUrl: 'app/test/test.html',
            controller: 'TestController',
            controllerAs: 'vm'
        });

        $stateProvider
        .state('performance', {
            url: '/performance',
            templateUrl: 'app/reportes/reportes.html',
            controller: 'ReportesController',
            controllerAs: 'vm'
        });

        $stateProvider
        .state('faq', {
            url: '/faq',
            templateUrl: 'app/faq/faq.html',
            controller: 'FaqController',
            controllerAs: 'vm'
        });

        $stateProvider
        .state('userdata', {
            url: '/userdata',
            templateUrl: 'app/userdata/userdata.html',
            controller: 'UserDataController',
            controllerAs: 'vm'
        });


        $urlRouterProvider.otherwise('/');
    }

})();

/* global moment:false */
(function() {
    'use strict';

    angular
        .module('portalProveedores')
        .constant('moment', moment)
        .constant('API_URL_BASE', 'api/v1/facturas/') // URL version portal API
        .constant('API_URL_SMART', 'api/v1/smart/')
        //.constant('DEBUG_INFO', true)
        .constant('DEBUG_INFO', true)
        // .constant('SERVICE_BASE', 'http://localhost:61866/'); //Token autorizaci�n DESARROLLO
        .constant('SERVICE_BASE', 'http://gestionproveedores.metsoadm.cl/'); //Token autorizaci�n PRODUCCION
})();
(function () {
    'use strict';

    angular
      .module('portalProveedores')
      .config(config);

    /** @ngInject */
    function config($compileProvider, $logProvider, DEBUG_INFO, toastrConfig, $httpProvider, $analyticsProvider) {
        //Boosts performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO);

        // Enable log
        $logProvider.debugEnabled(true);

        //Activa tracking para GA
        $analyticsProvider.virtualPageviews(true);

        $httpProvider.interceptors.push('authInterceptorService');

        // Set options third-party lib
        toastrConfig.allowHtml = true;
        toastrConfig.timeOut = 3000;
        toastrConfig.positionClass = 'toast-top-right';
        toastrConfig.preventDuplicates = true;
        toastrConfig.progressBar = true;
    }

})();

(function () {
    'use strict';

    angular.module('portalProveedores').factory('authService', authService);


    /** @ngInject */
    function authService($http, $q, localStorageService, SERVICE_BASE, $log) {

        var serviceBase = SERVICE_BASE; //recibe token de autentificación

        var authServiceFactory = {};

        var _authentication = {
            isAuth: false,
            userName: ""
        };

        var _saveRegistration = function (registration) {

            _logOut();

            return $http.post(serviceBase + 'api/v1/facturas/account/register', registration).then(function (response) {
                return response;
            });

        };

        var _login = function (loginData) {

            var data = "grant_type=password&username=" + loginData.userName + "&password=" + loginData.password;

            var deferred = $q.defer();

            $http.post(serviceBase + 'token', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).success(function (response) {

                localStorageService.set('authorizationData', { token: response.access_token, userName: loginData.userName });

                _authentication.isAuth = true;
                _authentication.userName = loginData.userName;

                deferred.resolve(response);

            }).error(function (err, status) {
                _logOut();
                $log.warn('Error iniciando sesion usuario. (Svc)');
                $log.log(err);
                $log.log(status);
                deferred.reject(err);
            });


            return deferred.promise;


        };

        var _logOut = function () {

            localStorageService.remove('authorizationData');

            _authentication.isAuth = false;
            _authentication.userName = "";

        };

        var _fillAuthData = function () {

            var authData = localStorageService.get('authorizationData');
            if (authData) {
                _authentication.isAuth = true;
                _authentication.userName = authData.userName;
            }

        }

        //Returns...
        authServiceFactory.saveRegistration = _saveRegistration;
        authServiceFactory.login = _login;
        authServiceFactory.logOut = _logOut;
        authServiceFactory.fillAuthData = _fillAuthData;
        authServiceFactory.authentication = _authentication;

        return authServiceFactory;
    }

})();

(function () {

    angular
      .module('portalProveedores')
      .factory('authInterceptorService', authInterceptorService);

    /** @ngInject */
    function authInterceptorService($location, $q, localStorageService, $log, $injector) {
        var authInterceptorServiceFactory = {};

        var _request = function (config) {

            config.headers = config.headers || {};

            var authData = localStorageService.get('authorizationData');
            if (authData) {
                config.headers.Authorization = 'Bearer ' + authData.token;
            }

            return config;
        }

        var _responseError = function (rejection) {
            
            // 401 : Para transacciones NO AUTENTICADAS (SIN inicio de sesión, ANONYMOUS), el token viene malformado o VENCIDO.
            // 403 : Para transacciones PROHIBIDAS (FORBIDDEN), no tiene el rol correcto
            //       El tiempo definido en la API Portal Proveedores es de 8 HORAS (Error 401).

            $log.info('AuthInterceptorService. Rejection Code : ' + rejection.status);
            $log.info(rejection);

            if (rejection.status === 401) {
                //$location.path('/ingresar');
                var status = rejection.status;                
                $injector.get('$state').go('ingresar', { razon: status });
            }
            return $q.reject(rejection);
        }

        authInterceptorServiceFactory.request = _request;
        authInterceptorServiceFactory.responseError = _responseError;

        return authInterceptorServiceFactory;
    }
})();
angular.module("portalProveedores").run(["$templateCache", function($templateCache) {$templateCache.put("app/ingresar/ingresar.html","<div class=\"header-jumbo\"><jumbotron-portal encabezado=\"\'Iniciar Sesi&oacute;n\'\" texto=\"\'Bienvenido al Portal de Proveedores Metso Chile S.A. En caso de requerir m&aacute;s informaci&oacute;n tiene a su disposici&oacute;n los siguientes recursos\'\" con-documentos=\"false\"></jumbotron-portal></div><div class=\"container\" style=\"min-height: 350px;\"><div class=\"row padding-bot-top-35\"><div class=\"col-lg-6 col-sm-12 col-xs-12 padding-bottom-35\"><h1>Iniciar Sesi&oacute;n en el Portal de Proveedores</h1><p>Para poder operar en el Portal de Proveedores Metso Outotec es necesario iniciar sesi&oacute;n con su cuenta de usuario, para eso es necesario haberse registrado como usuario en nuestro Portal. En caso de que no cuente con una cuenta de usuario por favor <a ui-sref=\"signup\">reg&iacute;strese aqu&iacute;</a>.</p><div class=\"alert alert-warning alert-dismissible\" role=\"alert\" ng-show=\"vm.razonLogin == 401\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4>Su sesi&oacute;n ha expirado</h4><p>Una vez que inicia sesi&oacute;n, por razones de seguridad, el Portal de Proveedores permite operar durante 8 horas. Una vez cumplido ese plazo es necesario que inicie sesi&oacute;n nuevamente</p></div></div><div class=\"col-lg-5 col-lg-offset-1 col-sm-12 col-xs-12 form-wrapper padding-col-35\"><div class=\"col-lg-12 text-center\"><i class=\"fa fa-user-plus fa-5x\" aria-hidden=\"true\"></i><h2>Iniciar Sesi&oacute;n</h2><hr></div><div class=\"col-lg-12\"><div ui-view=\"login\"></div></div></div></div></div>");
$templateCache.put("app/detalle/detalle.html","<div class=\"container\" style=\"margin-top: 50px; margin-bottom: 150px;\" smooth-scroll=\"\" offset=\"80\"><div class=\"row\" ng-intro-method=\"TutorialDetalle\" ng-intro-options=\"vm.introDetalleOptions\"><div class=\"col-lg-12 col-sm-12\"><div class=\"row\"><div class=\"col-lg-7 col-xs-12 col-sm-12\"><h2><i class=\"fa fa-eye\"></i> Detalle Documento</h2></div><div class=\"col-lg-5 hidden-xs hidden-sm\"><button class=\"button-special tutorial-span hidden-xs hidden-sm pull-right\" style=\"margin-top: 22px;\" ng-click=\"TutorialDetalle()\">EXPLICAR LA VISTA DE DETALLE</button></div></div><hr></div></div><div class=\"row doc-resumen-header hidden-sm hidden-xs\"><div class=\"col-lg-4 col-sm-12 col-xs-12\" id=\"detalle-resumen-doc\"><p class=\"lead\">NUMERO FACTURA <strong>{{vm.documento.numeroFactura}}</strong></p><h1 ng-show=\"vm.documento.montoTotal != null\">{{vm.documento.montoTotal | currency:$:0}}</h1><h1 ng-show=\"vm.documento.montoTotal == null\">- Sin Monto -</h1><p class=\"lead\"><strong>{{vm.documento.estado | uppercase}}</strong></p></div><div class=\"col-lg-4 hidden-md hidden-sm hidden-xs\"><img ng-show=\"vm.documento.estado == \'PAGADO\'\" src=\"assets/images/metso-pagado.png\" class=\"img-responsive center-block timbre-pagado\"></div><div class=\"col-lg-4 col-sm-12 col-xs-12 text-right\" id=\"detalle-fechas-doc\"><p class=\"lead\">FECHAS DOCUMENTO</p><h4><small>EMISI&Oacute;N</small> {{vm.documento.fechaEmision | date:\'dd/MM/yyyy\'}}</h4><h4><small>RECEPCI&Oacute;N</small> {{vm.documento.fechaRecepcion | date:\'dd/MM/yyyy\'}}</h4><h4 ng-show=\"vm.documento.estado == \'CONTABILIZADO\'\"><small>FECHA PROBABLE PAGO</small> {{vm.generaFechaProbablePago(vm.documento.fechaProbablePago, 0).format(\'DD/MM/YYYY\')}}</h4><h4 ng-show=\"vm.documento.estado == \'PAGADO\'\"><small>FECHA PAGO</small> {{vm.documento.fechaPago | date: \'dd/MM/yyyy\'}}</h4></div></div><div class=\"row doc-resumen-header hidden-md hidden-lg\"><div class=\"col-sm-6 col-xs-6\"><p class=\"lead\">NUMERO FACTURA <strong>{{vm.documento.numeroFactura}}</strong></p><h1 ng-show=\"vm.documento.montoTotal != null\">{{vm.documento.montoTotal | currency:$:0}}</h1><h1 ng-show=\"vm.documento.montoTotal == null\">- Sin Monto -</h1><p class=\"lead\"><strong>{{vm.documento.estado | uppercase}}</strong></p><p style=\"margin-top: 25px;\" class=\"lead\">FECHAS DOCUMENTO</p><h4><small>EMISI&Oacute;N</small> {{vm.documento.fechaEmision | date:\'dd/MM/yyyy\'}}</h4><h4><small>RECEPCI&Oacute;N</small> {{vm.documento.fechaDocumento | date:\'dd/MM/yyyy\'}}</h4><h4 ng-show=\"vm.documento.estado == \'CONTABILIZADO\'\"><small>FECHA PROBABLE PAGO</small> {{vm.generaFechaProbablePago(vm.documento.fechaDocumento, 90).format(\'DD/MM/YYYY\')}}</h4></div></div><hr class=\"hidden-sm hidden-xs\"><div class=\"row hidden-xs hidden-sm hidden-md\" id=\"detalle-barra-doc\"><div class=\"col-lg-offset-1 col-lg-2 col-sm-12 detalle-estado\" ng-class=\"{ \'doc-recibido\': vm.documento.estado == \'RECIBIDO\' }\"><h3>Recibido</h3><p><small>El documento fue recibido exitosamente</small></p></div><div class=\"col-lg-2 col-sm-12 detalle-estado\" ng-class=\"{ \'doc-contabilizado\': vm.documento.estado == \'CONTABILIZADO\' }\"><h3>Contabilizado</h3><h5 ng-show=\"vm.documento.estadoDiscrepancia != null && vm.documento.estadoDiscrepancia.length > 0\">con DISCREPANCIAS</h5><p><small>El documento ha sido procesado por parte de nuestro departamento de Contabilidad</small></p></div><div class=\"col-lg-2 col-sm-12 detalle-estado\" ng-class=\"{ \'doc-rechazado\': vm.documento.estado == \'RECHAZADO\' }\"><h3>Rechazado</h3><p><small>El documento fue rechazado, por favor verificar la <strong>razón del rechazo</strong></small></p></div><div class=\"col-lg-2 col-sm-12 detalle-estado\" ng-class=\"{ \'doc-pagado\': vm.documento.estado == \'PAGADO\' }\"><h3>Pagado</h3><p><small>Se ha realizado el pago del documento. Los datos del pago se encuentran en los detalles</small></p></div><div class=\"col-lg-offset-1 col-lg-8 col-sm-12\" style=\"padding: 0;\" ng-switch=\"\" on=\"vm.documento.estado | lowercase\"><div class=\"progress\" style=\"margin-top:10px; padding: 0;\" ng-switch-when=\"recibido\"><div class=\"progress-bar progress-bar-primary progress-bar-striped\" role=\"progressbar\" aria-valuenow=\"25\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 25%;\"><span class=\"sr-only\">20% Complete (success)</span></div></div><div class=\"progress\" style=\"margin-top:10px; padding: 0;\" ng-switch-when=\"contabilizado\"><div class=\"progress-bar progress-bar-primary progress-bar-striped\" role=\"progressbar\" aria-valuenow=\"50\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 50%;\"><span class=\"sr-only\">40% Complete (success)</span></div></div><div class=\"progress\" style=\"margin-top:10px; padding: 0;\" ng-switch-when=\"rechazado\"><div class=\"progress-bar progress-bar-danger progress-bar-striped\" role=\"progressbar\" aria-valuenow=\"75\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 75%;\"><span class=\"sr-only\">80% Complete (success)</span></div></div><div class=\"progress\" style=\"margin-top:10px; padding: 0;\" ng-switch-when=\"pagado\"><div class=\"progress-bar progress-bar-success progress-bar-striped\" role=\"progressbar\" aria-valuenow=\"100\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 100%;\"><span class=\"sr-only\">40% Complete (success)</span></div></div><div class=\"progress\" style=\"margin-top:10px; padding: 0;\" ng-switch-default=\"\"><div class=\"progress-bar progress-bar-primary progress-bar-striped\" role=\"progressbar\" aria-valuenow=\"0\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 0;\"><span class=\"sr-only\">0% Complete (success)</span></div></div></div></div><div class=\"row\"><div class=\"col-lg-6 col-sm-12 doc-resumen-info\" id=\"detalle-info-doc\"><h3>Informaci&oacute;n Documento</h3><hr><h4 class=\"text-uppercase\"><small>Nombre Proveedor</small></h4><p class=\"lead\">{{vm.documento.nombreProveedor}}</p><h4 class=\"text-uppercase\"><small>RUT Proveedor</small></h4><p class=\"lead\">{{vm.documento.rut}}</p><h4 class=\"text-uppercase\"><small>N&uacute;mero Documento</small></h4><p class=\"lead\">{{vm.documento.numeroDocumento}}</p><h4 class=\"text-uppercase\"><small>Tipo Documento</small></h4><p class=\"lead\">{{vm.documento.tipoDocumento}}</p><div ng-show=\"vm.documento.glosaGeneral.length\"><h4 class=\"text-uppercase\"><small>Observaciones</small></h4><p class=\"lead\">{{vm.documento.glosaGeneral}}</p></div></div><div class=\"col-lg-6 col-sm-12 doc-resumen-info\" id=\"detalle-infoestado-doc\"><h3>Informaci&oacute;n Estado</h3><hr><div ng-show=\"vm.documento.estadoDiscrepancia != null && vm.documento.estadoDiscrepancia.length > 0\"><h4 class=\"text-uppercase\"><small>DISCREPANCIA</small></h4><p class=\"lead\"><strong>EXISTEN DISCREPANCIAS CON EL DOCUMENTO</strong></p><h4 class=\"text-uppercase\"><small>DETALLE DISCREPANCIA</small></h4><div class=\"well well-lg\"><p class=\"lead\" style=\"font-size: 15px;\"><i class=\"fa fa-eye\"></i> {{vm.documento.estadoDiscrepancia}}</p></div></div><h4 class=\"text-uppercase\"><small>Estado Documento</small></h4><p class=\"lead\"><strong>{{vm.documento.estado}}</strong></p><h4 class=\"text-uppercase\"><small>Descripci&oacute;n Estado</small></h4><div ng-switch=\"\" on=\"vm.documento.estado | lowercase\"><div class=\"well well-lg\"><p class=\"lead\" style=\"font-size: 15px;\" ng-switch-when=\"recibido\"><i class=\"fa fa-inbox\"></i> El documento fue recibido exitosamente, a la brevedad comenzar&aacute; su proceso de contabilizaci&oacute;n.</p><p class=\"lead\" style=\"font-size: 15px;\" ng-switch-when=\"contabilizado\"><i class=\"fa fa-check-square-o\"></i> El documento fue entr&oacute; al estado de contabilizaci&oacute;n donde es procesado por nuestro departamento de Contabilidad para su posterior pago.</p><p class=\"lead\" style=\"font-size: 15px;\" ng-switch-when=\"devuelto\"><i class=\"fa fa-undo\"></i> El documento fue devuelto al proveedor por alguna raz&oacute;n. En caso de consultas por favor utilizar el <strong>formulario de contacto</strong> inferior.</p><p class=\"lead\" style=\"font-size: 15px;\" ng-switch-when=\"rechazado\"><i class=\"fa fa-warning\"></i> El documento fue rechazado. Los detalles del rechazo se encuentran a continuaci&oacute;n. Por favor comunicarse a trav&eacute;s de nuestro <strong>formulario de contacto.</strong></p><p class=\"lead\" style=\"font-size: 15px;\" ng-switch-when=\"pagado\"><i class=\"fa fa-money\"></i> El documento fue pagado al proveedor. Los detalles del pago se encuentran a continuaci&oacute;n.</p></div><div ng-switch-when=\"devuelto\" ng-if=\"vm.documento.fechaDevolucion != null\"><h4 class=\"text-uppercase\"><small>Fecha Devoluci&oacute;n</small></h4><p class=\"lead\">{{vm.documento.fechaDevolucion | date:\'dd/MM/yyyy\'}}</p></div><div ng-switch-when=\"rechazado\"><div ng-if=\"vm.documento.fechaRechazo != null\"><h4 class=\"text-uppercase\"><small>Fecha Rechazo</small></h4><p class=\"lead\">{{vm.documento.fechaRechazo | date:\'dd/MM/yyyy\'}}</p></div><div ng-if=\"vm.documento.glosaRechazo != null\"><h4 class=\"text-uppercase\"><small>Glosa Rechazo</small></h4><div class=\"well well-lg\"><p class=\"lead\" style=\"font-size: 15px;\">{{vm.documento.glosaRechazo}}</p></div></div></div><div ng-switch-when=\"pagado\"><div ng-if=\"vm.documento.fechaPago != null\"><h4 class=\"text-uppercase\"><small>Fecha Pago</small></h4><p class=\"lead\">{{vm.documento.fechaPago | date:\'dd/MM/yyyy\'}}</p></div><div ng-if=\"vm.documento.banco != null\"><h4 class=\"text-uppercase\"><small>Banco</small></h4><p class=\"lead\">{{vm.documento.banco}}</p></div><div ng-if=\"vm.documento.sucursal != null\"><h4 class=\"text-uppercase\"><small>Sucursal Banco</small></h4><p class=\"lead\">{{vm.documento.sucursal}}</p></div><div ng-if=\"vm.documento.cuentaCorriente != null\"><h4 class=\"text-uppercase\"><small>Cuenta Corriente</small></h4><p class=\"lead\">{{vm.documento.cuentaCorriente}}</p></div><div ng-if=\"vm.documento.numeroComprobante != null\"><h4 class=\"text-uppercase\"><small>Nro. Comprobante</small></h4><p class=\"lead\">{{vm.documento.numeroComprobante}}</p></div><div ng-if=\"vm.documento.montoPago != null\"><h4 class=\"text-uppercase\"><small>Monto Pago</small></h4><h2 style=\"margin-top: 0;\">{{vm.documento.montoPago | currency:$:0}}</h2></div></div></div></div></div><div ng-show=\"vm.documento.tickets.length > 0\" class=\"row\" style=\"margin-top:100px;\"><div class=\"col-lg-12 col-sm-12\"><h3>Tickets Asociados</h3><hr><div ng-repeat=\"ticket in vm.documento.tickets\" class=\"panel panel-default widget\"><div class=\"panel-heading\"><h3 class=\"panel-title\">TICKET ID {{ticket.ticketID}}</h3></div><div class=\"panel-body\"><ul class=\"list-group\"><li class=\"list-group-item\"><div class=\"row\"><div class=\"col-xs-2 col-md-1\"><i class=\"fa fa-envelope-o fa-5x\" aria-hidden=\"true\"></i></div><div class=\"col-xs-10 col-md-11\"><div><div class=\"mic-info\">Autor: <a href=\"mailto:{{ticket.emailAutor}}\">{{ticket.emailAutor}}</a> el {{ticket.fechaIngreso | date:\'dd/MM/yyyy\'}}</div></div><div class=\"comment-text\">{{ticket.mensaje}}</div></div></div></li><li ng-show=\"ticket.respuesta.length > 0\" class=\"list-group-item\"><div class=\"row\"><div class=\"col-xs-2 col-md-1\"><i class=\"fa fa-reply fa-5x fa-rotate-180\" aria-hidden=\"true\"></i></div><div class=\"col-xs-10 col-md-11\"><div><div class=\"mic-info\">Respuesta enviada el {{ticket.respuestaFecha | date:\'dd/MM/yyyy\'}}</div></div><div class=\"comment-text\">{{ticket.respuesta}}</div></div></div></li></ul></div></div></div></div><div class=\"row\" style=\"margin-top: 100px;\"><div class=\"col-lg-6 col-sm-12\"><h1><i class=\"fa fa-envelope-o\" aria-hidden=\"true\"></i> Cont&aacute;ctenos</h1><p class=\"lead\">Mediante nuestro formulario de contacto podr&aacute; realizar consultas respecto a <strong>este documento.</strong> Uno de nuestros analistas recibir&aacute; la informaci&oacute;n del documento y su mensaje, el cual ser&aacute; respondido a la direcci&oacute;n de correo que usted especifique.</p></div><div class=\"col-lg-6 col-sm-12 well\" id=\"detalle-ticket-doc\"><h3>Formulario Ticket Soporte</h3><hr><send-ticket rut-proveedor=\"vm.documento.rut\" nombre-proveedor=\"vm.documento.nombreProveedor\" numero-factura=\"vm.documento.numeroFactura\" factura-estado=\"vm.documento.estado\"></send-ticket></div></div></div>");
$templateCache.put("app/faq/faq-modal.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" aria-label=\"CERRAR\" ng-click=\"vm.closeModal()\" style=\"margin-top: 5px;\"><span aria-hidden=\"true\">&times;</span></button><h3 class=\"modal-title\">Preguntas Frecuentes</h3></div><div class=\"modal-body\"><faq-portal></faq-portal></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"vm.closeModal()\">CERRAR VENTANA</button></div>");
$templateCache.put("app/faq/faq.html","<v-accordion class=\"vAccordion--default\" multiple=\"\"><v-pane ng-repeat=\"faq in vm.faqs\"><v-pane-header><h4 ng-bind-html=\"faq.preguntaFrecuente\"></h4></v-pane-header><v-pane-content><p ng-bind-html=\"faq.respuestaFrecuente\"></p></v-pane-content></v-pane></v-accordion>");
$templateCache.put("app/login/login.html","<form role=\"form\" name=\"loginForm\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{ \'has-error\': loginForm.loginUsername.$touched && loginForm.loginUsername.$invalid, \'has-success\': loginForm.loginUsername.$valid }\"><label for=\"loginUsername\" class=\"control-label\">RUT Proveedor</label><input type=\"text\" class=\"form-control\" name=\"loginUsername\" id=\"loginUsername\" ng-model=\"vm.loginData.userName\" placeholder=\"RUT Proveedor\" required=\"\"><div ng-show=\"loginForm.loginUsername.$touched\"><p ng-show=\"loginForm.loginUsername.$error.required\" class=\"help-block\">Debe ingresar un <strong>nombre de usuario (RUT)</strong></p></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': loginForm.loginPassword.$touched && loginForm.loginPassword.$invalid, \'has-success\': loginForm.loginPassword.$valid }\"><label for=\"loginPassword\" class=\"control-label\">Contrase&ntilde;a</label> <input type=\"password\" class=\"form-control\" name=\"loginPassword\" id=\"loginPassword\" ng-model=\"vm.loginData.password\" placeholder=\"\" required=\"\"><div ng-show=\"loginForm.loginPassword.$touched\"><p ng-show=\"loginForm.loginPassword.$error.required\" class=\"help-block\">Debe ingresar una <strong>contrase&ntilde;a</strong></p></div></div><button class=\"btn btn-block btn-primary\" type=\"submit\" ng-click=\"vm.login()\" ng-disabled=\"!loginForm.$valid\">INGRESAR <i class=\"fa fa-sign-in\" aria-hidden=\"true\"></i></button> <a class=\"btn btn-block btn-default btn-xs\" style=\"margin-top: 15px;\" ui-sref=\"recuperar\">¿OLVID&Oacute; SU CONTRASE&Ntilde;A? <i class=\"fa fa-unlock-alt\" aria-hidden=\"true\"></i></a> <a ui-sref=\"signup\" class=\"center-block small\" style=\"margin-top: 15px; text-align: center;\">REG&Iacute;STRESE AQU&Iacute; <i class=\"fa fa-user-plus\" aria-hidden=\"true\"></i></a><p ng-hide=\"vm.message == \'\'\" class=\"text-danger\" style=\"margin-top: 10px;\"><i class=\"fa fa-warning\"></i> {{vm.message}}</p></form>");
$templateCache.put("app/sendticket/sendticket.html","<form class=\"form-horizontal\" name=\"ticketForm\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{ \'has-error\': ticketForm.ticketEmail.$touched && ticketForm.ticketEmail.$invalid, \'has-success\': ticketForm.ticketEmail.$valid }\"><label for=\"ticketEmail\" class=\"col-lg-2 control-label\">Email Contacto</label><div class=\"col-lg-10\"><input type=\"email\" class=\"form-control input-sm\" id=\"ticketEmail\" name=\"ticketEmail\" ng-model=\"send.infoTicket.EmailAutor\" placeholder=\"nombre@proveedor.cl\" ng-class=\"{ \'has-error\': ticketForm.ticketEmail.$touched && ticketForm.ticketEmail.$invalid, \'has-success\': ticketForm.ticketEmail.$valid }\" required=\"\"><div ng-show=\"ticketForm.ticketEmail.$touched\"><p ng-show=\"ticketForm.ticketEmail.$error.required\" class=\"help-block\">Debe ingresar un <strong>correo electr&oacute;nico</strong></p><p ng-show=\"ticketForm.ticketEmail.$error.email\" class=\"help-block\">Debe ingresar un <strong>correo electr&oacute;nico v&aacute;lido</strong></p></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': ticketForm.ticketMensaje.$touched && ticketForm.ticketMensaje.$invalid, \'has-success\': ticketForm.ticketMensaje.$valid }\"><label for=\"ticketMensaje\" class=\"col-lg-2 control-label\">Mensaje</label><div class=\"col-lg-10\"><textarea rows=\"5\" type=\"text\" class=\"form-control input-sm\" id=\"ticketMensaje\" name=\"ticketMensaje\" ng-model=\"send.infoTicket.Mensaje\" ng-trim=\"false\" ng-minlength=\"20\" ng-maxlength=\"250\" placeholder=\"Observaciones, consultas, etc.\" ng-class=\"{ \'has-error\': ticketForm.ticketMensaje.$touched && ticketForm.ticketMensaje.$invalid, \'has-success\': ticketForm.ticketMensaje.$valid }\" required=\"\">\r\n            </textarea><p class=\"help-block\">M&iacute;nimo de 20 caracteres en el mensaje</p><div ng-show=\"ticketForm.ticketMensaje.$touched\"><p ng-show=\"ticketForm.ticketMensaje.$error.required\" class=\"help-block\">Debe ingresar un mensaje de al menos <strong>20 caracteres</strong></p><p ng-show=\"ticketForm.ticketMensaje.$error.minlength\" class=\"help-block\">Debe ingresar un mensaje de al menos <strong>20 caracteres</strong></p><p ng-show=\"ticketForm.ticketMensaje.$error.maxlength\" class=\"help-block\">Debe ingresar un mensaje de m&aacute;ximo <strong>250 caracteres</strong></p></div></div></div><div class=\"form-group\"><div class=\"col-lg-10 col-lg-offset-2\"><button type=\"submit\" class=\"btn btn-primary btn-sm\" ng-click=\"send.postTicket()\" ng-disabled=\"ticketForm.$invalid\">Enviar Mensaje <i class=\"fa fa-paper-plane\" aria-hidden=\"true\"></i></button><p class=\"text-muted\" ng-show=\"ticketForm.$invalid\"><small><strong>Importante:</strong> Debe ingresar los campos arriba descritos para poder enviar el mensaje</small></p></div></div></form>");
$templateCache.put("app/showcase/showcase.html","<div class=\"container\"><div class=\"page-header\" id=\"banner\"><div class=\"row\"><div class=\"col-lg-8 col-md-7 col-sm-6\"><h1>Cosmo</h1><p class=\"lead\">An ode to Metro</p></div><div class=\"col-lg-4 col-md-5 col-sm-6\"><div class=\"sponsor\"><script async=\"\" type=\"text/javascript\" src=\"//cdn.carbonads.com/carbon.js?zoneid=1673&serve=C6AILKT&placement=bootswatchcom\" id=\"_carbonads_js\"></script></div></div></div><div class=\"row\"><div class=\"col-lg-3 col-md-3 col-sm-4\"><div class=\"list-group table-of-contents\"><a class=\"list-group-item\" href=\"#navbar\">Navbar</a> <a class=\"list-group-item\" href=\"#buttons\">Buttons</a> <a class=\"list-group-item\" href=\"#typography\">Typography</a> <a class=\"list-group-item\" href=\"#tables\">Tables</a> <a class=\"list-group-item\" href=\"#forms\">Forms</a> <a class=\"list-group-item\" href=\"#navs\">Navs</a> <a class=\"list-group-item\" href=\"#indicators\">Indicators</a> <a class=\"list-group-item\" href=\"#progress-bars\">Progress bars</a> <a class=\"list-group-item\" href=\"#containers\">Containers</a> <a class=\"list-group-item\" href=\"#dialogs\">Dialogs</a></div></div></div></div><div class=\"bs-docs-section clearfix\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"page-header\"><h1 id=\"navbar\">Navbar</h1></div><div class=\"bs-component\"><nav class=\"navbar navbar-default\"><div class=\"container-fluid\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#bs-example-navbar-collapse-1\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button> <a class=\"navbar-brand\" href=\"#\">Brand</a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-1\"><ul class=\"nav navbar-nav\"><li class=\"active\"><a href=\"#\">Link <span class=\"sr-only\">(current)</span></a></li><li><a href=\"#\">Link</a></li><li class=\"dropdown\"><a href=\"#\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-expanded=\"false\">Dropdown <span class=\"caret\"></span></a><ul class=\"dropdown-menu\" role=\"menu\"><li><a href=\"#\">Action</a></li><li><a href=\"#\">Another action</a></li><li><a href=\"#\">Something else here</a></li><li class=\"divider\"></li><li><a href=\"#\">Separated link</a></li><li class=\"divider\"></li><li><a href=\"#\">One more separated link</a></li></ul></li></ul><form class=\"navbar-form navbar-left\" role=\"search\"><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Search\"></div><button type=\"submit\" class=\"btn btn-default\">Submit</button></form><ul class=\"nav navbar-nav navbar-right\"><li><a href=\"#\">Link</a></li></ul></div></div></nav></div><div class=\"bs-component\"><nav class=\"navbar navbar-inverse\"><div class=\"container-fluid\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#bs-example-navbar-collapse-2\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button> <a class=\"navbar-brand\" href=\"#\">Brand</a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-2\"><ul class=\"nav navbar-nav\"><li class=\"active\"><a href=\"#\">Link <span class=\"sr-only\">(current)</span></a></li><li><a href=\"#\">Link</a></li><li class=\"dropdown\"><a href=\"#\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-expanded=\"false\">Dropdown <span class=\"caret\"></span></a><ul class=\"dropdown-menu\" role=\"menu\"><li><a href=\"#\">Action</a></li><li><a href=\"#\">Another action</a></li><li><a href=\"#\">Something else here</a></li><li class=\"divider\"></li><li><a href=\"#\">Separated link</a></li><li class=\"divider\"></li><li><a href=\"#\">One more separated link</a></li></ul></li></ul><form class=\"navbar-form navbar-left\" role=\"search\"><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Search\"></div><button type=\"submit\" class=\"btn btn-default\">Submit</button></form><ul class=\"nav navbar-nav navbar-right\"><li><a href=\"#\">Link</a></li></ul></div></div></nav></div></div></div></div><div class=\"bs-docs-section\"><div class=\"page-header\"><div class=\"row\"><div class=\"col-lg-12\"><h1 id=\"buttons\">Buttons</h1></div></div></div><div class=\"row\"><div class=\"col-lg-7\"><p class=\"bs-component\"><a href=\"#\" class=\"btn btn-default\">Default</a> <a href=\"#\" class=\"btn btn-primary\">Primary</a> <a href=\"#\" class=\"btn btn-success\">Success</a> <a href=\"#\" class=\"btn btn-info\">Info</a> <a href=\"#\" class=\"btn btn-warning\">Warning</a> <a href=\"#\" class=\"btn btn-danger\">Danger</a> <a href=\"#\" class=\"btn btn-link\">Link</a></p><p class=\"bs-component\"><a href=\"#\" class=\"btn btn-default disabled\">Default</a> <a href=\"#\" class=\"btn btn-primary disabled\">Primary</a> <a href=\"#\" class=\"btn btn-success disabled\">Success</a> <a href=\"#\" class=\"btn btn-info disabled\">Info</a> <a href=\"#\" class=\"btn btn-warning disabled\">Warning</a> <a href=\"#\" class=\"btn btn-danger disabled\">Danger</a> <a href=\"#\" class=\"btn btn-link disabled\">Link</a></p><div style=\"margin-bottom: 15px;\"><div class=\"btn-toolbar bs-component\" style=\"margin: 0;\"><div class=\"btn-group\"><a href=\"#\" class=\"btn btn-default\">Default</a> <a href=\"#\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\"><span class=\"caret\"></span></a><ul class=\"dropdown-menu\"><li><a href=\"#\">Action</a></li><li><a href=\"#\">Another action</a></li><li><a href=\"#\">Something else here</a></li><li class=\"divider\"></li><li><a href=\"#\">Separated link</a></li></ul></div><div class=\"btn-group\"><a href=\"#\" class=\"btn btn-primary\">Primary</a> <a href=\"#\" class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\"><span class=\"caret\"></span></a><ul class=\"dropdown-menu\"><li><a href=\"#\">Action</a></li><li><a href=\"#\">Another action</a></li><li><a href=\"#\">Something else here</a></li><li class=\"divider\"></li><li><a href=\"#\">Separated link</a></li></ul></div><div class=\"btn-group\"><a href=\"#\" class=\"btn btn-success\">Success</a> <a href=\"#\" class=\"btn btn-success dropdown-toggle\" data-toggle=\"dropdown\"><span class=\"caret\"></span></a><ul class=\"dropdown-menu\"><li><a href=\"#\">Action</a></li><li><a href=\"#\">Another action</a></li><li><a href=\"#\">Something else here</a></li><li class=\"divider\"></li><li><a href=\"#\">Separated link</a></li></ul></div><div class=\"btn-group\"><a href=\"#\" class=\"btn btn-info\">Info</a> <a href=\"#\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\"><span class=\"caret\"></span></a><ul class=\"dropdown-menu\"><li><a href=\"#\">Action</a></li><li><a href=\"#\">Another action</a></li><li><a href=\"#\">Something else here</a></li><li class=\"divider\"></li><li><a href=\"#\">Separated link</a></li></ul></div><div class=\"btn-group\"><a href=\"#\" class=\"btn btn-warning\">Warning</a> <a href=\"#\" class=\"btn btn-warning dropdown-toggle\" data-toggle=\"dropdown\"><span class=\"caret\"></span></a><ul class=\"dropdown-menu\"><li><a href=\"#\">Action</a></li><li><a href=\"#\">Another action</a></li><li><a href=\"#\">Something else here</a></li><li class=\"divider\"></li><li><a href=\"#\">Separated link</a></li></ul></div></div></div><p class=\"bs-component\"><a href=\"#\" class=\"btn btn-primary btn-lg\">Large button</a> <a href=\"#\" class=\"btn btn-primary\">Default button</a> <a href=\"#\" class=\"btn btn-primary btn-sm\">Small button</a> <a href=\"#\" class=\"btn btn-primary btn-xs\">Mini button</a></p></div><div class=\"col-lg-5\"><p class=\"bs-component\"><a href=\"#\" class=\"btn btn-default btn-lg btn-block\">Block level button</a></p><div class=\"bs-component\" style=\"margin-bottom: 15px;\"><div class=\"btn-group btn-group-justified\"><a href=\"#\" class=\"btn btn-default\">Left</a> <a href=\"#\" class=\"btn btn-default\">Middle</a> <a href=\"#\" class=\"btn btn-default\">Right</a></div></div><div class=\"bs-component\" style=\"margin-bottom: 15px;\"><div class=\"btn-toolbar\"><div class=\"btn-group\"><a href=\"#\" class=\"btn btn-default\">1</a> <a href=\"#\" class=\"btn btn-default\">2</a> <a href=\"#\" class=\"btn btn-default\">3</a> <a href=\"#\" class=\"btn btn-default\">4</a></div><div class=\"btn-group\"><a href=\"#\" class=\"btn btn-default\">5</a> <a href=\"#\" class=\"btn btn-default\">6</a> <a href=\"#\" class=\"btn btn-default\">7</a></div><div class=\"btn-group\"><a href=\"#\" class=\"btn btn-default\">8</a><div class=\"btn-group\"><a href=\"#\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\">Dropdown <span class=\"caret\"></span></a><ul class=\"dropdown-menu\"><li><a href=\"#\">Dropdown link</a></li><li><a href=\"#\">Dropdown link</a></li><li><a href=\"#\">Dropdown link</a></li></ul></div></div></div></div><div class=\"bs-component\"><div class=\"btn-group-vertical\"><a href=\"#\" class=\"btn btn-default\">Button</a> <a href=\"#\" class=\"btn btn-default\">Button</a> <a href=\"#\" class=\"btn btn-default\">Button</a> <a href=\"#\" class=\"btn btn-default\">Button</a></div></div></div></div></div><div class=\"bs-docs-section\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"page-header\"><h1 id=\"typography\">Typography</h1></div></div></div><div class=\"row\"><div class=\"col-lg-4\"><div class=\"bs-component\"><h1>Heading 1</h1><h2>Heading 2</h2><h3>Heading 3</h3><h4>Heading 4</h4><h5>Heading 5</h5><h6>Heading 6</h6><p class=\"lead\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p></div></div><div class=\"col-lg-4\"><div class=\"bs-component\"><h2>Example body text</h2><p>Nullam quis risus eget <a href=\"#\">urna mollis ornare</a> vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id nibh ultricies vehicula.</p><p><small>This line of text is meant to be treated as fine print.</small></p><p>The following snippet of text is <strong>rendered as bold text</strong>.</p><p>The following snippet of text is <em>rendered as italicized text</em>.</p><p>An abbreviation of the word attribute is <abbr title=\"attribute\">attr</abbr>.</p></div></div><div class=\"col-lg-4\"><div class=\"bs-component\"><h2>Emphasis classes</h2><p class=\"text-muted\">Fusce dapibus, tellus ac cursus commodo, tortor mauris nibh.</p><p class=\"text-primary\">Nullam id dolor id nibh ultricies vehicula ut id elit.</p><p class=\"text-warning\">Etiam porta sem malesuada magna mollis euismod.</p><p class=\"text-danger\">Donec ullamcorper nulla non metus auctor fringilla.</p><p class=\"text-success\">Duis mollis, est non commodo luctus, nisi erat porttitor ligula.</p><p class=\"text-info\">Maecenas sed diam eget risus varius blandit sit amet non magna.</p></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><h2 id=\"type-blockquotes\">Blockquotes</h2></div></div><div class=\"row\"><div class=\"col-lg-6\"><div class=\"bs-component\"><blockquote><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.</p><small>Someone famous in <cite title=\"Source Title\">Source Title</cite></small></blockquote></div></div><div class=\"col-lg-6\"><div class=\"bs-component\"><blockquote class=\"blockquote-reverse\"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.</p><small>Someone famous in <cite title=\"Source Title\">Source Title</cite></small></blockquote></div></div></div></div><div class=\"bs-docs-section\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"page-header\"><h1 id=\"tables\">Tables</h1></div><div class=\"bs-component\"><table class=\"table table-striped table-hover\"><thead><tr><th>#</th><th>Column heading</th><th>Column heading</th><th>Column heading</th></tr></thead><tbody><tr><td>1</td><td>Column content</td><td>Column content</td><td>Column content</td></tr><tr><td>2</td><td>Column content</td><td>Column content</td><td>Column content</td></tr><tr class=\"info\"><td>3</td><td>Column content</td><td>Column content</td><td>Column content</td></tr><tr class=\"success\"><td>4</td><td>Column content</td><td>Column content</td><td>Column content</td></tr><tr class=\"danger\"><td>5</td><td>Column content</td><td>Column content</td><td>Column content</td></tr><tr class=\"warning\"><td>6</td><td>Column content</td><td>Column content</td><td>Column content</td></tr><tr class=\"active\"><td>7</td><td>Column content</td><td>Column content</td><td>Column content</td></tr></tbody></table></div></div></div></div><div class=\"bs-docs-section\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"page-header\"><h1 id=\"forms\">Forms</h1></div></div></div><div class=\"row\"><div class=\"col-lg-6\"><div class=\"well bs-component\"><form class=\"form-horizontal\"><fieldset><legend>Legend</legend><div class=\"form-group\"><label for=\"inputEmail\" class=\"col-lg-2 control-label\">Email</label><div class=\"col-lg-10\"><input type=\"text\" class=\"form-control\" id=\"inputEmail\" placeholder=\"Email\"></div></div><div class=\"form-group\"><label for=\"inputPassword\" class=\"col-lg-2 control-label\">Password</label><div class=\"col-lg-10\"><input type=\"password\" class=\"form-control\" id=\"inputPassword\" placeholder=\"Password\"><div class=\"checkbox\"><label><input type=\"checkbox\"> Checkbox</label></div></div></div><div class=\"form-group\"><label for=\"textArea\" class=\"col-lg-2 control-label\">Textarea</label><div class=\"col-lg-10\"><textarea class=\"form-control\" rows=\"3\" id=\"textArea\"></textarea> <span class=\"help-block\">A longer block of help text that breaks onto a new line and may extend beyond one line.</span></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Radios</label><div class=\"col-lg-10\"><div class=\"radio\"><label><input type=\"radio\" name=\"optionsRadios\" id=\"optionsRadios1\" value=\"option1\" checked=\"\"> Option one is this</label></div><div class=\"radio\"><label><input type=\"radio\" name=\"optionsRadios\" id=\"optionsRadios2\" value=\"option2\"> Option two can be something else</label></div></div></div><div class=\"form-group\"><label for=\"select\" class=\"col-lg-2 control-label\">Selects</label><div class=\"col-lg-10\"><select class=\"form-control\" id=\"select\"><option>1</option><option>2</option><option>3</option><option>4</option><option>5</option></select><br><select multiple=\"\" class=\"form-control\"><option>1</option><option>2</option><option>3</option><option>4</option><option>5</option></select></div></div><div class=\"form-group\"><div class=\"col-lg-10 col-lg-offset-2\"><button type=\"reset\" class=\"btn btn-default\">Cancel</button> <button type=\"submit\" class=\"btn btn-primary\">Submit</button></div></div></fieldset></form></div></div><div class=\"col-lg-4 col-lg-offset-1\"><form class=\"bs-component\"><div class=\"form-group\"><label class=\"control-label\" for=\"focusedInput\">Focused input</label> <input class=\"form-control\" id=\"focusedInput\" type=\"text\" value=\"This is focused...\"></div><div class=\"form-group\"><label class=\"control-label\" for=\"disabledInput\">Disabled input</label> <input class=\"form-control\" id=\"disabledInput\" type=\"text\" placeholder=\"Disabled input here...\" disabled=\"\"></div><div class=\"form-group has-warning\"><label class=\"control-label\" for=\"inputWarning\">Input warning</label> <input type=\"text\" class=\"form-control\" id=\"inputWarning\"></div><div class=\"form-group has-error\"><label class=\"control-label\" for=\"inputError\">Input error</label> <input type=\"text\" class=\"form-control\" id=\"inputError\"></div><div class=\"form-group has-success\"><label class=\"control-label\" for=\"inputSuccess\">Input success</label> <input type=\"text\" class=\"form-control\" id=\"inputSuccess\"></div><div class=\"form-group\"><label class=\"control-label\" for=\"inputLarge\">Large input</label> <input class=\"form-control input-lg\" type=\"text\" id=\"inputLarge\"></div><div class=\"form-group\"><label class=\"control-label\" for=\"inputDefault\">Default input</label> <input type=\"text\" class=\"form-control\" id=\"inputDefault\"></div><div class=\"form-group\"><label class=\"control-label\" for=\"inputSmall\">Small input</label> <input class=\"form-control input-sm\" type=\"text\" id=\"inputSmall\"></div><div class=\"form-group\"><label class=\"control-label\">Input addons</label><div class=\"input-group\"><span class=\"input-group-addon\">$</span> <input type=\"text\" class=\"form-control\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\">Button</button></span></div></div></form></div></div></div><div class=\"bs-docs-section\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"page-header\"><h1 id=\"navs\">Navs</h1></div></div></div><div class=\"row\"><div class=\"col-lg-4\"><h2 id=\"nav-tabs\">Tabs</h2><div class=\"bs-component\"><ul class=\"nav nav-tabs\"><li class=\"active\"><a href=\"#home\" data-toggle=\"tab\">Home</a></li><li><a href=\"#profile\" data-toggle=\"tab\">Profile</a></li><li class=\"disabled\"><a>Disabled</a></li><li class=\"dropdown\"><a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"#\">Dropdown <span class=\"caret\"></span></a><ul class=\"dropdown-menu\"><li><a href=\"#dropdown1\" data-toggle=\"tab\">Action</a></li><li class=\"divider\"></li><li><a href=\"#dropdown2\" data-toggle=\"tab\">Another action</a></li></ul></li></ul><div id=\"myTabContent\" class=\"tab-content\"><div class=\"tab-pane fade active in\" id=\"home\"><p>Raw denim you probably haven\'t heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica. Reprehenderit butcher retro keffiyeh dreamcatcher synth. Cosby sweater eu banh mi, qui irure terry richardson ex squid. Aliquip placeat salvia cillum iphone. Seitan aliquip quis cardigan american apparel, butcher voluptate nisi qui.</p></div><div class=\"tab-pane fade\" id=\"profile\"><p>Food truck fixie locavore, accusamus mcsweeney\'s marfa nulla single-origin coffee squid. Exercitation +1 labore velit, blog sartorial PBR leggings next level wes anderson artisan four loko farm-to-table craft beer twee. Qui photo booth letterpress, commodo enim craft beer mlkshk aliquip jean shorts ullamco ad vinyl cillum PBR. Homo nostrud organic, assumenda labore aesthetic magna delectus mollit.</p></div><div class=\"tab-pane fade\" id=\"dropdown1\"><p>Etsy mixtape wayfarers, ethical wes anderson tofu before they sold out mcsweeney\'s organic lomo retro fanny pack lo-fi farm-to-table readymade. Messenger bag gentrify pitchfork tattooed craft beer, iphone skateboard locavore carles etsy salvia banksy hoodie helvetica. DIY synth PBR banksy irony. Leggings gentrify squid 8-bit cred pitchfork.</p></div><div class=\"tab-pane fade\" id=\"dropdown2\"><p>Trust fund seitan letterpress, keytar raw denim keffiyeh etsy art party before they sold out master cleanse gluten-free squid scenester freegan cosby sweater. Fanny pack portland seitan DIY, art party locavore wolf cliche high life echo park Austin. Cred vinyl keffiyeh DIY salvia PBR, banh mi before they sold out farm-to-table VHS viral locavore cosby sweater.</p></div></div></div></div><div class=\"col-lg-4\"><h2 id=\"nav-pills\">Pills</h2><div class=\"bs-component\"><ul class=\"nav nav-pills\"><li class=\"active\"><a href=\"#\">Home</a></li><li><a href=\"#\">Profile</a></li><li class=\"disabled\"><a href=\"#\">Disabled</a></li><li class=\"dropdown\"><a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"#\">Dropdown <span class=\"caret\"></span></a><ul class=\"dropdown-menu\"><li><a href=\"#\">Action</a></li><li><a href=\"#\">Another action</a></li><li><a href=\"#\">Something else here</a></li><li class=\"divider\"></li><li><a href=\"#\">Separated link</a></li></ul></li></ul></div><br><div class=\"bs-component\"><ul class=\"nav nav-pills nav-stacked\"><li class=\"active\"><a href=\"#\">Home</a></li><li><a href=\"#\">Profile</a></li><li class=\"disabled\"><a href=\"#\">Disabled</a></li><li class=\"dropdown\"><a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"#\">Dropdown <span class=\"caret\"></span></a><ul class=\"dropdown-menu\"><li><a href=\"#\">Action</a></li><li><a href=\"#\">Another action</a></li><li><a href=\"#\">Something else here</a></li><li class=\"divider\"></li><li><a href=\"#\">Separated link</a></li></ul></li></ul></div></div><div class=\"col-lg-4\"><h2 id=\"nav-breadcrumbs\">Breadcrumbs</h2><div class=\"bs-component\"><ul class=\"breadcrumb\"><li class=\"active\">Home</li></ul><ul class=\"breadcrumb\"><li><a href=\"#\">Home</a></li><li class=\"active\">Library</li></ul><ul class=\"breadcrumb\"><li><a href=\"#\">Home</a></li><li><a href=\"#\">Library</a></li><li class=\"active\">Data</li></ul></div></div></div><div class=\"row\"><div class=\"col-lg-4\"><h2 id=\"pagination\">Pagination</h2><div class=\"bs-component\"><ul class=\"pagination\"><li class=\"disabled\"><a href=\"#\">&laquo;</a></li><li class=\"active\"><a href=\"#\">1</a></li><li><a href=\"#\">2</a></li><li><a href=\"#\">3</a></li><li><a href=\"#\">4</a></li><li><a href=\"#\">5</a></li><li><a href=\"#\">&raquo;</a></li></ul><ul class=\"pagination pagination-lg\"><li class=\"disabled\"><a href=\"#\">&laquo;</a></li><li class=\"active\"><a href=\"#\">1</a></li><li><a href=\"#\">2</a></li><li><a href=\"#\">3</a></li><li><a href=\"#\">&raquo;</a></li></ul><ul class=\"pagination pagination-sm\"><li class=\"disabled\"><a href=\"#\">&laquo;</a></li><li class=\"active\"><a href=\"#\">1</a></li><li><a href=\"#\">2</a></li><li><a href=\"#\">3</a></li><li><a href=\"#\">4</a></li><li><a href=\"#\">5</a></li><li><a href=\"#\">&raquo;</a></li></ul></div></div><div class=\"col-lg-4\"><h2 id=\"pager\">Pager</h2><div class=\"bs-component\"><ul class=\"pager\"><li><a href=\"#\">Previous</a></li><li><a href=\"#\">Next</a></li></ul><ul class=\"pager\"><li class=\"previous disabled\"><a href=\"#\">&larr; Older</a></li><li class=\"next\"><a href=\"#\">Newer &rarr;</a></li></ul></div></div><div class=\"col-lg-4\"></div></div></div><div class=\"bs-docs-section\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"page-header\"><h1 id=\"indicators\">Indicators</h1></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><h2>Alerts</h2><div class=\"bs-component\"><div class=\"alert alert-dismissible alert-warning\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button><h4>Warning!</h4><p>Best check yo self, you\'re not looking too good. Nulla vitae elit libero, a pharetra augue. Praesent commodo cursus magna, <a href=\"#\" class=\"alert-link\">vel scelerisque nisl consectetur et</a>.</p></div></div></div></div><div class=\"row\"><div class=\"col-lg-4\"><div class=\"bs-component\"><div class=\"alert alert-dismissible alert-danger\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button> <strong>Oh snap!</strong> <a href=\"#\" class=\"alert-link\">Change a few things up</a> and try submitting again.</div></div></div><div class=\"col-lg-4\"><div class=\"bs-component\"><div class=\"alert alert-dismissible alert-success\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button> <strong>Well done!</strong> You successfully read <a href=\"#\" class=\"alert-link\">this important alert message</a>.</div></div></div><div class=\"col-lg-4\"><div class=\"bs-component\"><div class=\"alert alert-dismissible alert-info\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button> <strong>Heads up!</strong> This <a href=\"#\" class=\"alert-link\">alert needs your attention</a>, but it\'s not super important.</div></div></div></div><div class=\"row\"><div class=\"col-lg-4\"><h2>Labels</h2><div class=\"bs-component\" style=\"margin-bottom: 40px;\"><span class=\"label label-default\">Default</span> <span class=\"label label-primary\">Primary</span> <span class=\"label label-success\">Success</span> <span class=\"label label-warning\">Warning</span> <span class=\"label label-danger\">Danger</span> <span class=\"label label-info\">Info</span></div></div><div class=\"col-lg-4\"><h2>Badges</h2><div class=\"bs-component\"><ul class=\"nav nav-pills\"><li class=\"active\"><a href=\"#\">Home <span class=\"badge\">42</span></a></li><li><a href=\"#\">Profile <span class=\"badge\"></span></a></li><li><a href=\"#\">Messages <span class=\"badge\">3</span></a></li></ul></div></div></div></div><div class=\"bs-docs-section\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"page-header\"><h1 id=\"progress-bars\">Progress bars</h1></div><h3 id=\"progress-basic\">Basic</h3><div class=\"bs-component\"><div class=\"progress\"><div class=\"progress-bar\" style=\"width: 60%;\"></div></div></div><h3 id=\"progress-alternatives\">Contextual alternatives</h3><div class=\"bs-component\"><div class=\"progress\"><div class=\"progress-bar progress-bar-info\" style=\"width: 20%\"></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-success\" style=\"width: 40%\"></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-warning\" style=\"width: 60%\"></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-danger\" style=\"width: 80%\"></div></div></div><h3 id=\"progress-striped\">Striped</h3><div class=\"bs-component\"><div class=\"progress progress-striped\"><div class=\"progress-bar progress-bar-info\" style=\"width: 20%\"></div></div><div class=\"progress progress-striped\"><div class=\"progress-bar progress-bar-success\" style=\"width: 40%\"></div></div><div class=\"progress progress-striped\"><div class=\"progress-bar progress-bar-warning\" style=\"width: 60%\"></div></div><div class=\"progress progress-striped\"><div class=\"progress-bar progress-bar-danger\" style=\"width: 80%\"></div></div></div><h3 id=\"progress-animated\">Animated</h3><div class=\"bs-component\"><div class=\"progress progress-striped active\"><div class=\"progress-bar\" style=\"width: 45%\"></div></div></div><h3 id=\"progress-stacked\">Stacked</h3><div class=\"bs-component\"><div class=\"progress\"><div class=\"progress-bar progress-bar-success\" style=\"width: 35%\"></div><div class=\"progress-bar progress-bar-warning\" style=\"width: 20%\"></div><div class=\"progress-bar progress-bar-danger\" style=\"width: 10%\"></div></div></div></div></div></div><div class=\"bs-docs-section\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"page-header\"><h1 id=\"containers\">Containers</h1></div><div class=\"bs-component\"><div class=\"jumbotron\"><h1>Jumbotron</h1><p>This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured content or information.</p><p><a class=\"btn btn-primary btn-lg\">Learn more</a></p></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><h2>List groups</h2></div></div><div class=\"row\"><div class=\"col-lg-4\"><div class=\"bs-component\"><ul class=\"list-group\"><li class=\"list-group-item\"><span class=\"badge\">14</span> Cras justo odio</li><li class=\"list-group-item\"><span class=\"badge\">2</span> Dapibus ac facilisis in</li><li class=\"list-group-item\"><span class=\"badge\">1</span> Morbi leo risus</li></ul></div></div><div class=\"col-lg-4\"><div class=\"bs-component\"><div class=\"list-group\"><a href=\"#\" class=\"list-group-item active\">Cras justo odio</a> <a href=\"#\" class=\"list-group-item\">Dapibus ac facilisis in</a> <a href=\"#\" class=\"list-group-item\">Morbi leo risus</a></div></div></div><div class=\"col-lg-4\"><div class=\"bs-component\"><div class=\"list-group\"><a href=\"#\" class=\"list-group-item\"><h4 class=\"list-group-item-heading\">List group item heading</h4><p class=\"list-group-item-text\">Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.</p></a> <a href=\"#\" class=\"list-group-item\"><h4 class=\"list-group-item-heading\">List group item heading</h4><p class=\"list-group-item-text\">Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.</p></a></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><h2>Panels</h2></div></div><div class=\"row\"><div class=\"col-lg-4\"><div class=\"bs-component\"><div class=\"panel panel-default\"><div class=\"panel-body\">Basic panel</div></div><div class=\"panel panel-default\"><div class=\"panel-heading\">Panel heading</div><div class=\"panel-body\">Panel content</div></div><div class=\"panel panel-default\"><div class=\"panel-body\">Panel content</div><div class=\"panel-footer\">Panel footer</div></div></div></div><div class=\"col-lg-4\"><div class=\"bs-component\"><div class=\"panel panel-primary\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Panel primary</h3></div><div class=\"panel-body\">Panel content</div></div><div class=\"panel panel-success\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Panel success</h3></div><div class=\"panel-body\">Panel content</div></div><div class=\"panel panel-warning\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Panel warning</h3></div><div class=\"panel-body\">Panel content</div></div></div></div><div class=\"col-lg-4\"><div class=\"bs-component\"><div class=\"panel panel-danger\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Panel danger</h3></div><div class=\"panel-body\">Panel content</div></div><div class=\"panel panel-info\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Panel info</h3></div><div class=\"panel-body\">Panel content</div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><h2>Wells</h2></div></div><div class=\"row\"><div class=\"col-lg-4\"><div class=\"bs-component\"><div class=\"well\">Look, I\'m in a well!</div></div></div><div class=\"col-lg-4\"><div class=\"bs-component\"><div class=\"well well-sm\">Look, I\'m in a small well!</div></div></div><div class=\"col-lg-4\"><div class=\"bs-component\"><div class=\"well well-lg\">Look, I\'m in a large well!</div></div></div></div></div><div class=\"bs-docs-section\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"page-header\"><h1 id=\"dialogs\">Dialogs</h1></div></div></div><div class=\"row\"><div class=\"col-lg-6\"><h2>Modals</h2><div class=\"bs-component\"><div class=\"modal\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button><h4 class=\"modal-title\">Modal title</h4></div><div class=\"modal-body\"><p>One fine body…</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <button type=\"button\" class=\"btn btn-primary\">Save changes</button></div></div></div></div></div></div><div class=\"col-lg-6\"><h2>Popovers</h2><div class=\"bs-component\"><button type=\"button\" class=\"btn btn-default\" data-container=\"body\" data-toggle=\"popover\" data-placement=\"left\" data-content=\"Vivamus sagittis lacus vel augue laoreet rutrum faucibus.\">Left</button> <button type=\"button\" class=\"btn btn-default\" data-container=\"body\" data-toggle=\"popover\" data-placement=\"top\" data-content=\"Vivamus sagittis lacus vel augue laoreet rutrum faucibus.\">Top</button> <button type=\"button\" class=\"btn btn-default\" data-container=\"body\" data-toggle=\"popover\" data-placement=\"bottom\" data-content=\"Vivamus sagittis lacus vel augue laoreet rutrum faucibus.\">Bottom</button> <button type=\"button\" class=\"btn btn-default\" data-container=\"body\" data-toggle=\"popover\" data-placement=\"right\" data-content=\"Vivamus sagittis lacus vel augue laoreet rutrum faucibus.\">Right</button></div><h2>Tooltips</h2><div class=\"bs-component\"><button type=\"button\" class=\"btn btn-default\" data-toggle=\"tooltip\" data-placement=\"left\" title=\"\" data-original-title=\"Tooltip on left\">Left</button> <button type=\"button\" class=\"btn btn-default\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"\" data-original-title=\"Tooltip on top\">Top</button> <button type=\"button\" class=\"btn btn-default\" data-toggle=\"tooltip\" data-placement=\"bottom\" title=\"\" data-original-title=\"Tooltip on bottom\">Bottom</button> <button type=\"button\" class=\"btn btn-default\" data-toggle=\"tooltip\" data-placement=\"right\" title=\"\" data-original-title=\"Tooltip on right\">Right</button></div></div></div></div><div id=\"source-modal\" class=\"modal fade\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</button><h4 class=\"modal-title\">Source Code</h4></div><div class=\"modal-body\"><pre></pre></div></div></div></div></div>");
$templateCache.put("app/signup/signup.html","<div class=\"header-jumbo\"><jumbotron-portal encabezado=\"\'Registro\'\" texto=\"\'Bienvenido al Portal de Proveedores Metso Chile S.A. En caso de requerir m&aacute;s informaci&oacute;n tiene a su disposici&oacute;n los siguientes recursos\'\" con-documentos=\"true\"></jumbotron-portal></div><div class=\"container\" style=\"min-height: 350px;\"><div class=\"row padding-bot-top-35\"><div class=\"col-lg-6 col-sm-12 col-xs-12 padding-bottom-35\"><h1>Registro en el Portal de Proveedores</h1><p>Para poder operar en nuestro Portal ustede debe contar con un nombre de usuario (RUT Proveedor) y una contrase&ntilde;a. Al momento de iniciar el proceso de registro el sistema verificar&aacute; que usted cuente con documentos disponibles para visualizaci&oacute;n. Una vez que se haya registrado exitosamente ser&aacute; redireccionado para que pueda iniciar sesi&oacute;n</p></div><div class=\"col-lg-5 col-lg-offset-1 col-sm-12 col-xs-12 form-wrapper padding-col-35\"><div class=\"col-lg-12 text-center\"><i class=\"fa fa-user-plus fa-5x\" aria-hidden=\"true\"></i><h2>Formulario Registro</h2><hr></div><div class=\"col-lg-12\"><form name=\"registerForm\" role=\"form\" ng-submit=\"vm.signUp()\"><div class=\"form-group\" ng-class=\"{ \'has-error\': registerForm.nombreUsuario.$touched && registerForm.nombreUsuario.$invalid }\"><label for=\"nombreUsuario\">RUT Proveedor</label> <input type=\"text\" name=\"nombreUsuario\" id=\"nombreUsuario\" class=\"form-control\" placeholder=\"RUT Proveedor\" ng-model=\"vm.registration.userName\" required=\"\" ng-disabled=\"vm.mensajeUsuario.esProveedor == true\"> <button style=\"margin-top: 10px;\" type=\"button\" class=\"btn btn-xs btn-primary btn-block\" ng-click=\"vm.checkUser()\" ng-disabled=\"!vm.registration.userName.length > 0\" ng-hide=\"vm.mensajeUsuario.esProveedor == true\">Verificar si existen registros <i class=\"fa fa-check-square-o\" aria-hidden=\"true\"></i></button><div ng-show=\"vm.mensajeUsuario.esProveedor == false && vm.mensajeUsuario.mensaje.length > 0\"><p class=\"help-block\" style=\"color: darkred;\">{{vm.mensajeUsuario.mensaje}}</p></div><div ng-show=\"registerForm.nombreUsuario.$touched\"><p ng-show=\"registerForm.nombreUsuario.$error.required\" class=\"help-block\">Debe ingresar un <strong>nombre de usuario</strong></p></div></div><div ng-show=\"vm.mensajeUsuario.esProveedor == true\"><div class=\"alert alert-info alert-dismissible\" role=\"alert\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><p><strong>ATENCI&Oacute;N</strong><br>Su contrase&ntilde;a debe contar con <strong>al menos:</strong></p><ul style=\"margin: 8px 0;\"><li>6 caracteres</li><li>Contener may&uacute;sculas y min&uacute;sculas</li><li>Incluir un d&iacute;gito (0-9)</li><li>Un caracter especial (%,#,-, etc.)</li></ul><p><strong>Ejemplo:</strong>Proveedor_123</p></div><div class=\"form-group\" ng-class=\"{ \'has-error\': registerForm.passwordUsuario.$touched && registerForm.passwordUsuario.$invalid, \'has-success\': registerForm.passwordUsuario.$valid }\"><label for=\"passwordUsuario\">Contrase&ntilde;a</label> <input type=\"password\" name=\"passwordUsuario\" id=\"passwordUsuario\" class=\"form-control\" placeholder=\"Password\" ng-model=\"vm.registration.password\" required=\"\"><div ng-show=\"registerForm.passwordUsuario.$touched\"><p ng-show=\"registerForm.passwordUsuario.$error.required\" class=\"help-block\">Debe ingresar una <strong>contrase&ntilde;a</strong></p></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': registerForm.passwordConfUsuario.$touched && registerForm.passwordConfUsuario.$invalid, \'has-success\': registerForm.passwordConfUsuario.$valid }\"><label for=\"passwordConfUsuario\">Confirma Contrase&ntilde;a</label> <input type=\"password\" name=\"passwordConfUsuario\" id=\"passwordConfUsuario\" class=\"form-control\" placeholder=\"Confirmar Password\" ng-model=\"vm.registration.confirmPassword\" required=\"\" pw-check=\"passwordUsuario\"><div ng-show=\"registerForm.passwordConfUsuario.$touched\"><p ng-show=\"registerForm.passwordConfUsuario.$error.required\" class=\"help-block\">Debe confirmar <strong>contrase&ntilde;a</strong></p><p ng-show=\"registerForm.passwordConfUsuario.$error.pwmatch\" class=\"help-block\">Passwords <strong>no coinciden</strong></p></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': registerForm.razonSocialUsuario.$touched && registerForm.razonSocialUsuario.$invalid, \'has-success\': registerForm.razonSocialUsuario.$valid }\"><label for=\"razonSocialUsuario\">Raz&oacute;n Social (Nombre Empresa)</label> <input type=\"text\" name=\"razonSocialUsuario\" id=\"razonSocialUsuario\" class=\"form-control\" placeholder=\"Nombre Empresa\" ng-model=\"vm.registration.razonSocial\" required=\"\"><div ng-show=\"registerForm.razonSocialUsuario.$touched\"><p ng-show=\"registerForm.razonSocialUsuario.$error.required\" class=\"help-block\">Debe ingresar <strong>raz&oacute;n social</strong></p></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': registerForm.nombreEncargadoUsuario.$touched && registerForm.nombreEncargadoUsuario.$invalid, \'has-success\': registerForm.nombreEncargadoUsuario.$valid }\"><label for=\"nombreEncargadoUsuario\">Nombre Encargado</label> <input type=\"text\" name=\"nombreEncargadoUsuario\" id=\"nombreEncargadoUsuario\" class=\"form-control\" placeholder=\"Nombre Encargado\" ng-model=\"vm.registration.nombreEncargado\" required=\"\"><div ng-show=\"registerForm.nombreEncargadoUsuario.$touched\"><p ng-show=\"registerForm.nombreEncargadoUsuario.$error.required\" class=\"help-block\">Debe ingresar <strong>nombre de encargado</strong></p></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': registerForm.emailEncargadoUsuario.$touched && registerForm.emailEncargadoUsuario.$invalid, \'has-success\': registerForm.emailEncargadoUsuario.$valid }\"><label for=\"emailEncargadoUsuario\">Email Encargado</label> <input type=\"email\" name=\"emailEncargadoUsuario\" id=\"emailEncargadoUsuario\" class=\"form-control\" placeholder=\"Mail Encargado\" ng-model=\"vm.registration.email\" required=\"\"><div ng-show=\"registerForm.emailEncargadoUsuario.$touched\"><p ng-show=\"registerForm.emailEncargadoUsuario.$error.required\" class=\"help-block\">Debe ingresar <strong>email de encargado</strong></p><p ng-show=\"registerForm.emailEncargadoUsuario.$error.email\" class=\"help-block\">Email ingresado <strong>no es v&aacute;lido</strong></p></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': registerForm.cargoEncargadoUsuario.$touched && registerForm.cargoEncargadoUsuario.$invalid, \'has-success\': registerForm.cargoEncargadoUsuario.$valid }\"><label for=\"cargoEncargadoUsuario\">Cargo Encargado</label> <input type=\"text\" name=\"cargoEncargadoUsuario\" id=\"cargoEncargadoUsuario\" class=\"form-control\" placeholder=\"Cargo Encargado\" ng-model=\"vm.registration.cargoEncargado\" required=\"\"><div ng-show=\"registerForm.cargoEncargadoUsuario.$touched\"><p ng-show=\"registerForm.cargoEncargadoUsuario.$error.required\" class=\"help-block\">Debe ingresar <strong>cargo de encargado</strong></p></div></div><button class=\"btn btn-info btn-block\" type=\"submit\" ng-disabled=\"!registerForm.$valid\">REGISTRARSE <i class=\"fa fa-sign-in\" aria-hidden=\"true\"></i></button><div ng-show=\"vm.mensajesRegistro.length > 0\" ng-class=\"(vm.savedSuccessfully) ? \'alert alert-success\' : \'alert alert-danger\'\" style=\"margin-top: 20px;\"><p style=\"font-size: 15px;\" ng-repeat=\"error in vm.mensajesRegistro\">{{error}}</p></div></div></form></div></div></div></div>");
$templateCache.put("app/main/main.html","<div smooth-scroll=\"\" offset=\"60\"></div><div class=\"header-jumbo\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-7 col-sm-12 col-xs-12 jumbo-seccion-naranja\" style=\"background-color: black; background-image:url(assets/images/metso-personal-3.jpg);\"><div class=\"row\"></div></div><div class=\"col-lg-5 col-sm-12 col-xs-12 jumbo-seccion-naranja\" style=\"background-color: black;\"><div class=\"row\"><div class=\"col-lg-12 col-sm-12 col-xs-12\"><p>RAZ&Oacute;N SOCIAL</p><h1 style=\"margin-top: 0\">{{vm.proveedorInfo.razonSocial}}</h1><p>RUT PROVEEDOR</p><h2 style=\"margin-top: 0\">{{vm.authentication.userName}}</h2></div></div></div></div></div></div><div class=\"container\" id=\"main-content\" ng-intro-method=\"TutorialMainFiltros\" ng-intro-options=\"vm.introFiltrosOptions\"><div class=\"row bloque-lightgray-metso bloque-filtro\" ng-if=\"vm.proveedorInfo.isAdmin\"><div class=\"col-lg-12 col-sm-12 col-xs-12\"><div class=\"row\"><div class=\"col-lg-12 col-xs-12 col-sm-12\"><h1><i class=\"fa fa-unlock-alt\" aria-hidden=\"true\"></i> Administrador | B&uacute;squeda por Proveedor</h1><p class=\"lead\">Usted est&aacute; asignado con el rol de administrador del sistema por lo que puede consultar como cualquiera de los Proveedores con registros activos (documentos). Una vez seleccionado el proveedor puede utilizar el sistema de consultas con normalidad.</p></div></div><div class=\"row\"><div class=\"col-lg-4 col-sm-12 col-xs-12\"><div class=\"form-group\"><label id=\"admin-proveedor\">Ver como PROVEEDOR espec&iacute;fico:</label><angucomplete-alt id=\"admin-proveedor\" placeholder=\"Ingrese RUT o Raz&oacute;n Social\" pause=\"400\" selected-object=\"vm.adminProveedorCallback\" remote-url=\"{{vm.urlBase}}\" remote-url-data-field=\"results\" title-field=\"nombre\" description-field=\"rut\" input-class=\"form-control input-sm\"></angucomplete-alt><span class=\"help-block\">Debe ingresar como m&iacute;nimo <strong>3 caracteres</strong>, si la b&uacute;squeda no arroja resultados es porque <strong>no existen registros activos</strong> para el proveedor consultado</span></div></div><div class=\"col-lg-8 col-sm-12 col-xs-12 bloque-gray-proveedor-seleccionado\"><h5>CONSULTANDO DOCUMENTOS COMO</h5><h2>{{vm.adminProveedor.title}}</h2><p class=\"lead\">{{vm.adminProveedor.description}}</p><p>{{vm.adminProveedor.emailUsuario}} | {{vm.adminProveedor.nombreEncargado}}</p></div></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"row\"><div class=\"col-lg-7 col-xs-12 col-sm-12\"><h1><i class=\"fa fa-search\" aria-hidden=\"true\"></i> B&uacute;squeda de Documentos</h1></div><div class=\"col-lg-5 hidden-xs hidden-sm\"><button class=\"button-special tutorial-span hidden-xs hidden-sm pull-right\" style=\"margin-top: 22px;\" ng-click=\"TutorialMainFiltros()\">&iquest;C&oacute;mo funcionan los filtros?</button></div></div><hr></div><div class=\"col-lg-7 col-sm-12 col-xs-12 bloque-naranjo-metso bloque-filtro\" style=\"background-color: black;\" id=\"caja-filtro-periodo\"><div class=\"form-wrapper-main\"><div class=\"row\"><div class=\"col-lg-12 col-xs-12\"><h3>B&uacute;squeda por Per&iacute;odo</h3></div></div><div class=\"row\"><div class=\"col-lg-5\"><div class=\"form-group\"><label for=\"resumen-periodo\">Per&iacute;odo B&uacute;squeda</label> <span id=\"resumen-periodo\" class=\"ddl-rangofechas date-picker form-control input-sm\"><span class=\"glyphicon glyphicon-calendar\"></span> Desde <strong>{{vm.datePicker.date.startDate.format(\'DD/MM/YYYY\')}}</strong> hasta <strong>{{vm.datePicker.date.endDate.format(\'DD/MM/YYYY\')}}</strong></span> <span id=\"helpBlock\" class=\"help-block\">Click para seleccionar per&iacute;odo espec&iacute;fico</span></div></div><div class=\"col-lg-4\"><div class=\"form-group\"><label>Estado Documento</label><select class=\"form-control input-sm\" ng-model=\"vm.consultaDocumento.estado\" id=\"filtro-estado-documento\"><option value=\"\">Seleccionar estado</option><option value=\"todos\">TODOS</option><option value=\"recibido\">Recibido</option><option value=\"contabilizado\">Contabilizado</option><option value=\"devuelto\">Devuelto</option><option value=\"rechazado\">Rechazado</option><option value=\"pagado\">Pagado</option></select></div></div><div class=\"col-lg-3\"><div class=\"form-group\"><button type=\"button\" class=\"btn btn-default btn-sm btn-block\" style=\"margin-top:25px;\" ng-click=\"vm.getDocumentos()\" id=\"btn-buscar-periodo\"><span class=\"glyphicon glyphicon-search\"></span> BUSCAR</button></div></div></div></div></div><div class=\"col-lg-2 col-lg-offset-1 col-sm-6 col-xs-6 bloque-filtro\" style=\"background-color:#e6e6e6;\" id=\"caja-filtro-nrofactura\"><h3>Nro. Factura</h3><form name=\"formNumeroFactura\" role=\"form\" ng-submit=\"vm.getDocumentosPorNumero(vm.numeroFacturaConsulta)\" novalidate=\"\"><div class=\"form-group\"><label for=\"numero-folio\">N&uacute;mero Documento</label> <input id=\"numero-folio\" name=\"numero-folio\" class=\"form-control input-sm\" type=\"number\" placeholder=\"ej.: 45687\" min=\"1\" ng-model=\"vm.numeroFacturaConsulta\" ng-minlength=\"1\" required=\"\"></div><button class=\"btn btn-primary btn-xs btn-block\" ng-disabled=\"formNumeroFactura.$invalid\" type=\"submit\">BUSCAR DOCUMENTO</button></form></div><div class=\"col-lg-2 col-sm-6 col-xs-6 bloque-filtro\" style=\"background-color:#f2f2f2;\" id=\"caja-filtro-fechapago\"><h3>Fecha Pago</h3><form name=\"formFechasPagos\" role=\"form\" ng-submit=\"vm.getDocumentosPagados()\" novalidate=\"\"><div class=\"form-group\"><label for=\"fechasPagos\">Fecha Pago <strong>{{vm.fechaPagoSeleccionada | date:\'dd/MM/yyyy\'}}</strong></label><select id=\"fechasPagos\" name=\"fechasPagos\" class=\"form-control input-sm\" ng-model=\"vm.fechaPagoSeleccionada\" required=\"\"><option value=\"\">Seleccionar...</option><option ng-repeat=\"fecha in vm.fechasPagos\" value=\"{{fecha | date: \'yyyy-MM-dd\'}}\">{{fecha | date}}</option></select></div><button class=\"btn btn-primary btn-xs btn-block\" ng-disabled=\"formFechasPagos.$invalid\" type=\"submit\">BUSCAR POR FECHA PAGO</button></form></div></div><div class=\"row documentos-tabla padding-bot-top-35\" style=\"margin-top: 50px;\" ng-intro-method=\"TutorialMainResultados\" ng-intro-options=\"vm.introResultadosOptions\"><div class=\"col-lg-12 col-sm-12\" ng-hide=\"vm.documentosProveedor==null\"><div class=\"row\"><div class=\"col-lg-7 col-xs-12 col-sm-12\"><h2><i class=\"fa fa-list-ul\"></i> Resultados B&uacute;squeda</h2></div><div class=\"col-lg-5 hidden-xs hidden-sm\"><button class=\"button-special tutorial-span hidden-xs hidden-sm pull-right\" ng-show=\"vm.documentosProveedor.length> 0\" style=\"margin-top: 22px;\" ng-click=\"TutorialMainResultados()\">COMPONENTES DE LA TABLA DE RESULTADOS</button></div></div></div><div class=\"col-lg-12 col-sm-12 text-center\" ng-show=\"!vm.documentosProveedor.length\"><h1 class=\"text-muted\">Sin datos para mostrar</h1></div><div class=\"col-lg-12 col-sm-12 col-xs-12\" ng-hide=\"vm.documentosProveedor == null\" style=\"margin-top: 35px;\"><div class=\"table-responsive\"><table ng-table=\"vm.tableParams\" class=\"table\" show-filter=\"true\" id=\"tabla-resultados\"><tr ng-repeat=\"doc in $data\" ng-class=\"{ success: doc.estado == \'PAGADO\', warning: doc.estado == \'DEVUELTO\' }\"><td data-title=\"\'RUT\'\" filter=\"{rutProveedor: \'text\'}\" sortable=\"\'rutProveedor\'\" class=\"text-center\" style=\"width: 90px;\" id=\"{{\'res-rutprov-\' + $index}}\">{{doc.rutProveedor}}</td><td data-title=\"\'Nro. Doc.\'\" filter=\"{numeroFactura: \'number\'}\" sortable=\"\'numeroFactura\'\" class=\"text-center\" style=\"width: 120px;\" id=\"{{\'res-nrodoc-\' + $index}}\"><a ui-sref=\".detalle({docID : doc.facturaID})\">{{doc.numeroFactura}}</a></td><td data-title=\"vm.nombreColumnaFecha\" filter=\"{fechaEmision: \'text\'}\" sortable=\"\'fechaEmision\'\" class=\"text-center\" ng-class=\"{ success: vm.columnaSuccess }\" id=\"{{\'res-fechadoc-\' + $index}}\">{{doc.fechaEmision | date:\'yyyy-MM-dd\'}}</td><td data-title=\"\'Fecha Recepci&oacute;n\'\" filter=\"{fechaRecepcion: \'text\'}\" sortable=\"\'fechaRecepcion\'\" class=\"text-center\" id=\"{{\'res-fecharecepciondoc-\' + $index}}\">{{doc.fechaRecepcion | date:\'yyyy-MM-dd\'}}</td><td data-title=\"\'Monto\'\" filter=\"{montoTotal: \'number\'}\" sortable=\"\'montoTotal\'\" class=\"text-center\" id=\"{{\'res-montodoc-\' + $index}}\">{{doc.montoTotal | currency:\'$\':0}}</td><td data-title=\"\'Pagado\'\" sortable=\"\'montoPagado\'\" class=\"text-center\" id=\"{{\'res-pagadodoc-\' + $index}}\">{{doc.montoPagado | currency:\'$\':0}}</td><td data-title=\"\'Estado\'\" filter=\"{estado: \'text\'}\" sortable=\"\'estado\'\" ng-switch=\"\" on=\"doc.estado | lowercase\" id=\"{{\'res-estadodoc-\' + $index}}\"><span class=\"label label-primary\" ng-switch-when=\"contabilizado\">CONTABILIZADO</span> <span class=\"label label-success\" ng-switch-when=\"pagado\">PAGADO</span> <span class=\"label label-warning\" ng-switch-when=\"devuelto\">DEVUELTO</span> <span class=\"label label-danger\" ng-switch-when=\"rechazado\">RECHAZADO</span> <span class=\"label label-default\" ng-switch-default=\"\">RECIBIDO</span></td><td data-title=\"\'Tickets\'\" class=\"text-center\" style=\"width: 90px;\" id=\"{{\'res-ticketsdoc-\' + $index}}\"><span class=\"badge\">{{doc.ticketsAsociados}}</span></td><td data-title=\"\'Detalle\'\" style=\"width: 120px;\" class=\"text-center\" id=\"{{\'res-detalledoc-\' + $index}}\"><a ui-sref=\".detalle({docID : doc.facturaID})\" class=\"btn btn-xs btn-default\"><i class=\"fa fa-file-text\"></i> DETALLE</a></td></tr><tr style=\"background-color: #e6e6e6;\" id=\"{{\'res-totales\'}}\"><td></td><td></td><td></td><td style=\"text-align:center;\"><strong>TOTALES</strong></td><td style=\"text-align:center;\"><strong>{{vm.totalDocumentosEmitidos | currency:\'$\':0}}</strong></td><td style=\"text-align:center;\"><strong>{{vm.totalDocumentosPagados | currency:\'$\':0}}</strong></td><td></td><td></td><td></td></tr></table></div></div></div><div class=\"row\" id=\"vista-detalle\"><div ui-view=\"\"></div></div><a href=\"\" scroll-to=\"main-content\" class=\"cd-top\" offset=\"80\">BACK TO TOP</a></div><script>\r\n    (function() {\r\n\r\n        //DateRangePicker\r\n        $(\'#resumen-periodo\').daterangepicker({\r\n                startDate: moment().startOf(\'month\'),\r\n                endDate: moment().endOf(\'month\'),\r\n                //minDate: moment().subtract(3, \'year\'),\r\n                maxDate: moment(),\r\n                locale: {\r\n                    format: \'DD/MM/YYYY\',\r\n                    applyLabel: \'Aplicar\',\r\n                    cancelLabel: \'Cancelar\',\r\n                    customRangeLabel: \'Especificar Rango\'\r\n                },\r\n                autoApply: true,\r\n                ranges: {\r\n                    \'Mes Actual\': [moment().startOf(\'month\'), moment().endOf(\'month\')],\r\n                    \'&Uacute;ltimos 30 D&iacute;as\': [moment().subtract(29, \'days\'), moment()],\r\n                    \'Mes Anterior\': [moment().subtract(1, \'month\').startOf(\'month\'), moment().subtract(1, \'month\').endOf(\'month\')],\r\n                    \'A&ntilde;o Actual\': [moment().startOf(\'year\'), moment().endOf(\'year\')],\r\n                    \'&Uacute;ltimos 12 Meses\': [moment().subtract(12, \'month\'), moment()],\r\n                    \'A&ntilde;o Anterior\': [moment().subtract(1, \'year\').startOf(\'year\'), moment().subtract(1, \'year\').endOf(\'year\')]\r\n                }\r\n            },\r\n            function(start, end, label) {\r\n\r\n                //document.querySelector( \'#some-id\' )\r\n                //var scope = angular.element($(\"#main-content\")).scope();\r\n                var scope = angular.element(document.querySelector(\'#main-content\')).scope();\r\n\r\n\r\n                scope.$apply(function() {\r\n                    scope.vm.datePicker.date.startDate = start;\r\n                    scope.vm.datePicker.date.endDate = end;\r\n                })\r\n            });\r\n\r\n        //Back-to-top\r\n\r\n        var offset = 300;\r\n        var offset_opacity = 2000;\r\n\r\n        $back_to_top = $(\'.cd-top\');\r\n\r\n        //hide or show the \"back to top\" link\r\n        $(window).scroll(function() {\r\n\r\n            ($(this).scrollTop() > offset) ? $back_to_top.addClass(\'cd-is-visible\'): $back_to_top.removeClass(\'cd-is-visible cd-fade-out\');\r\n\r\n            if ($(this).scrollTop() > offset_opacity) {\r\n                $back_to_top.addClass(\'cd-fade-out\');\r\n            }\r\n        });\r\n\r\n\r\n\r\n    })();\r\n</script>");
$templateCache.put("app/test/test.html","<metso-jumbotron-component></metso-jumbotron-component>");
$templateCache.put("app/reportes/reportes.html","<div class=\"container containerVertical\" style=\"padding: 80px 0; margin-bottom: 50px;\"><div id=\"barra-estado-wrapper\"><div class=\"row box-dashboard box-margin-bot-50\"><barra-estado-reportes-component></barra-estado-reportes-component></div></div><div class=\"espaciador-reportes\" id=\"ciclo-vida-wrapper\"><h1 class=\"reporte-titulo\">Ciclo de Vida Documentos</h1><ciclo-vida-main-component style=\"display: block;\"></ciclo-vida-main-component></div><div class=\"espaciador-reportes\" id=\"performance-analistas-wrapper\"><h1 class=\"reporte-titulo\">Performance Analistas</h1><analistas-performance-component></analistas-performance-component></div><div class=\"espaciador-reportes\" id=\"tickets-respuesta-wrapper\"><h1 class=\"reporte-titulo\">Tickets vs. Tiempo Respuesta</h1><tickets-respuesta-component show-date=\"true\"></tickets-respuesta-component></div><fixed-navigator-component></fixed-navigator-component></div><style>\r\n    body {\r\n        background-color: #f2f2f2;\r\n    }\r\n    /* CORRIGE ERROR EN MODAL AL NO PODER ALTERAR Z-INDEX */\r\n    .modal-fix{\r\n        margin-top: 50px !important;\r\n    }\r\n\r\n</style>");
$templateCache.put("app/recuperarpassword/recuperarpassword.html","<div class=\"header-jumbo\"><jumbotron-portal encabezado=\"\'Recuperar Contrase&ntilde;a\'\" texto=\"\'Reestablezca su contrase&ntilde;a para poder acceder al Portal Proveedores y revisar sus documentos. La contrase&ntilde;a ser&aacute; enviada al correo asignado al momento de registrarse por primera vez en el sistema\'\" con-documentos=\"true\"></jumbotron-portal></div><div class=\"container\" style=\"min-height: 350px;\"><div class=\"row padding-bot-top-35\"><div class=\"col-lg-6 col-sm-12 col-xs-12 padding-bottom-35\"><h1>Recuperar su contrase&ntilde;a</h1><p>Mediante este formulario podr&aacute; iniciar el proceso para reestablecer su contrase&ntilde;a. Primero debe ingresar su RUT de Proveedor para verificar que est&aacute; actualmente registrado en el sistema, posteriormente se enviar&aacute; un correo electr&oacute;nico a la direcci&oacute;n asociada a su cuenta al momemnto de <strong>registrarse</strong> por primera vez al sistema. A su correo llegar&aacute; un mensaje con las instrucciones pertinentes.</p></div><div class=\"col-lg-5 col-lg-offset-1 col-sm-12 col-xs-12 form-wrapper padding-col-35\"><div class=\"col-lg-12 text-center\"><i class=\"fa fa-unlock-alt fa-5x\" aria-hidden=\"true\"></i><h2>Ingrese RUT Proveedor</h2><hr></div><div class=\"col-lg-12\"><form name=\"recuperarForm\" role=\"form\" ng-submit=\"vm.forgotPassword()\"><div class=\"form-group\" ng-class=\"{ \'has-error\': recuperarForm.nombreUsuario.$touched && recuperarForm.nombreUsuario.$invalid }\"><label for=\"nombreUsuario\" class=\"control-label\">RUT Proveedor</label> <input type=\"text\" name=\"nombreUsuario\" id=\"nombreUsuario\" class=\"form-control\" placeholder=\"RUT Proveedor\" ng-model=\"vm.registration.userName\" required=\"\" ng-disabled=\"vm.mensajeUsuario.esProveedor == true\"> <button style=\"margin-top: 10px;\" type=\"button\" class=\"btn btn-xs btn-info btn-block\" ng-click=\"vm.checkUser()\" ng-disabled=\"!vm.registration.userName.length > 0\" ng-hide=\"vm.mensajeUsuario.esProveedor == true\">Verificar Usuario <i class=\"fa fa-check-square-o\" aria-hidden=\"true\"></i></button><div ng-show=\"vm.mensajeUsuario.esProveedor == false && vm.mensajeUsuario.mensaje.length > 0\"><p class=\"help-block\" style=\"color: darkred;\" ng-bind-html=\"vm.mensajeUsuario.mensaje\"></p></div><div ng-show=\"registerForm.nombreUsuario.$touched\"><p ng-show=\"registerForm.nombreUsuario.$error.required\" class=\"help-block\">Debe ingresar un <strong>nombre de usuario</strong></p></div></div><div ng-show=\"vm.mensajeUsuario.esProveedor\"><div class=\"alert alert-success text-center\" style=\"margin-top: 20px;\"><p style=\"font-size: 13px;\">Usted est&aacute; registrado como proveedor en nuestro portal, el correo con la informaci&oacute;n para reestablecer su contrase&ntilde;a ser&aacute; enviado a la siguiente direcci&oacute;n</p><p style=\"font-size: 16px;\"><strong>{{vm.datosUsuario.emailUsuario}}</strong></p><p></p></div><button class=\"btn btn-info btn-block\" type=\"submit\" ng-disabled=\"!recuperarForm.$valid || !vm.mensajeUsuario.esProveedor\">RECUPERAR CONTRASE&Ntilde;A <i class=\"fa fa-sign-in\" aria-hidden=\"true\"></i></button></div></form></div></div></div></div>");
$templateCache.put("app/recuperarpassword/resetpassword.html","<div class=\"header-jumbo\"><jumbotron-portal encabezado=\"\'Confirmar Nueva Contrase&ntilde;a\'\" texto=\"\'Genere su nueva contrase&ntilde;a para poder operar en el Portal Proveedores. A la izquierda del formulario cuenta con instrucciones y detalles del proceso en curso\'\" con-documentos=\"true\"></jumbotron-portal></div><div class=\"container\" style=\"min-height: 350px;\"><div class=\"row padding-bot-top-35\"><div class=\"col-lg-6 col-sm-12 col-xs-12 padding-bottom-35\"><h1>Ingreso de nueva constrase&ntilde;a</h1><p>Usted ingres&oacute; a esta p&aacute;gina mediante el correo electr&oacute;nico que envi&oacute; el Portal Proveedores Metso con el fin de reestablecer su contrase&ntilde;a. Ahora solo debe ingresar su nueva contrase&ntilde;a recordando que debe ser de <strong>al menos 6 caracteres, tener como m&iacute; un caracter especial (#, $, _,%, etc.) y contar con letras may&uacute;sculas y min&uacute;sculas.</strong> Esto con el fin de velar por la seguridad e integridad de sus datos</p></div><div class=\"col-lg-5 col-lg-offset-1 col-sm-12 col-xs-12 form-wrapper padding-col-35\"><div class=\"col-lg-12 text-center\"><i class=\"fa fa-user-plus fa-5x\" aria-hidden=\"true\"></i><h2>Nueva Contrase&ntilde;a</h2><hr></div><div class=\"col-lg-12\"><form name=\"resetForm\" role=\"form\" ng-submit=\"vm.resetPassword()\"><div class=\"alert alert-info alert-dismissible\" role=\"alert\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><p><strong>ATENCI&Oacute;N</strong><br>Su contrase&ntilde;a debe contar con <strong>al menos:</strong></p><ul style=\"margin: 8px 0;\"><li>6 caracteres</li><li>Contener may&uacute;sculas y min&uacute;sculas</li><li>Incluir un d&iacute;gito (0-9)</li><li>Un caracter especial (%,#,-, etc.)</li></ul><p><strong>Ejemplo:</strong>Proveedor_123</p></div><div class=\"form-group\" ng-class=\"{ \'has-error\': resetForm.passwordUsuario.$touched && resetForm.passwordUsuario.$invalid, \'has-success\': resetForm.passwordUsuario.$valid }\"><label for=\"passwordUsuario\">Nueva Contrase&ntilde;a</label> <input type=\"password\" name=\"passwordUsuario\" id=\"passwordUsuario\" class=\"form-control\" placeholder=\"Password\" ng-model=\"vm.resetPasswordViewModel.password\" required=\"\"><div ng-show=\"resetForm.passwordUsuario.$touched\"><p ng-show=\"resetForm.passwordUsuario.$error.required\" class=\"help-block\">Debe ingresar una <strong>contrase&ntilde;a</strong></p></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': resetForm.passwordConfUsuario.$touched && resetForm.passwordConfUsuario.$invalid, \'has-success\': resetForm.passwordConfUsuario.$valid }\"><label for=\"passwordConfUsuario\">Confirmar Nueva Contrase&ntilde;a</label> <input type=\"password\" name=\"passwordConfUsuario\" id=\"passwordConfUsuario\" class=\"form-control\" placeholder=\"Confirmar Password\" ng-model=\"vm.confirmPassword\" required=\"\" pw-check=\"passwordUsuario\"><div ng-show=\"resetForm.passwordConfUsuario.$touched\"><p ng-show=\"resetForm.passwordConfUsuario.$error.required\" class=\"help-block\">Debe confirmar <strong>contrase&ntilde;a</strong></p><p ng-show=\"resetForm.passwordConfUsuario.$error.pwmatch\" class=\"help-block\">Passwords <strong>no coinciden</strong></p></div></div><button class=\"btn btn-info btn-block\" type=\"submit\" ng-disabled=\"!resetForm.$valid\">CONFIRMAR PASSWORD <i class=\"fa fa-sign-in\" aria-hidden=\"true\"></i></button><div ng-show=\"vm.mensajesRegistro.length > 0\" ng-class=\"(vm.savedSuccessfully) ? \'alert alert-success\' : \'alert alert-danger\'\" style=\"margin-top: 20px;\"><p style=\"font-size: 15px;\" ng-repeat=\"error in vm.mensajesRegistro\">{{error}}</p></div></form></div></div></div></div>");
$templateCache.put("app/userdata/userdata.html","<div class=\"container\"><div class=\"row\"><div class=\"col-lg-8 col-sm-12\"><form role=\"form\" name=\"userDataForm\" novalidate=\"\" ng-submit=\"vm.sendUserData()\"><div class=\"form-group\" ng-class=\"{ \'has-error\': userDataForm.email.$touched && userDataForm.email.$invalid, \'has-success\': userDataForm.email.$valid }\"><label for=\"email\" class=\"control-label\">Email Encargado *</label> <input type=\"email\" class=\"form-control\" ng-model=\"vm.userData.email\" id=\"email\" name=\"email\" required=\"\"><div ng-show=\"userDataForm.email.$touched\"><p ng-show=\"userDataForm.email.$error.required\" class=\"help-block\">Este campo es obligatorio</p><p ng-show=\"userDataForm.email.$error.email\" class=\"help-block\"><strong>Debe ser un correo electr&oacute;nico v&aacute;lido</strong></p></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': userDataForm.nombreEncargado.$touched && userDataForm.nombreEncargado.$invalid, \'has-success\': userDataForm.nombreEncargado.$valid }\"><label for=\"nombreEncargado\" class=\"control-label\">Nombre Encargado</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.userData.nombreEncargado\" id=\"nombreEncargado\" name=\"nombreEncargado\" required=\"\"><div ng-show=\"userDataForm.nombreEncargado.$touched\"><p ng-show=\"userDataForm.nombreEncargado.$error.required\" class=\"help-block\">Este campo es obligatorio</p></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': userDataForm.cargoEncargado.$touched && userDataForm.cargoEncargado.$invalid, \'has-success\': userDataForm.cargoEncargado.$valid }\"><label for=\"cargoEncargado\" class=\"control-label\">Cargo Encargado</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.userData.cargoEncargado\" id=\"cargoEncargado\" name=\"cargoEncargado\" required=\"\"><div ng-show=\"userDataForm.cargoEncargado.$touched\"><p ng-show=\"userDataForm.cargoEncargado.$error.required\" class=\"help-block\">Este campo es obligatorio</p></div></div><button type=\"submit\" class=\"btn btn-sm btn-block\">MODIFICAR DATOS USUARIO</button></form></div></div></div>");
$templateCache.put("app/welcome/welcome.html","<div smooth-scroll=\"\" offset=\"60\"></div><metso-jumbotron-component class=\"hidden-xs hidden-sm\"></metso-jumbotron-component><div class=\"header-jumbo hidden-md hidden-lg\"><jumbotron-portal encabezado=\"\'Bienvenido\'\" texto=\"\'Bienvenido al Portal de Proveedores Metso Chile S.A. En caso de requerir más información tiene a su disposición los siguientes recursos\'\" con-documentos=\"true\"></jumbotron-portal></div><div class=\"row padding-bot-top-35\" id=\"metso-welcome-login\" style=\"display: none;\"><div class=\"col-lg-12\"><div class=\"alert alert-danger\" role=\"alert\" style=\"text-align: center;\"><p style=\"font-size: 18px; text-align: center;\"><i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i> Metso Outotec ha contar del 01 de Junio, cambia de facturador electrónico; la nueva casilla de intercambio de documentos electrónicos, donde deberán ser enviados los documentos emitidos a Metso Outotec será dte.cl@einvoicing.signature-clud.com, favor modificar dicha información en sus plataformas electrónicas, para no sufrir inconvenientes en sus pagos futuros</p></div></div></div><div class=\"container\" style=\"min-height: 450px;\" ng-intro-method=\"TutorialWelcome\" ng-intro-options=\"vm.introWelcomeOptions\"><div class=\"row\" style=\"margin-top: 10px ;\"><div class=\"col-md-12\"><div class=\"alert alert-danger\" role=\"alert\" style=\"text-align: center;\"><p style=\"font-size: 23px;\"><i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i> Estimado Proveedor, recuerde que desde el 01/05/2021, todos los documentos deben ser emitidos a la razón social Metso Outotec Chile Spa, para mas información ingrese <a href=\"https://gestionproveedores.metsoadm.cl/DocumentosPortal/Cambio%20Raz%C3%B3n%20Social%20MO%20Portal.pdf\">aqui</a></p></div></div></div><div class=\"row padding-bot-top-35\" id=\"metso-welcome-login\"><div class=\"col-lg-6 col-sm-12 col-xs-12 padding-bottom-35\"><h1 style=\"font-size: 55px;\">Bienvenido al Portal de Proveedores</h1><p>Esta es una herramienta que Metso Outotec pone a disposici&oacute;n de nuestros proveedores con el objetivo de llevar un seguimiento del estado y situaci&oacute;n de los documentos contables que hayan sido recepcionados por nuestro Departamento de Contabilidad</p><p>Para poder operar en el Portal de Proveedores Metso Outotec es necesario <strong>iniciar sesi&oacute;n</strong> con su cuenta de usuario. En caso de que no cuente con una por favor <strong><a ui-sref=\"signup\">reg&iacute;strese aqu&iacute;</a></strong></p><button class=\"button-special tutorial-span hidden-xs hidden-sm\" ng-click=\"TutorialWelcome()\">VER TUTORIAL PARA LA P&Aacute;GINA DE INICIO</button></div><div class=\"col-lg-5 col-lg-offset-1 col-sm-12 col-xs-12 form-wrapper padding-col-35\" id=\"intro-login-welcome\"><div ng-hide=\"vm.isAuthenticated()\"><div class=\"col-lg-12 text-center\"><h2>Iniciar Sesi&oacute;n <i class=\"fa fa-user\" aria-hidden=\"true\"></i><i class=\"fa fa-sign-in\" aria-hidden=\"true\"></i></h2><hr></div><div class=\"col-lg-12\"><div ui-view=\"login\"></div></div></div><div ng-show=\"vm.isAuthenticated()\"><div class=\"col-lg-12 text-center\"><h4><small>INFORMACION USUARIO</small></h4><h2>{{vm.userData.razonSocial}}</h2><h3>{{vm.userData.rutProveedor}}</h3><hr><div ng-show=\"!vm.mostrarFormModificacion\"><p><small>EMAIL ENCARGADO</small></p><h4>{{vm.userData.email}}</h4><p><small>NOMBRE ENCARGADO</small></p><h4>{{vm.userData.nombreEncargado}}</h4><p><small>CARGO ENCARGADO</small></p><h4>{{vm.userData.cargoEncargado}}</h4><button type=\"button\" class=\"btn btn-sm btn-block\" ng-click=\"vm.mostrarFormModificacion = true\">MODIFICAR DATOS USUARIO</button></div></div><div class=\"col-lg-12\" ng-show=\"vm.mostrarFormModificacion\"><form role=\"form\" name=\"userDataForm\" novalidate=\"\" ng-submit=\"vm.sendUserData()\"><div class=\"form-group\" ng-class=\"{ \'has-error\': userDataForm.email.$touched && userDataForm.email.$invalid, \'has-success\': userDataForm.email.$valid }\"><label for=\"email\" class=\"control-label\">Email Encargado *</label> <input type=\"email\" class=\"form-control input-sm\" ng-model=\"vm.userData.email\" id=\"email\" name=\"email\" required=\"\"><div ng-show=\"userDataForm.email.$touched\"><p ng-show=\"userDataForm.email.$error.required\" class=\"help-block\">Este campo es obligatorio</p><p ng-show=\"userDataForm.email.$error.email\" class=\"help-block\"><strong>Debe ser un correo electr&oacute;nico v&aacute;lido</strong></p></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': userDataForm.nombreEncargado.$touched && userDataForm.nombreEncargado.$invalid, \'has-success\': userDataForm.nombreEncargado.$valid }\"><label for=\"nombreEncargado\" class=\"control-label\">Nombre Encargado</label> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"vm.userData.nombreEncargado\" id=\"nombreEncargado\" name=\"nombreEncargado\" required=\"\"><div ng-show=\"userDataForm.nombreEncargado.$touched\"><p ng-show=\"userDataForm.nombreEncargado.$error.required\" class=\"help-block\">Este campo es obligatorio</p></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': userDataForm.cargoEncargado.$touched && userDataForm.cargoEncargado.$invalid, \'has-success\': userDataForm.cargoEncargado.$valid }\"><label for=\"cargoEncargado\" class=\"control-label\">Cargo Encargado</label> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"vm.userData.cargoEncargado\" id=\"cargoEncargado\" name=\"cargoEncargado\" required=\"\"><div ng-show=\"userDataForm.cargoEncargado.$touched\"><p ng-show=\"userDataForm.cargoEncargado.$error.required\" class=\"help-block\">Este campo es obligatorio</p></div></div><button type=\"submit\" ng-disabled=\"userDataForm.$invalid\" class=\"btn btn-sm btn-block\" ng-class=\"{\'btn-success\': userDataForm.$valid}\">GUARDAR DATOS USUARIO</button> <button type=\"button\" ng-click=\"vm.mostrarFormModificacion = false\" class=\"btn btn-sm btn-block\">CANCELAR</button></form></div></div></div></div><div id=\"tests\"></div><div id=\"metso-welcome-recursos\" class=\"row padding-bot-top-35\"><div class=\"col-lg-12 col-xs-12\" id=\"intro-inforecursos-welcome\"><h1 style=\"font-size: 55px;\">Informaci&oacute;n & Recursos</h1><hr></div><div class=\"col-lg-6 col-sm-12 col-xs-12 padding-bottom-35\" id=\"intro-faq-welcome\"><h1>Preguntas Frecuentes</h1><p style=\"margin-bottom: 35px;\">En caso de tener consultas en particular nos puede contactar v&iacute;a correo electr&oacute;nico o a nuestros tel&eacute;fonos de contacto</p><faq-portal></faq-portal></div><div class=\"col-lg-5 col-lg-offset-1 col-sm-12 col-xs-12 padding-col-35\" id=\"intro-docs-welcome\"><h1>Documentos y Manuales</h1><p style=\"margin-bottom: 35px;\">En caso de tener consultas en particular nos puede contactar v&iacute;a correo electr&oacute;nico o a nuestros tel&eacute;fonos de contacto</p><documentos-portal tipo=\"\'listgroup\'\" con-bullet=\"true\"></documentos-portal></div></div><div class=\"row padding-bot-top-35\"><div class=\"col-lg-12 col-sm-12 col-xs-12\" style=\"text-align:center;\"><h1 style=\"font-size: 55px;\"><i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i> Horarios de Atenci&oacute;n</h1><div ng-switch=\"vm.hoy.day()\"><section ng-switch-when=\"3\"><h2>Hoy <strong>{{vm.hoy.format(\'dddd\')}}</strong> {{vm.hoy.format(\'D [de] MMMM [del] YYYY\')}}, <strong>desde 9 a 18 horas</strong></h2><h2><i class=\"fa fa-phone\" aria-hidden=\"true\"></i> +56 32 227 0800</h2></section><section ng-switch-when=\"5\"><h2>Hoy <strong>{{vm.hoy.format(\'dddd\')}}</strong> {{vm.hoy.format(\'D [de] MMMM [del] YYYY\')}}, <strong>desde 9 a 15 horas</strong></h2><h2><i class=\"fa fa-phone\" aria-hidden=\"true\"></i> +56 32 227 0800</h2></section><section ng-switch-default=\"\"></section></div><hr></div><div class=\"col-lg-12 col-xs-12\" style=\"text-align: center;\"><h2>INFORMACI&Oacute;N CONTACTO</h2><h4><i class=\"fa fa-globe\" aria-hidden=\"true\"></i> <a href=\"http://www.mogroup.com\" target=\"_blank\">http://www.mogroup.com</a></h4><h4><i class=\"fa fa-phone\" aria-hidden=\"true\"></i> +56 32 227 0800</h4></div><div class=\"col-lg-12 col-xs-12\" style=\"text-align: center;\"><h2>HORARIOS SEMANALES</h2><h4>Mi&eacute;rcoles: Desde 9 a 18 horas</h4><h4>Viernes: Desde 9 a 15.30 horas</h4><h4>Debido a la emergencia nacional por el Covid 19 sólo se estarán atendiendo consultas a través del portal de proveedores de Metso Outotec</h4></div></div></div>");
$templateCache.put("app/components/jumbotron/jumbotron.html","<div class=\"container\"><div class=\"row\"><div class=\"col-lg-7 col-sm-12 col-xs-12 jumbo-seccion-naranja\" style=\"background-color: black;\" id=\"slide-viewer\"><div class=\"row\"></div></div><div class=\"col-lg-5 col-sm-12 col-xs-12 jumbo-seccion-naranja\" style=\"background-color: black;\" id=\"intro-jumbotron-seccion\"><div class=\"row\"><div class=\"col-lg-12 col-sm-12 col-xs-12\"><h1 ng-bind-html=\"vm.encabezado\"></h1><p ng-bind-html=\"vm.texto\"></p></div><div class=\"col-lg-12 col-sm-12 col-xs-12\" ng-show=\"vm.conDocumentos\"><documentos-portal con-bullet=\"true\" tipo=\"\'listunstyled\'\"></documentos-portal></div></div></div></div></div><script type=\"text/javascript\">\r\n    (function() {\r\n        $(\"#slide-viewer\").vegas({\r\n            slides: [{\r\n                src: \"assets/images/Modelo 2.jpg\"\r\n            }],\r\n            timer: false,\r\n            color: \'#fc9000\',\r\n            cover: false,\r\n            overlay: false\r\n        });\r\n    })();\r\n</script><style>\r\n    .vegas-slide-inner {\r\n        background-size: unset;\r\n    }\r\n</style>");
$templateCache.put("app/components/documentos/documentos.html","<section ng-switch=\"\" on=\"vm.tipo | lowercase\"><ul class=\"list-unstyled\" ng-switch-when=\"listunstyled\"><li ng-repeat=\"doc in vm.documentos\"><a href=\"http://gestionproveedores.metsoadm.cl/DocumentosPortal/{{doc.documentoNombreArchivo}}\" target=\"_blank\"><i ng-show=\"vm.conBullet\" class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i> {{doc.documentoDescripcion | uppercase}}</a></li></ul><div class=\"list-group\" ng-switch-when=\"listgroup\"><a ng-repeat=\"doc in vm.documentos\" href=\"http://gestionproveedores.metsoadm.cl/DocumentosPortal/{{doc.documentoNombreArchivo}}\" target=\"_blank\" class=\"list-group-item\"><h5 class=\"list-group-item-heading\"><i ng-show=\"vm.conBullet\" class=\"fa fa-file-pdf-o\" style=\"color: #ff6a00; margin-right: 8px;\" aria-hidden=\"true\"></i> {{doc.documentoDescripcion | uppercase}}</h5></a></div></section>");
$templateCache.put("app/reportes/analistasperformance/analistas-performance.html","<div class=\"row\" style=\"margin-bottom: 45px;\"><form class=\"form\" novalidate=\"\"><div class=\"col-lg-3 col-xs-8\"><div class=\"form-group\"><label>ANALISTA</label><select class=\"form-control input-sm\" name=\"analistaConsulta\" ng-model=\"$ctrl.query.analista\" ng-options=\"analista for analista in $ctrl.analistasDocumentos\" required=\"\"><option value=\"\">TODOS LOS ANALISTAS</option></select></div></div><div class=\"col-lg-2 col-xs-4\"><label for=\"botonEnviar\">.</label> <button type=\"button\" class=\"btn btn-sm btn-block btn-primary\" ng-click=\"$ctrl.getCicloVida()\"><i class=\"fa fa-bar-chart\" aria-hidden=\"true\"></i> ENVIAR</button></div></form></div><div class=\"row box-dashboard box-margin-bot-35\" style=\"background-color: #fff; margin-bottom: 20px; padding: 25px; min-height: 85px;\" ng-if=\"$ctrl.muestraStandby\"><div class=\"col-lg-12\"><h2 class=\"text-center text-muted\"><i class=\"fa fa-cog fa-spin fa-fw\"></i> <span>Esperando consulta para generar reporte. <small>Performance Analistas</small></span></h2></div></div><div class=\"row box-dashboard box-margin-bot-35\" style=\"background-color: #fff; margin-bottom: 20px; padding: 25px;\" ng-show=\"$ctrl.grafico.data.length >0\"><div class=\"col-lg-12\"><canvas height=\"130\" class=\"chart chart-bar\" chart-data=\"$ctrl.grafico.data\" chart-dataset-override=\"$ctrl.grafico.set\" chart-labels=\"$ctrl.grafico.etiquetas\" chart-options=\"$ctrl.grafico.opciones\"></canvas></div></div>");
$templateCache.put("app/reportes/barraestado/barra-estado-main.html","<div class=\"barra-estado-dashboard\"><div class=\"col-lg-2 col-sm-4 col-xs-4 barra-estado-dashboard-box text-center\" ng-if=\"$ctrl.barraEstadoInfo.documentosTotal != null\"><h5>DOCUMENTOS</h5><h1>{{$ctrl.barraEstadoInfo.documentosTotal}}</h1><h5>TOTAL SISTEMA</h5></div><div class=\"col-lg-2 col-sm-4 col-xs-4 barra-estado-dashboard-box text-center\" ng-if=\"$ctrl.barraEstadoInfo.usuariosRegistrados != null\"><h5>USUARIOS</h5><h1>{{$ctrl.barraEstadoInfo.usuariosRegistrados}}</h1><h5>REGISTRADOS</h5></div><div class=\"col-lg-3 col-sm-4 col-xs-4 barra-estado-dashboard-box text-center\" ng-if=\"$ctrl.barraEstadoInfo.ticketsTotal != null\"><h5>TICKETS</h5><h1>{{$ctrl.barraEstadoInfo.ticketsTotal}}</h1><h5><span class=\"text-danger\">ABIERTOS <strong>{{$ctrl.barraEstadoInfo.ticketsAbiertos}}</strong></span> / <span class=\"text-success\">CERRADOS <strong>{{$ctrl.barraEstadoInfo.ticketsCerrados}}</strong></span></h5></div><div class=\"col-lg-5 col-sm-12 col-xs-12 barra-estado-dashboard-box text-center\" ng-if=\"$ctrl.barraEstadoInfo.ultimaCargaDatos != null\" style=\"border-right: none;\"><h5>&Uacute;LTIMA CARGA</h5><h1>{{$ctrl.barraEstadoInfo.ultimaCargaDatos | date:\'dd/MM/yyyy HH:mm\'}}</h1><h5><a ng-href=\"{{$ctrl.baseUrl + \'Upload/docsDMS.xlsx\'}}\">DESCARGAR DATOS <i class=\"fa fa-download\" aria-hidden=\"true\"></i></a></h5></div></div>");
$templateCache.put("app/components/footer/footer.html","<footer class=\"hidden-xs hidden-sm\" id=\"footer\" ng-intro-method=\"CallMe\" ng-intro-options=\"vm.introOptions\" style=\"background-color: black;\"><div class=\"container\"><div class=\"col-lg-3\"><a href=\"http://www.mogroup.com\" target=\"_blank\" title=\"Metso en Espa&ntilde;ol\"><img style=\"width: 60%;\" src=\"assets/images/Whitewordmark.png\"></a><address><strong>Metso Outotec Chile</strong><br>Camino Internacional 5725<br>Con Con, Chile 2510 000<br><abbr title=\"mogroup.com\"><i class=\"fa fa-globe\" aria-hidden=\"true\"></i></abbr> <a href=\"http://www.mogroup.com\" target=\"_blank\">Metso Outotec</a><br><abbr title=\"Email\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i></abbr> <a href=\"mailto:contacto.proveedores@metsoadm.cl\">contacto.proveedores@metsoadm.cl</a></address></div><div class=\"col-lg-4 col-lg-offset-1\"><h5>FORMULARIO CONTACTO <i class=\"fa fa-comment\"></i></h5><p class=\"small\">En caso de que su solicitud corresponda a alguna consulta o problema en nuestra plataforma de proveedores, por favor utilice este formulario</p><form role=\"form\" id=\"footer-contacto\" name=\"footercontacto\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{ \'has-error\': footercontacto.nombreProveedor.$touched && footercontacto.nombreProveedor.$invalid, \'has-success\': footercontacto.nombreProveedor.$valid }\"><label for=\"nombreProveedor\" class=\"control-label\">Nombre Proveedor</label> <input type=\"text\" class=\"form-control input-sm\" name=\"nombreProveedor\" ng-model=\"vm.formularioContacto.nombreProveedor\" required=\"\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\': footercontacto.razonmensaje.$touched && footercontacto.razonmensaje.$invalid, \'has-success\': footercontacto.razonmensaje.$valid }\"><label for=\"razonmensaje\" class=\"control-label\">Razon Mensaje</label><select class=\"form-control input-sm\" name=\"razonmensaje\" ng-model=\"vm.responsableSeleccionado\" ng-options=\"responsable.descripcion for responsable in vm.responsables\" required=\"\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\': footercontacto.rutProveedor.$touched && footercontacto.rutProveedor.$invalid, \'has-success\': footercontacto.rutProveedor.$valid }\"><label for=\"rutProveedor\" class=\"control-label\">RUT/Identificador</label> <input type=\"text\" class=\"form-control input-sm\" name=\"rutProveedor\" ng-model=\"vm.formularioContacto.rutProveedor\" required=\"\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\': footercontacto.emailProveedor.$touched && footercontacto.emailProveedor.$invalid, \'has-success\': footercontacto.emailProveedor.$valid }\"><label for=\"emailProveedor\" class=\"control-label\">Email Contacto</label> <input type=\"email\" class=\"form-control input-sm\" name=\"emailProveedor\" ng-model=\"vm.formularioContacto.emailProveedor\" required=\"\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\': footercontacto.mensajeProveedor.$touched && footercontacto.mensajeProveedor.$invalid, \'has-success\': footercontacto.mensajeProveedor.$valid }\"><label for=\"nombrecontacto\" class=\"control-label\">Mensaje</label> <textarea rows=\"6\" class=\"form-control input-sm\" name=\"mensajeProveedor\" ng-model=\"vm.formularioContacto.mensajeContacto\" required=\"\">\r\n                    </textarea></div><button type=\"button\" ng-disabled=\"footercontacto.$invalid\" class=\"btn pull-right btn-sm btn-default\" ng-click=\"vm.sendFormularioContacto()\">ENVIAR MENSAJE <i class=\"fa fa-send\"></i></button></form></div><div class=\"col-lg-3 col-lg-offset-1\"><div class=\"footer-row\"><h5>S&Iacute;GANOS</h5><p class=\"small\">Siga a Metso Outocec en las redes sociales</p><a href=\"http://twitter.com/metsogroup\" target=\"_blank\" class=\"icon-button twitter\"><i class=\"fa fa-twitter\" aria-hidden=\"true\"></i><span></span></a> <a href=\"http://www.facebook.com/MetsoWorld\" target=\"_blank\" class=\"icon-button facebook\"><i class=\"fa fa-facebook\" aria-hidden=\"true\"></i><span></span></a> <a href=\"http://www.linkedin.com/company/metso\" target=\"_blank\" class=\"icon-button linkedin\"><i class=\"fa fa-linkedin\" aria-hidden=\"true\"></i><span></span></a> <a href=\"https://www.youtube.com/MetsoWorld\" target=\"_blank\" class=\"icon-button youtube\"><i class=\"fa fa-youtube\" aria-hidden=\"true\"></i><span></span></a></div><div class=\"footer-row\"><h5><a href=\"\" ng-click=\"vm.openFaqModal()\">PREGUNTAS FRECUENTES <i class=\"fa fa-question-circle\" aria-hidden=\"true\"></i></a></h5><p class=\"small\">Consulte las Preguntas Frecuentes en una ventana emergente sin perder su trabajo actual</p></div><div class=\"footer-row\" ng-show=\"vm.introOptions.steps.length > 0\"><h5 style=\"margin-top: 20px;\" id=\"intro-tutorial-link\"><a href=\"\" ng-click=\"CallMe()\">EMPEZAR TUTORIAL <i class=\"fa fa-graduation-cap\" aria-hidden=\"true\"></i></a></h5><p class=\"small\">Para poder ver un paso a paso de los componentes de esta p&aacute;gina</p></div></div></div></footer><footer class=\"hidden-md hidden-lg\" id=\"footer-mobile\" style=\"background-color: black;\"><div class=\"container\"><div class=\"col-xs-12 col-sm-12 text-center\"><a href=\"http://www.mogroup.com\" target=\"_blank\" title=\"Metso en Espa&ntilde;ol\"><img style=\"width: 60%;\" src=\"assets/images/Whitewordmark.png\"></a><address><strong>Metso Chile SpA</strong><br>Camino Internacional 5725<br>Con Con, Chile 2510 000<br><abbr title=\"Telefono\"><i class=\"fa fa-phone\" aria-hidden=\"true\"></i></abbr> <a href=\"tel:+56322270800\">+56 32 227 0800</a><br><abbr title=\"Email\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i></abbr> <a href=\"mailto:contacto.proveedores@metsoadm.cl\">contacto.proveedores@metsoadm.cl</a></address></div><div class=\"col-xs-12 col-sm-12 text-center\"><a href=\"http://twitter.com/metsogroup\" target=\"_blank\" class=\"icon-button twitter\"><i class=\"fa fa-twitter\" aria-hidden=\"true\"></i><span></span></a> <a href=\"http://www.facebook.com/MetsoWorld\" target=\"_blank\" class=\"icon-button facebook\"><i class=\"fa fa-facebook\" aria-hidden=\"true\"></i><span></span></a> <a href=\"http://www.linkedin.com/company/metso\" target=\"_blank\" class=\"icon-button linkedin\"><i class=\"fa fa-linkedin\" aria-hidden=\"true\"></i><span></span></a> <a href=\"https://www.youtube.com/MetsoWorld\" target=\"_blank\" class=\"icon-button youtube\"><i class=\"fa fa-youtube\" aria-hidden=\"true\"></i><span></span></a></div></div></footer><script>\r\n    //$(document).ready(function () {\r\n    //    $(\'select.nice-select\').niceSelect();\r\n    //});\r\n</script>");
$templateCache.put("app/reportes/fixednavigator/fixednavigator.html","<div id=\"fixed-navigator\" class=\"hidden-sm hidden-xs\"><a href=\"\" uib-tooltip=\"Barra de Estado\" tooltip-placement=\"left\" tooltip-trigger=\"\'mouseenter\'\" scroll-to=\"barra-estado-wrapper\" offset=\"100\"><i class=\"fa fa-clock-o\"></i></a> <a href=\"\" uib-tooltip=\"Ciclo de Vida\" tooltip-placement=\"left\" tooltip-trigger=\"\'mouseenter\'\" scroll-to=\"ciclo-vida-wrapper\" offset=\"100\">C</a> <a href=\"\" uib-tooltip=\"Performance Analistas\" tooltip-placement=\"left\" tooltip-trigger=\"\'mouseenter\'\" scroll-to=\"performance-analistas-wrapper\" offset=\"100\">P</a> <a href=\"\" uib-tooltip=\"Tickets vs. Respuesta\" tooltip-placement=\"left\" tooltip-trigger=\"\'mouseenter\'\" scroll-to=\"tickets-respuesta-wrapper\" offset=\"100\">T</a></div>");
$templateCache.put("app/components/navbar/navbar.html","<script>\r\n    \'use strict\';\r\n\r\n    // variables\r\n    var menumobile = $(\'#menu-mobile\'); //define selector para el div con contenido del men�\r\n    var menumobile_link = $(\'#menu-mobile a\'); // selectores para link\r\n    var menumobile_opener = $(\'#menu-mobile-opener\');\r\n    var menumobile_brand = $(\'#menu-mobile-brand\');\r\n    var menumovile_overlay_brand = $(\'#overlay-mobile-content-brand\');\r\n\r\n    /* abre men� */\r\n    var openNav = function() {\r\n        menumobile.width(\'100%\');\r\n        menumobile_brand.addClass(\'animated zoomOut\');\r\n        menumobile_opener.addClass(\'animated zoomOut\');\r\n        menumovile_overlay_brand.removeClass(\'animated zoomOut\');\r\n        menumovile_overlay_brand.addClass(\'animated fadeInDown\');\r\n    }\r\n\r\n    /* abre men� */\r\n    var closeNav = function() {\r\n        menumobile.width(\'0%\');\r\n\r\n        menumobile_brand.removeClass(\'animated zoomOut\');\r\n        menumobile_brand.addClass(\'animated zoomIn\');\r\n\r\n        menumobile_opener.removeClass(\'animated zoomOut\');\r\n        menumobile_opener.addClass(\'animated zoomIn\');\r\n\r\n        menumovile_overlay_brand.removeClass(\'animated fadeInDown\');\r\n        menumovile_overlay_brand.addClass(\'animated zoomOut\');\r\n    }\r\n\r\n    /* cierra men� en caso de click a un v�nculo*/\r\n    menumobile_link.on(\'click\', function() {\r\n        closeNav();\r\n    });\r\n</script><style>\r\n    .navbar-inverse .navbar-nav>li>a:focus {\r\n        color: grey;\r\n    }\r\n    \r\n    .navbar-inverse .navbar-nav>li>a:hover,\r\n    .navbar-inverse .navbar-nav>li>a:focus {\r\n        color: rgb(231, 99, 21);\r\n        background-color: transparent;\r\n    }\r\n    \r\n    .navbar-inverse .navbar-nav>li>a {\r\n        color: white;\r\n    }\r\n    \r\n    .btnMenu:hover,\r\n    .btnMenu:focus,\r\n    .btnMenu.focus {\r\n        color: #636363;\r\n        text-decoration: none;\r\n    }\r\n</style><nav class=\"navbar navbar-inverse navbar navbar-metso hidden-xs hidden-sm\"><div class=\"container\" style=\"background-color: black; height: 101%;\"><div class=\"navbar-header\"><a class=\"navbar-brand\" ui-sref=\"home\"><div class=\"logo\" style=\"width: 140px; background-color: white; margin-top: 0px; margin-bottom: 0px; padding-top: 16px; padding-bottom: 9px;\"><img style=\"width: 108%;\" src=\"assets/images/Blackwordmark.png\"></div><div class=\"titulo-industria\" style=\"border-left: 0px solid #d8dddd;\"><h3 style=\"color:white\">Portal Proveedores</h3></div></a></div><ul class=\"nav navbar-nav navbar-right\" style=\"margin-top: 10px; font-weight: bold;\" id=\"intro-navbar\"><li><a ui-sref=\"home\">INICIO</a></li><li ng-show=\"vm.isAuthenticated()\"><a ui-sref=\"main\">DOCUMENTOS</a></li><li ng-show=\"!vm.isAuthenticated()\"><a ui-sref=\"ingresar\">LOGIN</a></li><li ng-show=\"!vm.isAuthenticated()\"><a ui-sref=\"signup\">REGISTRARSE</a></li><li ng-show=\"vm.isAuthenticated()\"><a href=\"\" ui-sref=\"home\"><i class=\"fa fa-user\" aria-hidden=\"true\"></i> {{vm.authentication.userName}}</a></li><li ng-show=\"vm.isAuthenticated()\"><a href=\"\" ng-click=\"vm.logOut()\">CERRAR SESI&Oacute;N <i class=\"fa fa-sign-out\" aria-hidden=\"true\"></i></a></li><li ng-show=\"!vm.isAuthenticated()\"><button type=\"button\" style=\"font-family: \'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 17px; font-weight: bold; background-color: black; color: white; padding-bottom: 0px;padding-top: 10px;\" class=\"btn btn-lg btnMenu\" scroll-to=\"metso-welcome-recursos\" offset=\"50\">Informaci&oacute;n & Manuales</button></li></ul></div></nav><nav id=\"navbar-mobile\" class=\"navbar navbar-inverse navbar-metso hidden-md hidden-lg text-center\" style=\"background-color: black;\"><a ui-sref=\"home\" id=\"menu-mobile-brand\" class=\"pull-left\" style=\"width: 48px\"><img style=\"width: 274%;\" src=\"assets/images/Whitewordmark.png\"></a> <a href=\"\" id=\"menu-mobile-opener\" class=\"pull-right\" onclick=\"openNav()\" style=\"color: white;\">MENU <span class=\"glyphicon glyphicon-option-vertical\"></span></a></nav><div id=\"menu-mobile\" class=\"overlay-mobile\" style=\"background: black;color: white;\"><div class=\"overlay-mobile-content\" style=\"top: -2%;\"><div class=\"logo\" id=\"overlay-mobile-content-brand\" style=\"z-index: 9999;\"><img style=\"width: 60%;\" src=\"assets/images/Whitewordmark.png\"></div><div class=\"menu-mobile-items\"><a class=\"mobile-item\" ui-sref=\"home\">INICIO</a> <a class=\"mobile-item\" ng-show=\"vm.isAuthenticated()\" ui-sref=\"main\">DOCUMENTOS</a> <a class=\"mobile-item\" ng-show=\"!vm.isAuthenticated()\" ui-sref=\"ingresar\">LOGIN</a> <a class=\"mobile-item\" ng-show=\"!vm.isAuthenticated()\" ui-sref=\"signup\">REGISTRARSE</a> <a class=\"mobile-item\" ng-show=\"vm.isAuthenticated()\" href=\"\" ng-click=\"vm.logOut()\">CERRAR SESI&Oacute;N <i class=\"fa fa-sign-out\" aria-hidden=\"true\"></i></a><a href=\"javascript:void(0)\" onclick=\"closeNav()\" class=\"icon-button close-button\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i><span></span></a></div></div></div>");
$templateCache.put("app/components/jumbotron-v2/metsojumbo.html","<div id=\"jumbo-slider-v2\" style=\"background-image: url(assets/images/Modelo 2.jpg);\"><div class=\"container jumbo-content\"><div class=\"row\"></div><div class=\"row jumbo-button-row\"><div class=\"col-lg-12 text-center\"><button ng-show=\"$ctrl.isAuthenticated\" type=\"button\" ui-sref=\"main\" class=\"btn btn-default btn-lg\">Buscar Documentos</button></div></div></div></div><script>\r\n    (function() {\r\n\r\n        var selector = \'#jumbo-slider-v2\';\r\n\r\n        $(selector).vegas({\r\n            slides: [{\r\n                src: \"assets/images/Modelo 2.jpg\"\r\n            }],\r\n            timer: false,\r\n            color: \'#fff\',\r\n            cover: false,\r\n            overlay: false\r\n\r\n        });\r\n\r\n        selector.style\r\n\r\n    })();\r\n</script>");
$templateCache.put("app/reportes/mock/mock.html","<div class=\"col-lg-12\" style=\"margin-bottom: 45px;\"><div class=\"row\"><div class=\"col-lg-4\"><h3>CANTIDAD TOTAL DOCS</h3><h1>23696</h1></div><div class=\"col-lg-8\"><div class=\"row\"><div class=\"col-lg-12\"><h2>CONTABILIZADOS</h2></div><div class=\"col-lg-4\"><h4>SUMA</h4><h3>456</h3></div><div class=\"col-lg-4\"><h4>PROMEDIO</h4><h3>456</h3></div><div class=\"col-lg-4\"><h4>PORCENTAJE</h4><h3>100%</h3></div></div><div class=\"row\"><div class=\"col-lg-12\"><h2>NO CONTABILIZADOS</h2></div><div class=\"col-lg-4\"><h4>SUMA</h4><h3>456</h3></div><div class=\"col-lg-4\"><h4>PROMEDIO</h4><h3>456</h3></div><div class=\"col-lg-4\"><h4>PORCENTAJE</h4><h3>100%</h3></div></div></div></div></div>");
$templateCache.put("app/reportes/detalledocumentomodal/detalle-documento-main.html","<div class=\"reporte-detalle-documento-wrapper\"><div class=\"row\"><div class=\"col-lg-12 col-sm-12 col-xs-12\"><h4>PROVEEDOR</h4><h2>{{$ctrl.documento.nombreProveedor}}</h2></div></div><div class=\"row\"><div class=\"col-lg-12 col-sm-12 col-xs-12\"><h4>ANALISTA</h4><h3>{{$ctrl.documento.analista}}</h3></div></div><div class=\"row\"><div class=\"col-lg-4 col-sm-6 col-xs-6\"><h4>RUT PROVEEDOR</h4><h3>{{$ctrl.documento.rut}}</h3></div><div class=\"col-lg-4 col-sm-6 col-xs-6\"><h4>FOLIO</h4><h3>{{$ctrl.documento.folio}}</h3></div><div class=\"col-lg-4 col-sm-6 col-xs-6 box-promedio-dias\" ng-class=\"{\'box-danger\': $ctrl.promedioDias >= 8 }\"><h4>PROMEDIO D&Iacute;AS</h4><h3>{{$ctrl.promedioDias}}</h3></div></div><div class=\"row\"><div class=\"col-lg-4 col-sm-6 col-xs-6\"><h4>N&Uacute;MERO DOCUMENTO</h4><h3>{{$ctrl.documento.numeroFactura}}</h3></div><div class=\"col-lg-4 col-sm-6 col-xs-6\"><h4>FECHA EMISI&Oacute;N</h4><h3>{{$ctrl.documento.fechaEmision | date:\'dd/MM/yyyy\'}}</h3></div><div class=\"col-lg-4 col-sm-6 col-xs-6\"><h4>FECHA RECEPCION</h4><h3>{{$ctrl.documento.fechaRecepcion | date:\'dd/MM/yyyy\'}}</h3></div></div><div class=\"row\"><div class=\"col-lg-4 col-sm-6 col-xs-6\"><h4>ESTADO</h4><h3>{{$ctrl.documento.estado}}</h3></div><div class=\"col-lg-4 col-sm-6 col-xs-6\" ng-if=\"$ctrl.documento.fechaContabilizacion != null\"><h4>FECHA CONTABILIZACI&Oacute;N</h4><h3>{{$ctrl.documento.fechaContabilizacion | date:\'dd/MM/yyyy\'}}</h3></div><div class=\"col-lg-4 col-sm-6 col-xs-6\"><h4>MONTO TOTAL</h4><h3>{{$ctrl.documento.montoTotal | currency:\'$\':0}}</h3></div></div><div class=\"row\"><div class=\"col-lg-6\" ng-if=\"$ctrl.documento.fechaPago != null\"><h4>FECHA PAGO</h4><h3>{{$ctrl.documento.fechaPago | date:\'dd/MM/yyyy\'}}</h3></div><div class=\"col-lg-6\" ng-if=\"$ctrl.documento.numeroOc != null\"><h4>N&Uacute;MERO OC</h4><h2>{{$ctrl.documento.numeroOc}}</h2></div></div></div>");
$templateCache.put("app/reportes/ciclovida/ciclo-vida-main.html","<style>\r\n    .ciclo-mes-consulta {\r\n        opacity: 1 !important;\r\n    }\r\n\r\n        .ciclo-mes-consulta.ng-hide-add {\r\n            animation: fadeOut 0.5s;\r\n        }\r\n\r\n        .ciclo-mes-consulta.ng-hide-remove {\r\n            animation: fadeIn 0.5s;\r\n        }\r\n</style><div class=\"row\" style=\"margin-bottom: 45px;\"><div class=\"col-lg-3 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">ANALISTA</label><select class=\"form-control input-sm\" ng-model=\"$ctrl.query.analista\" ng-options=\"analista for analista in $ctrl.analistasDocumentos\"><option value=\"\">TODOS LOS ANALISTAS</option></select></div></div><div class=\"col-lg-2 col-xs-6\"><div class=\"form-group\"><label class=\"control-label\">A&Ntilde;O</label><select class=\"form-control input-sm\" name=\"yearConsulta\" ng-model=\"$ctrl.query.year\" ng-options=\"year for year in $ctrl.yearsDocumentos\"></select></div></div><div class=\"col-lg-1 col-xs-6\"><div class=\"form-group cantidad-periodos-consulta\"><label for=\"cantidadPeriodosConsulta\">CANT.</label><select class=\"form-control input-sm\" name=\"cantidadPeriodosConsulta\" ng-model=\"$ctrl.query.cantidadPeriodos\" ng-options=\"cantidad for cantidad in [3, 6, 12]\" required=\"\"></select></div></div><div class=\"col-lg-2 col-xs-12\"><div class=\"form-group\"><label for=\"tipoPeriodoConsulta\">PER&Iacute;ODO</label><select class=\"form-control input-sm\" name=\"tipoPeriodoConsulta\" ng-model=\"$ctrl.query.tipoPeriodo\" ng-options=\"tipo for tipo in $ctrl.tiposPeriodoConsulta\" required=\"\"></select></div></div><div class=\"col-lg-2 col-xs-12\"><div class=\"form-group ciclo-mes-consulta\" ng-show=\"$ctrl.query.tipoPeriodo.toLowerCase() == \'mensual\'\"><label for=\"mesConsulta\">Mes</label><select class=\"form-control input-sm\" name=\"mesConsulta\" ng-model=\"$ctrl.query.mes\" ng-options=\"mes as mes.nombremes for mes in $ctrl.listadoMeses track by mes.numeromes\" required=\"\"></select></div></div><div class=\"col-lg-2 col-xs-12\"><div class=\"form-group\"><label for=\"botonEnviar\">.</label> <button type=\"button\" class=\"btn btn-block btn-sm btn-primary\" ng-click=\"$ctrl.getCicloVida()\"><i class=\"fa fa-line-chart\" aria-hidden=\"true\"></i> ENVIAR</button></div></div></div><div class=\"row box-dashboard box-margin-bot-35\" style=\"background-color: #fff; margin-bottom: 20px; padding: 25px; min-height: 85px;\" ng-if=\"$ctrl.muestraStandby\"><div class=\"col-lg-12\"><h2 class=\"text-center text-muted\"><i class=\"fa fa-cog fa-spin fa-fw\"></i> <span>Esperando consulta para generar reporte. <small>Ciclo Vida Documentos</small></span></h2></div></div><div class=\"row box-dashboard box-margin-bot-35\" ng-show=\"$ctrl.respuestaCiclo.length > 0\" style=\"background-color: #fff; margin-bottom: 20px; padding: 25px; min-height: 85px;\"><div class=\"col-lg-4\"><div class=\"littleheaders\"><span class=\"littlenumber\">{{$ctrl.resumenTodosCiclos.totalDocsPeriodo}}</span> <span class=\"littlenumber-descripcion\">TOTAL DOCS</span></div></div><div class=\"col-lg-2\"><div class=\"littleheaders\" style=\"color: #005e57;\"><span class=\"littlenumber\">{{$ctrl.resumenTodosCiclos.sumaContabilizados}}</span> <span class=\"littlenumber-descripcion\">CONTABILIZADOS</span></div></div><div class=\"col-lg-2\"><div class=\"littleheaders\" style=\"color: #005e57;\"><span class=\"littlenumber\">{{$ctrl.resumenTodosCiclos.porcentajeContabilizados}}</span> <span class=\"littlenumber-descripcion\">% CONTABILIZADOS</span></div></div><div class=\"col-lg-2\"><div class=\"littleheaders\" style=\"color: #e05314;\"><span class=\"littlenumber\">{{$ctrl.resumenTodosCiclos.sumaNoContabilizados}}</span> <span class=\"littlenumber-descripcion\">NO CONTABILIZADOS</span></div></div><div class=\"col-lg-2\"><div class=\"littleheaders\" style=\"color: #e05314;\"><span class=\"littlenumber\">{{$ctrl.resumenTodosCiclos.porcentajeNoContabilizados}}</span> <span class=\"littlenumber-descripcion\">PORCENTAJE</span></div></div></div><div class=\"row box-dashboard box-margin-bot-35\" ng-repeat=\"periodo in $ctrl.respuestaCiclo\" style=\"background-color: #fff; margin-bottom: 20px; padding: 25px;\"><div class=\"col-lg-4\"><div class=\"row\"><div class=\"col-lg-4\"><div class=\"mediumheaders\"><span class=\"mediumnumber\" style=\"color: #a3a3a3\">#{{$index + 1}}</span></div></div><div class=\"col-lg-8\"><div class=\"periodo-headers\"><span class=\"periodo\" style=\"color: #a3a3a3\">{{$ctrl.momento(periodo.inicioPeriodo).utc().format(\'D MMMM YYYY\')}}</span> <span class=\"periodo\" style=\"color: #a3a3a3\">{{$ctrl.momento(periodo.finPeriodo).utc().format(\'D MMMM YYYY\')}}</span></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"bigheaders\"><span class=\"bignumber\">{{periodo.cantidadDocumentosTotal}}</span> <span class=\"bignumber-descripcion\">TOTAL DOCS</span></div></div><div class=\"col-lg-12\" ng-if=\"periodo.totalMontoPagados != null || periodo.totalMontoPagados > 0\" style=\"margin-top: 2px;\"><div class=\"littleheaders\"><span class=\"littlenumber\">{{periodo.totalMontoPagados | currency : \'$\' : 0}}</span> <span class=\"littlenumber-descripcion\"><i class=\"fa fa-money\" aria-hidden=\"true\"></i> MONTO TOTAL PAGOS</span></div></div></div></div><div class=\"col-lg-8\"><div class=\"row fila-datos\"><div class=\"col-lg-12\"><h3 style=\"color:#005e57; text-align:center; padding-bottom:15px; border-bottom: 1px solid #005e57;\">CONTABILIZADOS</h3></div><div class=\"col-lg-4\"><div class=\"littleheaders\"><span class=\"littlenumber\">{{periodo.resumenContabilizados.cantidadDocumentos}}</span> <span class=\"littlenumber-descripcion\">CANTIDAD</span></div></div><div class=\"col-lg-4\"><div class=\"littleheaders\"><span class=\"littlenumber\">{{periodo.resumenContabilizados.promedioDias | number:2}}</span> <span class=\"littlenumber-descripcion\">PROMEDIO D&Iacute;AS</span></div></div><div class=\"col-lg-4\"><div class=\"littleheaders\"><span class=\"littlenumber\">{{$ctrl.calcularPorcentaje(periodo.resumenContabilizados.cantidadDocumentos, periodo.cantidadDocumentosTotal)}}</span> <span class=\"littlenumber-descripcion\">PORCENTAJE</span></div></div></div><div class=\"row fila-datos\" ng-if=\"periodo.esPeriodoActual == true\"><div class=\"col-lg-12\"><h5 style=\"color:#005e57; text-align:center; padding-bottom:15px; border-bottom: 1px solid #005e57;\">VARIACI&Oacute;N PROMEDIO D&Iacute;AS CONTABILIZADOS PER&Iacute;ODOS ANTERIORES</h5></div><div class=\"col-lg-2\" ng-repeat=\"res in $ctrl.variacionesPeriodosAnteriores.contabilizados track by $index\"><div class=\"miniheaders\"><span class=\"mininumber-descripcion\">#{{$index + 2}}</span> <span class=\"mininumber\" ng-class=\"{ \'text-success\': res < 0, \'text-danger\': res > 0 }\">{{res | number:1}}%</span></div></div></div><div class=\"row fila-datos\"><div class=\"col-lg-12\"><h3 style=\"color: #e05314; text-align:center; padding-bottom:15px; border-bottom: 1px solid #e05314;\">NO CONTABILIZADOS</h3></div><div class=\"col-lg-4\"><div class=\"littleheaders\"><span class=\"littlenumber\">{{periodo.resumenNoContabilizados.cantidadDocumentos}}</span> <span class=\"littlenumber-descripcion\">SIN CONTABILIZAR</span></div></div><div class=\"col-lg-4\"><div class=\"littleheaders\"><span class=\"littlenumber\">{{periodo.resumenNoContabilizados.promedioDias | number:2}}</span> <span class=\"littlenumber-descripcion\">SIN CONT. PROMEDIO DIAS</span></div></div><div class=\"col-lg-4\"><div class=\"littleheaders\"><span class=\"littlenumber\">{{$ctrl.calcularPorcentaje(periodo.resumenNoContabilizados.cantidadDocumentos, periodo.cantidadDocumentosTotal)}}</span> <span class=\"littlenumber-descripcion\">PORCENTAJE</span></div></div></div><div class=\"row fila-datos\" ng-if=\"periodo.esPeriodoActual == true\"><div class=\"col-lg-12\"><h5 style=\"color:#e05314; text-align:center; padding-bottom:15px; border-bottom: 1px solid #e05314;\">VARIACI&Oacute;N PROMEDIO D&Iacute;AS NO CONTABILIZADOS PER&Iacute;ODOS ANTERIORES</h5></div><div class=\"col-lg-2\" ng-repeat=\"res in $ctrl.variacionesPeriodosAnteriores.noContabilizados track by $index\"><div class=\"miniheaders\"><span class=\"mininumber-descripcion\">#{{$index + 2}}</span> <span class=\"mininumber\" ng-class=\"{ \'text-success\': res < 0, \'text-danger\': res > 0 }\">{{res | number:1}}%</span></div></div></div></div><div class=\"col-lg-12 col-sm-12\" style=\"margin-top: 25px;\"><v-accordion class=\"vAccordion--default\" multiple=\"\" ng-show=\"periodo.topContabilizados.length != 0 || periodo.topNoContabilizados.length != 0 || periodo.topPagados.length != 0\"><v-pane ng-show=\"periodo.topContabilizados.length != 0\"><v-pane-header><h5>RECIBIDOS EN PERIODO CONTABILIZADOS SOBRE KPI</h5></v-pane-header><v-pane-content><ciclo-vida-grid-component table-data=\"periodo.topContabilizados\" campo-promedio=\"diferenciaDiasContabilizacion\"></ciclo-vida-grid-component></v-pane-content></v-pane><v-pane ng-show=\"periodo.topNoContabilizados.length != 0\"><v-pane-header><h5>RECIBIDOS EN PERIODO NO CONTABILIZADOS</h5></v-pane-header><v-pane-content><ciclo-vida-grid-component table-data=\"periodo.topNoContabilizados\" campo-promedio=\"diferenciaDiasRecepcion\"></ciclo-vida-grid-component></v-pane-content></v-pane><v-pane ng-show=\"periodo.topPagados.length != 0\"><v-pane-header><h5>DOCUMENTOS PAGADOS RECIBIDOS PERIODO</h5></v-pane-header><v-pane-content><ciclo-vida-grid-component table-data=\"periodo.topPagados\" campo-promedio=\"diferenciaDiasPago\"></ciclo-vida-grid-component></v-pane-content></v-pane></v-accordion></div></div>");
$templateCache.put("app/reportes/ciclovida/detalle-documento.modal.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" aria-label=\"CERRAR\" ng-click=\"vm.closeModal()\" style=\"margin-top: 5px;\"><span aria-hidden=\"true\">&times;</span></button> <img src=\"assets/images/metso.png\" class=\"pull-left\" style=\"padding-top: 3px;\"><h3 class=\"modal-title\" style=\"float: left; margin-left: 15px;\">Detalle Documento</h3></div><div class=\"modal-body modal-body-detalle\"><detalle-documento-modal-component documentoid=\"vm.documentoID\" promedio-dias=\"vm.promedio\"></detalle-documento-modal-component></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"vm.closeModal()\">CERRAR DETALLE</button></div>");
$templateCache.put("app/reportes/tickets/detalleticketmodal/detalle-ticket-main.html","<div class=\"reporte-detalle-documento-wrapper\"><div class=\"row\"><div class=\"col-lg-12 col-sm-12 col-xs-12\"><h4>PROVEEDOR</h4><h2>{{$ctrl.ticketData.nombreProvedor}}</h2></div></div><div class=\"row\"><div class=\"col-lg-8 col-sm-12 col-xs-12\"><h4>ANALISTA</h4><h3>{{$ctrl.ticketData.encargado}}</h3></div><div class=\"col-lg-4 col-sm-12 col-xs-12\"><h4>FECHA INGRESO</h4><h3>{{$ctrl.ticketData.fechaIngreso | date:\"dd/MM/yyyy HH:mm\"}}</h3></div></div><div class=\"row\"><div class=\"col-lg-12 col-sm-12 col-xs-12\"><h4>AUTOR TICKET</h4><h3>{{$ctrl.ticketData.emailAutor}}</h3></div></div><div class=\"row\"><div class=\"col-lg-4 col-sm-6 col-xs-6 box-promedio-dias box-danger\"><h4>ESTADO TICKET</h4><h3>{{$ctrl.ticketData.ticketEstado}}</h3></div><div class=\"col-lg-4 col-sm-6 col-xs-6\"><h4>RUT PROVEEDOR</h4><h3>{{$ctrl.ticketData.rutProveedor}}</h3></div></div><div class=\"row\"><div class=\"col-lg-4 col-sm-6 col-xs-6\"><h4>NUMERO FACTURA</h4><h3>{{$ctrl.ticketData.numeroFactura}}</h3></div><div class=\"col-lg-4 col-sm-6 col-xs-6\"><h4>ESTADO FACTURA</h4><h3>{{$ctrl.ticketData.facturaEstado}}</h3></div><div class=\"col-lg-4 col-sm-6 col-xs-6\"><h4>DESDE FORMULARIO</h4><div ng-switch=\"$ctrl.ticketData.desdeFormularioContacto\"><h3 ng-switch-when=\"true\">S&iacute;</h3><h3 ng-switch-when=\"false\">No</h3><h3 ng-switch-default=\"\">Sin Info</h3></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-sm-12 col-xs-12\" ng-show=\"$ctrl.ticketData.asunto != null || $ctrl.ticketData.asunto.length > 0\"><h4>Asunto</h4><h3>{{$ctrl.ticketData.asunto}}</h3></div><div class=\"col-lg-12 col-sm-12 col-xs-12\"><h4>Mensaje</h4><h3>{{$ctrl.ticketData.mensaje}}</h3></div></div></div>");
$templateCache.put("app/reportes/tickets/ticketsrespuesta/detalle-ticket.modal.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" aria-label=\"CERRAR\" ng-click=\"vm.closeModal()\" style=\"margin-top: 5px;\"><span aria-hidden=\"true\">&times;</span></button> <img src=\"assets/images/metso.png\" class=\"pull-left\" style=\"padding-top: 3px;\"><h3 class=\"modal-title\" style=\"float: left; margin-left: 15px;\">Detalle Ticket</h3></div><div class=\"modal-body modal-body-detalle\"><detalle-ticket-modal-component ticket-data=\"vm.ticket\"></detalle-ticket-modal-component></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"vm.closeModal()\">CERRAR DETALLE</button></div>");
$templateCache.put("app/reportes/tickets/ticketsrespuesta/tickets-respuesta-grid.html","<table class=\"table\"><thead><tr><th class=\"text-center\">Nombre Proveedor</th><th class=\"text-center\">Rut Proveedor</th><th class=\"text-center\">Responsable</th><th class=\"text-center\">Fecha Ingreso</th><th class=\"text-center\">Detalles</th></tr></thead><tbody><tr ng-repeat=\"$ticket in $ctrl.tableData track by $ticket.ticketID\"><th class=\"text-center\">{{$ticket.nombreProvedor}}</th><th class=\"text-center\">{{$ticket.rutProveedor}}</th><th class=\"text-center\">{{$ticket.encargado}}</th><td class=\"text-center\">{{$ticket.fechaIngreso | date:\"dd/MM/yyyy HH:mm\"}}</td><td class=\"text-center\"><a href=\"\" ng-click=\"$ctrl.openDetalleTicketModal($ticket)\">VER DETALLES <i class=\"fa fa-eye\"></i></a></td></tr></tbody></table>");
$templateCache.put("app/reportes/tickets/ticketsrespuesta/tickets-respuesta.html","<div class=\"row\" style=\"margin-bottom: 45px;\"><form class=\"form\" novalidate=\"\"><div class=\"col-lg-3 col-xs-8\"><div class=\"form-group\"><label>PERIODO</label><select class=\"form-control input-sm\" name=\"periodoTicketConsulta\" ng-model=\"$ctrl.query\" ng-options=\"periodo as periodo.nombrePeriodo for periodo in $ctrl.periodos\"></select></div></div><div class=\"col-lg-2 col-xs-4\"><label for=\"botonEnviar\">.</label> <button type=\"button\" class=\"btn btn-sm btn-block btn-primary\" ng-click=\"$ctrl.getTicketsPerformance()\"><i class=\"fa fa-bar-chart\" aria-hidden=\"true\"></i> ENVIAR</button></div></form></div><div class=\"row box-dashboard box-margin-bot-35\" style=\"background-color: #fff; margin-bottom: 20px; padding: 25px; min-height: 85px;\" ng-if=\"$ctrl.muestraStandby\"><div class=\"col-lg-12\"><h2 class=\"text-center text-muted\"><i class=\"fa fa-cog fa-spin fa-fw\"></i> <span>Esperando consulta para generar reporte. <small>Tickets vs. Respuesta</small></span></h2></div></div><div class=\"row box-dashboard box-margin-bot-35\" ng-show=\"$ctrl.barData.data.length > 0\" style=\"background-color: #fff; margin-bottom: 20px; padding: 25px; min-height: 85px;\"><div class=\"col-lg-3\"><div class=\"littleheaders\"><span class=\"littlenumber\">{{$ctrl.resumenConsulta.totalTickets}}</span> <span class=\"littlenumber-descripcion\">TICKETS PER&Iacute;ODO</span></div></div><div class=\"col-lg-3\"><div class=\"littleheaders\"><span class=\"littlenumber\">{{$ctrl.resumenConsulta.totalCantidadAnalistas}}</span> <span class=\"littlenumber-descripcion\">ANALISTAS</span></div></div><div class=\"col-lg-3\"><div class=\"littleheaders\" style=\"color: #005e57;\"><span class=\"littlenumber\">{{$ctrl.resumenConsulta.totalTicketsCerrados}}</span> <span class=\"littlenumber-descripcion\">CERRADOS</span></div></div><div class=\"col-lg-3\"><div class=\"littleheaders\" style=\"color: #e05314;\"><span class=\"littlenumber\">{{$ctrl.resumenConsulta.totalTicketsAbiertos}}</span> <span class=\"littlenumber-descripcion\">ABIERTOS</span></div></div></div><div class=\"row box-dashboard box-margin-bot-35\" style=\"background-color: #fff; margin-bottom: 20px; padding: 25px;\" ng-show=\"$ctrl.barData.data.length >0\"><div class=\"col-lg-12\"><canvas height=\"130\" class=\"chart chart-bar\" chart-data=\"$ctrl.barData.data\" chart-dataset-override=\"$ctrl.datosSet\" chart-labels=\"$ctrl.barData.etiquetas\" chart-options=\"$ctrl.graficoOpciones\"></canvas></div><div class=\"col-lg-12 col-sm-12\" style=\"margin-top: 25px;\" ng-show=\"$ctrl.listadoAbiertos.length > 0\"><v-accordion class=\"vAccordion--default\" multiple=\"\"><v-pane expanded=\"\"><v-pane-header><h5>TICKETS ABIERTOS</h5></v-pane-header><v-pane-content><tickets-respuesta-grid-component table-data=\"$ctrl.listadoAbiertos\"></tickets-respuesta-grid-component></v-pane-content></v-pane></v-accordion></div></div>");}]);